const bloxFrenchSubscriptionMessages = {
  label: 'Abonnement',
  subscriptions: 'Abonnements',
  new_subscription: 'Nouvel abonnement',
  rate: {
    label: 'Tarif',
  },
  nextRate: 'Prochain tarif',
  termExpires: 'Échéance du terme',
  termExpired: 'Terme expiré',
  expireTime: {
    label: "Date d'expiration",
    edit: "Modifier la date d'expiration",
    success: "Date d'expiration mise à jour.",
    error: 'Erreur de mise à jour: {{error}}',
    noDateSelected: "Aucune date n'a été sélectionnée.",
    invalidDate:
      "La date sélectionnée n'est pas valide. Veuillez actualiser et réessayer.",
    formatError: "Impossible de formater la date d'expiration.",
  },
  nextRetryDate: 'Prochaine date de tentative',
  nextRenewalDate: 'Prochaine date de renouvellement',
  graceEnds: 'Fin de la période de grâce',
  autorenews: {
    label: 'Renouvellement automatique',
    success: 'Renouvellement automatique mis à jour',
    error: 'Erreur lors de la mise à jour du renouvellement automatique',
  },
  startDate: "Début de l'abonnement",
  every: 'tous les',
  for: 'pour',
  fields: {
    account: 'Compte',
    productId: 'ID du produit',
    subscriptionId: "ID de l'abonnement",
    edition: 'Édition',
  },
  managedOnOriginatingSite: "Ce type d'abonnement peut être géré sur le site d'origine.",
  actions: {
    change_rate: 'Changer de tarif',
    cancel_subscription: "Annuler l'abonnement",
  },
  change_rate_wizard: {
    title: "Modifier le tarif de l'abonnement",
    steps: {
      offers: 'Offres',
      payment: 'Paiement',
      review: 'Révision',
      confirmation: 'Confirmation',
    },
    alerts: {
      subscription_error:
        "Erreur lors du chargement des données de l'abonnement. Veuillez réessayer plus tard.",
      missing_data:
        "Aucune donnée d'abonnement ou d'utilisateur disponible. Vérifiez les identifiants et réessayez.",
    },
    fallbacks: {
      unnamed_subscriber: 'Abonné sans nom',
    },
    buttons: {
      processing: 'Traitement...',
      confirm_change: 'Confirmer la modification',
      close: 'Fermer',
      next: 'Suivant',
    },
    notifications: {
      change_success: "Tarif de l'abonnement modifié avec succès",
      change_warning: 'Modification du tarif terminée (réponse : {{status}})',
      change_error:
        "Erreur lors de la modification du tarif de l'abonnement : {{message}}",
      user_error: "Erreur lors du chargement des données de l'utilisateur : {{message}}",
      subscription_error:
        "Erreur lors du chargement des données de l'abonnement : {{message}}",
    },
    labels: {
      unknown_status: 'inconnu',
    },
    review: {
      taxQuoteWarning:
        'Estimation de la taxe indisponible. La taxe sera calculée au moment du paiement et peut ne pas être reflétée dans le total affiché.',
      taxUnavailable: 'Indisponible',
    },
  },
  loading: {
    rateDetails: 'Chargement des détails du tarif...',
  },
  error: {
    fetchingRateDetails: 'Erreur lors de la récupération des détails du tarif.',
  },
  transactions: {
    label: 'Transactions',
    history: 'Historique',
    loading: 'Chargement des transactions...',
    loadMore: 'Charger plus',
    transactionDate: 'Date de transaction',
    error: {
      fetching: 'Erreur lors de la récupération des transactions.',
    },
    refund: {
      success: 'Remboursement réussi !',
      error: 'Erreur de remboursement : {{error}}',
      confirmPrompt:
        'Êtes-vous sûr de vouloir rembourser le montant total de cette transaction ?',
      processing: 'Traitement du remboursement...',
      confirmButton: 'Rembourser {{amount}} {{emoji}}',
      completed: 'Remboursé',
      issueButton: 'Effectuer un remboursement',
    },
    refundId: 'ID de remboursement',
    addressLine1: 'Adresse ligne 1',
    addressLine2: 'Adresse ligne 2',
    amount: 'Montant',
    duration: 'Durée',
    durationDays: '{{days}} jours',
    taxAmount: 'Montant de la taxe',
    taxRegion: 'Région fiscale',
    taxRate: "Taux d'imposition",
    id: 'ID de transaction',
    filters: {
      title: 'Filtrer les transactions',
      transactionId: 'ID de transaction',
      userUuid: 'UUID utilisateur',
      externalId: 'ID externe',
      product: 'Produit',
      serviceName: 'Nom du service',
      formName: 'Nom du formulaire',
      transactionState: {
        label: 'État de la transaction',
        all: 'Tous les états',
        succeeded: 'Réussie',
        failed: 'Échouée',
        gateway_processing_failed: 'Échec du traitement',
        gateway_processing_result_unknown: 'Statut de passerelle inconnu',
      },
      transactionType: {
        label: 'Type de transaction',
        all: 'Tous les types',
        purchase: 'Achat',
        authorization: 'Autorisation',
        capture: 'Capture',
        credit: 'Crédit',
        refund: 'Remboursement',
        void: 'Annulation',
        replace_payment_method: 'Remplacer le moyen de paiement',
        invalid_replace_payment_method: 'Remplacement invalide',
        contact_card_holder: 'Contacter le titulaire',
        close_payment_method: 'Fermer le moyen de paiement',
      },
      application: {
        label: 'Application',
        all: 'Toutes les applications',
        subscriptions: 'Abonnements',
        forms: 'Formulaires',
        adowl: 'AdOwl',
        classifieds: 'Petites annonces',
      },
      testStatus: {
        label: 'Statut de test',
        all: 'Tous',
        test: 'Test',
        live: 'Production',
      },
      paymentHandler: {
        label: 'Gestionnaire de paiement',
        all: 'Tous les gestionnaires',
        payflow_pro: 'Payflow Pro',
        elavon_authorize: 'Elavon Authorize',
        paypal: 'PayPal',
        adyen: 'Adyen',
        other: 'Autre',
      },
      paymentType: {
        label: 'Type de paiement',
        all: 'Tous les types',
        purchase: 'Achat',
        authorization: 'Autorisation',
        capture: 'Capture',
        credit: 'Crédit',
        refund: 'Remboursement',
        void: 'Annulation',
        replace_payment_method: 'Remplacer le moyen de paiement',
        invalid_replace_payment_method: 'Remplacement invalide',
        contact_card_holder: 'Contacter le titulaire',
        close_payment_method: 'Fermer le moyen de paiement',
      },
      subscriptionService: {
        label: "Service d'abonnement",
        all: 'Tous les services',
        digital_access: 'Accès numérique',
        print_delivery: 'Livraison papier',
      },
      citMit: {
        label: 'CIT / MIT',
        all: 'Tous',
        cit: 'CIT',
        mit: 'MIT',
      },
      initiatedBy: {
        label: 'Initiée par',
        all: 'Tous',
        customer: 'Client',
        admin: 'Administrateur NXT',
        system: 'Système',
      },
      lifecycle: {
        label: "Cycle d'abonnement",
        all: 'Tous',
        renewal: 'Renouvellement',
        new_start: 'Nouveau départ',
      },
      dateFrom: 'Date de transaction à partir de',
      dateTo: 'Date de transaction jusqu’à',
      transactionDate: 'Plage de dates de transaction',
    },
    table: {
      date: 'Date / heure',
      customer: 'Nom du client',
      type: 'Type',
      amount: 'Montant',
      state: 'Statut',
      paymentHandler: 'Gestionnaire de paiement',
      email: 'E-mail',
      application: 'Application',
      test: 'Test',
      stateValues: {
        succeeded: 'Réussie',
        failed: 'Échouée',
        gateway_processing_failed: 'Échec du traitement',
        gateway_processing_result_unknown: 'Statut de passerelle inconnu',
      },
    },
    search: {
      placeholder: 'Rechercher des transactions...',
    },
    breadcrumbs: {
      backToSearch: 'Retour aux résultats de recherche',
      search: 'Recherche de transactions',
    },
    detail: {
      untitled: 'Détails de la transaction',
      customer: 'Client',
      customerName: 'Nom du client',
      email: 'E-mail',
      phone: 'Téléphone',
      openCustomerProfile: 'Ouvrir le profil du client',
      addresses: {
        billing: 'Adresse de facturation',
        shipping: 'Adresse de livraison',
      },
      transaction: 'Détails de la transaction',
      message: 'Message',
      error: 'Erreur',
      paymentHandler: 'Gestionnaire de paiement',
      transactionId: 'ID de transaction',
      description: 'Description',
      overviewTitle: 'Aperçu de la transaction',
      totalAmount: 'Montant total',
      date: 'Date',
      latestActivity: 'Dernière activité',
      paymentMethodTitle: 'Mode de paiement',
      viewCard: 'Voir la carte',
      unknownProcessor: 'Processeur inconnu',
      paymentUnavailable: 'Détails du paiement indisponibles.',
      statusUpdate: 'Mise à jour du statut',
      testTransaction: 'Transaction de test',
      liveTransaction: 'Transaction en direct',
      testModeLabel: 'Mode',
      gatewayDetails: 'Détails de la passerelle',
      metadata: 'Métadonnées',
      processedBy: 'Traité par',
      userWidgetTitle: 'Utilisateur',
      user: {
        loadError: "Impossible de charger les informations de l'utilisateur.",
        noUser: "Aucun utilisateur n'est associé à cette transaction.",
      },
      errors: {
        notFound: 'Transaction introuvable',
        missingId: 'Identifiant de transaction manquant',
        missingUserId: 'Identifiant utilisateur manquant',
        missingPaymentIdentifiers: 'Identifiants de paiement manquants',
      },
      fields: {
        state: 'État',
        paymentToken: 'Jeton de paiement',
        avsResponse: 'Réponse AVS',
        cvvResponse: 'Réponse CVV',
        spreedlyToken: 'Jeton Spreedly',
        ipAddress: 'Adresse IP',
        rateName: 'Nom du tarif',
        recurring: 'Récurrent',
      },
      recurring: {
        yes: 'Oui',
        no: 'Non',
      },
    },
  },
  paymentMethod: {
    label: 'Moyen de paiement',
    changeButton: 'Modifier le moyen de paiement',
    expiredWarning: 'Cette carte est expirée et doit être mise à jour.',
    selectTitle: 'Sélectionner un moyen de paiement',
    noMethodAvailable: 'Aucun moyen de paiement disponible.',
    preferred: 'Préféré',
    expired: 'Expiré',
    expires: 'Expire',
    addCard: 'Ajouter une carte',
    addNewCard: 'Ajouter une nouvelle carte',
    addCardCaption: 'Ou ajouter une carte',
    failedToLoad:
      "Nous n'avons pas pu charger vos moyens de paiement. Veuillez réessayer.",
    noValidPaymentMethods: 'Aucun moyen de paiement valide trouvé pour ce compte.',
    new_card_success: 'Nouvelle carte ajoutée avec succès',
    removeError: 'Échec de la suppression du moyen de paiement',
    updateError: 'Échec de la mise à jour du moyen de paiement',
    notAvailable: 'N/D',
    details: {
      title: 'Détails du paiement',
      cardholder: 'Titulaire de la carte',
      name: 'Nom',
      expiration: 'Expiration',
      billingAddress: 'Adresse de facturation',
      street: 'Rue',
      cityStateZip: 'Ville / Région / Code postal',
      country: 'Pays',
      activity: 'Activité',
      created: 'Créé',
      lastUpdated: 'Dernière mise à jour',
      addedVia: 'Ajouté via {{wallet}}',
      paypalAccount: 'Compte PayPal',
      wallet: 'Portefeuille',
      unknownCard: 'Carte inconnue',
    },
  },
  detail: {
    loading: "Chargement des détails de l'abonnement...",
  },
  ltv: {
    defaultName: 'Ce client',
    tooltipText:
      'La valeur à vie (LTV) est la somme des paiements de ce client tout au long de la durée de ses abonnements et de toute autre transaction via BLOX.',
    label: 'LTV du client :',
    shortLabel: 'LTV :',
    hasContributed: 'a contribué {{amount}}',
    hasNotContributed: "n'a pas contribué",
    since: ' depuis {{startdate}}',
  },
  search: {
    new_starts: 'Nouveaux Départs',
    new_starts_info: 'Actifs et commencés au cours des 30 derniers jours',
    stops: 'Arrêts',
    stops_info: 'Annulés au cours des 30 derniers jours',
  },
  rate_modal: {
    title: {
      add: 'Ajouter un tarif',
      edit: 'Modifier le tarif',
    },
    actions: {
      save: 'Enregistrer',
      saving: 'Enregistrement...',
      cancel: 'Annuler',
    },
    sections: {
      general: 'Général',
      lifecycle: 'Cycle de vie',
      transition: 'Paramètres de transition',
      additional_settings: 'Paramètres supplémentaires',
      preview: 'Aperçu',
    },
    messages: {
      failed_to_save: "Échec de l'enregistrement du tarif",
      fix_validation_errors: 'Veuillez corriger les erreurs de validation ci-dessous.',
    },
    service_warnings: {
      disabled:
        "Ce service est désactivé, les utilisateurs ne peuvent donc pas acheter ce tarif tant que le service n'est pas activé.",
      hidden:
        "Ce service est masqué, les utilisateurs ne peuvent donc pas acheter ce tarif tant que le service n'est pas activé.",
      test: "Ce service est en mode test, ce tarif ne peut donc être acheté qu'avec des cartes de test.",
    },
    promo_code_validation: {
      empty: 'Le code promo ne peut pas être vide',
      max_length: 'Le code promo ne peut pas dépasser 50 caractères',
      invalid_format:
        'Le code promo ne peut contenir que des lettres, des chiffres, des tirets et des traits de soulignement',
      duplicate: 'Ce code promo existe déjà',
    },
    fields: {
      name: {
        label: 'Nom du tarif',
        validation: {
          required: 'Le nom du tarif est requis',
          max_length: 'Le nom du tarif ne peut pas dépasser 40 caractères',
        },
        description:
          "Ce nom apparaîtra dans la recherche d'administration et sur les e-mails des clients (40 caractères max)",
      },
      price: {
        label: 'Prix',
        placeholder: '0,00',
        validation: {
          required: 'Le prix est requis',
          valid_price: 'Veuillez entrer un prix valide',
          greater_than_zero: 'Le prix doit être supérieur à 0,00 $',
          max_amount: 'Le prix ne peut pas dépasser 999 999,99 $',
        },
        help: {
          format: 'Entrez le montant en dollars (par exemple, 4,50 pour 4,50 $)',
          editing_disabled:
            "Le prix ne peut pas être modifié après l'enregistrement initial",
        },
      },
      duration: {
        label: 'Durée (jours)',
        validation: {
          required: 'Une durée valide est requise',
          valid_number: 'Veuillez entrer un nombre de jours valide supérieur à 0',
        },
        help: {
          format: 'Durée en jours (par exemple, 28)',
          editing_disabled:
            "La durée ne peut pas être modifiée après l'enregistrement initial",
        },
      },
      terms: {
        label: 'Conditions',
        description: 'Conditions légales pour ce tarif',
      },
      start_date: {
        label: 'Date et heure de début',
        description: 'Quand le tarif devient disponible (par défaut maintenant)',
      },
      always_available: {
        label: 'Le tarif est toujours disponible',
      },
      end_date: {
        label: 'Le tarif se termine le',
        description: "Quand le tarif cesse d'être disponible",
      },
      hide_date: {
        label: "Disponible jusqu'au",
        description: 'Dernière date et heure où le tarif peut être acheté',
      },
      enable_rate_changes: {
        label: 'Activer les changements de tarif',
      },
      end_cycles: {
        label: 'Total des transactions',
        validation: {
          required: 'Le total des transactions est requis',
          valid_number: 'Veuillez entrer un nombre de transactions valide supérieur à 0',
        },
        description: 'Nombre de fois que ce tarif sera facturé avant la transition',
      },
      end_id: {
        label: 'Suivi par',
        validation: {
          required: 'Vous devez sélectionner un tarif de suivi',
        },
        placeholder: {
          loading: 'Chargement des tarifs...',
          search: 'Rechercher et sélectionner un tarif...',
        },
        help: {
          loading: 'Chargement des tarifs disponibles...',
          choose: 'Choisir parmi {{count}} tarifs actifs',
        },
        no_options: {
          loading: 'Chargement des tarifs...',
          no_rates: 'Aucun tarif actif disponible',
          no_match: 'Aucun tarif ne correspond à votre recherche',
        },
      },
      save_rate: {
        label: "Tarif de sauvegarde pour l'annulation",
        description:
          'Faire de ce tarif un "Tarif de sauvegarde" pour les offres de rétention lors des annulations',
      },
      hidden: {
        label: 'Masquer le tarif du site web',
        description:
          'Ce tarif ne sera utilisé que pour les transactions de renouvellement automatique',
        warning:
          'Masquer ce tarif ne permettra pas aux utilisateurs de l\'acheter sur le site web. Ce tarif ne peut être utilisé que pour les transactions de renouvellement automatique. Pour permettre aux utilisateurs de l\'acheter, désactivez "Masquer le tarif".',
      },
      external_id: {
        label: 'ID externe',
        description:
          "Identifiant optionnel pour l'intégration avec des systèmes externes",
        placeholder: "Entrez l'identifiant externe (optionnel)",
        validation: {
          max_length: "L'ID externe ne peut pas dépasser 100 caractères",
        },
      },
      promo_needs_code: {
        label: 'Exiger un code promo',
        description:
          'Les utilisateurs doivent entrer un code promo pour accéder à ce tarif',
      },
      promo_codes: {
        label: 'Codes promo',
        placeholder: 'Entrez les codes promo (par exemple, SAVE20, WELCOME)',
        validation: {
          required_when_enabled:
            'Au moins un code promo est requis lorsque "Exiger un code promo" est activé',
        },
        help: {
          mobile:
            'Appuyez sur Entrée pour ajouter des codes. Appuyez sur les puces pour les supprimer.',
          desktop:
            'Appuyez sur Entrée ou virgule pour ajouter des codes promo. Utilisez Retour arrière pour supprimer le dernier code.',
          validation_rules:
            'Les codes promo sont automatiquement convertis en majuscules et ne peuvent contenir que des lettres, des chiffres, des tirets et des traits de soulignement. Maximum 50 caractères chacun.',
        },
        warning: {
          required_but_empty:
            'Vous avez activé "Exiger un code promo" mais n\'avez ajouté aucun code promo. Les utilisateurs ne pourront pas accéder à ce tarif tant que vous n\'ajouterez pas au moins un code promo.',
        },
      },
    },
    transition: {
      for: 'pour',
      days: 'jours',
      save_rate_chip: 'TARIF SAUVEGARDE',
      ends: 'SE TERMINE',
    },
    preview: {
      title: 'Aperçu du tarif',
      new_rate: 'Nouveau tarif',
      for: 'pour',
      days: 'jours',
      charged: 'Facturé',
      time: 'fois',
      times: 'fois',
      then: 'puis',
      auto_renews_indefinitely: 'Puis se renouvellement automatiquement indéfiniment',
      expires_without_auto_renewal: 'Puis expire sans renouvellement automatique',
      terms: 'Conditions',
      promo_codes: 'Codes promo',
      required: 'Requis',
      blox_rate_id: 'ID du tarif BLOX',
      external_id: 'ID externe',
      will_be_generated: "Sera généré lors de l'enregistrement",
      copy_blox_rate_id: "Copier l'ID du tarif BLOX",
      blox_rate_id_copied: 'ID du tarif BLOX copié !',
      copy_external_id: "Copier l'ID externe",
      external_id_copied: 'ID externe copié !',
    },
  },
  deliveryPhone: 'Téléphone de livraison',
  deliveryAddress: {
    label: 'Adresse de livraison',
    edit: "Modifier l'adresse de livraison",
    editTitle: "Modifier l'adresse de livraison",
    line1: "Ligne d'adresse 1",
    line2: "Ligne d'adresse 2",
    city: 'Ville',
    state: 'État/Région',
    country: 'Pays',
    zip: 'Code postal',
    phone: 'Numéro de téléphone',
    phoneHelperText: 'Veuillez entrer un numéro de téléphone valide à 10 chiffres',
    requiredFields: 'Veuillez remplir tous les champs obligatoires',
    invalidPhone: 'Veuillez entrer un numéro de téléphone valide',
    updateSuccess: 'Adresse de livraison mise à jour avec succès',
    updateError: "Échec de la mise à jour de l'adresse de livraison : {error}",
  },
  new_sub_wizard: {
    title: 'Démarrer un nouvel abonnement',
    steps: {
      userDetails: 'Informations utilisateur',
      packageSelection: 'Sélection du forfait',
      paymentDetails: 'Détails de paiement',
      reviewPurchase: 'Vérifier et acheter',
      confirmation: 'Confirmation',
    },
    buttons: {
      processing: 'Traitement en cours...',
      createUserAndContinue: "Créer l'utilisateur et continuer",
      purchase: 'Acheter',
      returnToReview: 'Retour à la vérification',
      next: 'Suivant',
      closeWizard: "Fermer l'assistant",
    },
    notifications: {
      userCreated: 'Nouveau compte utilisateur créé avec succès',
      subscriptionCreated: 'Abonnement créé avec succès',
      passwordResetSent:
        'Utilisateur créé et e-mail de réinitialisation du mot de passe envoyé avec succès',
      passwordResetError:
        "Erreur lors de l'envoi de l'e-mail de réinitialisation du mot de passe : {{message}}",
      subscriptionError: "Erreur lors de la création de l'abonnement : {{message}}",
      fetchUserError:
        'Erreur lors de la récupération des données utilisateur : {{message}}',
    },
    errors: {
      missingData: "Données requises manquantes pour l'achat",
    },
    review: {
      title: 'Vérifier et acheter',
      confirmationEmail: 'Un e-mail de confirmation sera envoyé à :',
      cards: {
        userInformation: 'Informations utilisateur',
        subscription: 'Abonnement',
        paymentAndSubscription: 'Paiement et abonnement',
      },
      labels: {
        name: 'Nom',
        email: 'E-mail',
        phone: 'Téléphone',
        primaryAddress: 'Adresse principale',
        service: 'Service',
        freeServiceFallback: 'Service gratuit',
        deliveryAddress: 'Adresse de livraison',
        deliveryRequired: 'Une adresse de livraison est requise pour ce service.',
        cost: 'Coût',
        freeServiceCost: 'Aucun paiement requis (service gratuit)',
        billingAddress: 'Adresse de facturation',
        plan: 'Forfait',
        pricing: 'Tarification',
        subtotal: 'Sous-total',
        tax: 'Taxe',
        total: 'Total',
      },
      editMenu: {
        editPayment: 'Modifier le paiement',
        editSubscription: "Modifier l'abonnement",
      },
      errors: {
        missingInfo: 'Informations requises manquantes pour la vérification.',
        missingRate: 'Tarif requis manquant pour un service payant.',
        missingPaymentMethod:
          'Méthode de paiement requise manquante pour un service payant.',
        taxQuoteWarning:
          'Estimation de la taxe indisponible. La taxe sera calculée au moment du paiement et peut ne pas être reflétée dans le total affiché.',
        taxUnavailable: 'Indisponible',
      },
    },
  },
  cancel_wizard: {
    title: "Annuler l'abonnement",
    steps: {
      reason: 'Motif',
      offers: 'Offres',
      review: 'Vérification',
      confirmation: 'Confirmation',
    },
    buttons: {
      processing: 'Traitement en cours...',
      continue_to_cancel: "Non, continuer l'annulation",
      confirm_rate_change: 'Confirmer le changement de tarif',
      confirm_cancel: "Confirmer l'annulation",
      accept_offer: "Oui, accepter l'offre",
      select_rate_placeholder: 'Veuillez sélectionner un tarif...',
    },
    notifications: {
      cancel_success: 'Abonnement annulé',
      update_success: 'Abonnement mis à jour',
    },
    alerts: {
      expire_warning: "L'abonnement de {{name}} expirera le",
      loading_error:
        'Erreur lors du chargement des données. Veuillez réessayer plus tard.',
    },
    cancel_reasons: {
      title: 'Pourquoi souhaitez-vous annuler ?',
      select_reason: 'Sélectionnez un motif',
      notes_label: 'Notes',
      notes_helper: '{{count}}/200 caractères',
      error_fetching: "Erreur lors de la récupération des motifs d'annulation.",
      benefits_lost: "Après cette date, l'accès à ces avantages sera perdu :",
    },
    errors: {
      fetching_benefits: 'Erreur lors de la récupération des détails des avantages.',
    },
    save_offers: {
      title: 'Pouvons-nous vous offrir un prix spécial pour rester ?',
      current_rate: 'Le tarif actuel de {{name}} est {{price}} / {{duration}}',
      show_hidden_rates: 'Afficher les tarifs masqués',
      save_offers_only: 'Offres de rétention uniquement',
      will_pay: 'paiera',
      same_amount: 'le même montant.',
      select_rate_prompt: 'Veuillez sélectionner un tarif à comparer.',
      save_offer_chip: 'Offre de rétention',
      no_results: 'Aucun résultat trouvé.',
      showing_results: 'Affichage de {{shown}} sur {{total}} résultats au total.',
      error_fetching_rates: 'Erreur lors de la récupération des tarifs de comparaison.',
      no_other_rates: "Aucun autre tarif n'est disponible.",
      rates_label: 'Tarifs',
      compare: {
        daily: 'Quotidien',
        monthly: 'Mensuel',
        yearly: 'Annuel',
        less: 'moins',
        more: 'plus',
      },
    },
    review: {
      title: 'Vérifier et confirmer les modifications',
      changing_rate: '{{name}} passe à un nouveau tarif.',
      new_rate_begins: 'Le nouveau tarif commence le {{date}}',
      card_will_be_charged: 'La carte enregistrée sera débitée de {{amount}}',
      terms_prefix: 'Conditions :',
      benefits_lost: "Après cette date, l'accès à ces avantages sera perdu :",
      error_fetching_benefits:
        'Erreur lors de la récupération des détails des avantages.',
    },
    confirm: {
      new_rate_title: 'Confirmé — Nouveau tarif accepté',
      cancel_title: 'Confirmé — Abonnement annulé',
      subscription_updated: "L'abonnement de {{name}} a été mis à jour.",
      subscription_canceled: "L'abonnement de {{name}} a été annulé.",
      new_rate_begins: 'Le nouveau tarif commence le {{date}}',
      access_ends: "L'accès se terminera le {{date}}.",
      confirmation_email_sent: 'Un e-mail de confirmation a été envoyé à',
    },
  },
};

const bloxFrenchServiceMessages = {
  label: 'Services',
  breadcrumbs: {
    backToSearch: 'Retour aux résultats de recherche',
    search: 'Recherche de services',
  },
  delimited: {
    manager: {
      steps: {
        uploadFile: 'Télécharger le Fichier',
        mapColumns: 'Mapper les Colonnes',
        cleanData: 'Nettoyer les Données',
        confirmImport: "Confirmer l'Importation",
        results: 'Résultats',
      },
      processing: {
        uploading: 'Téléchargement de votre fichier...',
        verifying: 'Vérification des données...',
        checkingErrors: 'Vérification des erreurs...',
      },
      navigation: {
        back: 'Retour',
        next: 'Suivant',
        startImport: "Démarrer l'Importation",
        processing: 'Traitement...',
        selectFile: 'Sélectionnez un fichier pour continuer',
      },
      errors: {
        unknownStep: 'Étape inconnue',
        unresolvedErrors:
          'Vous ne pouvez pas avancer tant que toutes les erreurs ne sont pas corrigées. Modifiez chaque ligne en erreur, puis cliquez à nouveau sur Suivant.',
      },
      confirmMappingDialog: {
        title: 'Confirmer les mises à jour de mappage',
        unmapped: 'Non mappé',
        columnLabel: 'Colonne {{value}}',
        headerLabel: "Ligne d'en-tête",
        delimiterLabel: 'Délimiteur',
        enclosureLabel: 'Qualificateur de texte',
        messageWithChangesIntro:
          "L'enregistrement de ce mappage de colonnes mettra à jour les éléments suivants :",
        message:
          "L'enregistrement de ce mappage de colonnes mettra à jour la configuration du service pour tous les futurs téléchargements. Continuer ?",
        unsetValue: 'Aucun',
        headerEnabled: "Ligne d'en-tête : activée",
        headerDisabled: "Ligne d'en-tête : désactivée",
      },
    },
    upload: {
      title: 'Télécharger le Fichier CSV',
      subtitle:
        "Sélectionnez ou glissez votre fichier CSV pour commencer le processus d'importation",
      dropzone: {
        processing: 'Traitement de votre fichier...',
        validating: 'Validation des données et vérification des erreurs',
        invalidFile: 'Fichier invalide sélectionné',
        selectValid: 'Veuillez sélectionner un fichier CSV valide',
        fileReady: "Fichier prêt pour l'importation",
        dropHere: 'Déposez votre fichier CSV ici',
        orBrowse: 'ou cliquez pour parcourir',
        maxSize: 'Taille maximale : 50MB • Format CSV uniquement',
      },
      buttons: {
        removeFile: 'Supprimer le Fichier',
        changeFile: 'Changer le Fichier',
        showLess: 'Afficher Moins',
        viewAll: 'Voir Toutes les {{count}} Lignes',
      },
      settings: {
        hasHeaders: {
          label: 'La première ligne contient des en-têtes',
          withHeaders: 'Les en-têtes seront utilisés pour le mappage des colonnes',
          withoutHeaders: 'Les colonnes seront nommées génériquement',
        },
      },
      stats: {
        rows: 'Lignes',
        columns: 'Colonnes',
      },
      preview: {
        title: 'Aperçu des Données',
        showingAll: 'Affichage de toutes les {{count}} lignes',
        showingPartial: 'Affichage des {{shown}} premières lignes sur {{total}}',
        empty: 'vide',
        showLess: "Afficher uniquement l'aperçu",
        viewAll: 'Voir toutes les lignes',
      },
      errors: {
        validation: {
          title: 'Erreur de Validation du Fichier',
          invalidType:
            'Type de fichier invalide. Veuillez télécharger un fichier CSV. Vous avez téléchargé : {{fileName}}',
          invalidFormat: 'Format de fichier invalide. CSV attendu mais {{fileType}} reçu',
          tooLarge: 'Fichier trop volumineux ({{size}}). La taille maximale est de 50MB.',
          empty:
            'Le fichier est vide. Veuillez télécharger un fichier CSV avec des données.',
          onlyOne: 'Un seul fichier peut être fourni à la fois.',
        },
        upload: {
          title: 'Échec du Téléchargement',
          helpText:
            'Veuillez vérifier le format de votre fichier et réessayer. Si le problème persiste, contactez le support.',
        },
        processing: {
          title: 'Problèmes de Traitement du Fichier',
          description:
            "Le fichier a été téléchargé mais n'a pas pu être traité correctement. Causes courantes :",
          causes: {
            delimiter: 'Délimiteur incorrect (doit être séparé par des virgules)',
            encoding: "Problèmes d'encodage du texte (enregistrer en UTF-8)",
            structure: 'Structure CSV mal formée',
            dataTypes: 'Types de données mixtes dans les colonnes',
          },
          suggestion:
            "Essayez d'ouvrir dans une application de tableur et de ré-enregistrer en CSV (UTF-8).",
        },
      },
    },
    mapping: {
      title: 'Mapper les Colonnes CSV',
      subtitle:
        'Faites correspondre vos colonnes CSV aux champs du système pour une importation correcte',
      detection: {
        title: 'Détection des Colonnes',
        allMapped: 'Tous les champs requis mappés',
        fieldsDetected: '{{count}} champs auto-détectés',
        instruction: 'Mappez vos colonnes CSV aux champs du système',
        retrying:
          'Nouvelle tentative de détection IA (tentative {{attempt}} sur {{max}})',
      },
      buttons: {
        aiDetect: 'Auto-Détection IA',
        reDetect: 'Re-détecter',
        detecting: 'Détection...',
        retrying: 'Nouvelle tentative...',
      },
      field: {
        selectPlaceholder: 'Sélectionner un champ...',
        sample: 'Échantillon : {{value}}',
        mappedTo: 'Mappé à {{fieldName}}',
        used: 'Utilisé',
        required: 'Requis',
      },
      alerts: {
        success: "L'IA a mappé {{count}} colonnes avec succès",
        error: {
          title: 'Échec de la Détection IA',
          generic: 'Le mappage IA a échoué. Veuillez mapper les colonnes manuellement.',
          instruction:
            'Veuillez mapper vos colonnes manuellement en utilisant les menus déroulants ci-dessous.',
        },
        missingFields: {
          title: 'Champs requis manquants',
          fields: '{{fields}}',
        },
      },
      ai: {
        analyzing: "L'IA analyse vos colonnes",
        detecting: 'Détection des meilleures correspondances...',
        retrying:
          'Nouvelle tentative après une erreur temporaire (tentative {{attempt}} sur {{max}})...',
        badge: 'IA',
      },
      autoMap: {
        noHeaders: 'Le mappage IA nécessite des en-têtes dans le fichier CSV',
      },
    },
    cleanup: {
      title: 'Vérifier la qualité des données',
      subtitle: "Examinez et corrigez les problèmes de données avant l'importation",

      checking: {
        checking: 'Vérification des erreurs',
        rechecking: 'Nouvelle vérification des erreurs',
        attempt: 'Vérification #{{attempt}}',
      },

      recheck: {
        info: '{{fixed}} erreurs corrigées sur {{previous}}. {{remaining}} erreur{{plural}} restante{{plural}}.',
        success: 'Les {{count}} erreurs ont été corrigées avec succès !',
      },

      healthScore: {
        title: 'Score de santé des données',
        description: '{{clean}} lignes sur {{total}} sont correctes',
      },

      pending: {
        title: '{{count}} modification{{plural}} en attente',
        description:
          '{{modified}} édition{{modifiedPlural}}, {{deleted}} suppression{{deletedPlural}} non appliquée(s)',
        apply: 'Appliquer ({{count}})',
        discard: 'Annuler',
      },

      rowEditModal: {
        title: 'Modifier la ligne {{row}}',
        titleNoRow: 'Modifier la ligne',
        saveRow: 'Enregistrer la ligne',
        deleteRow: 'Supprimer la ligne',
        noChanges:
          'Aucune modification effectuée. Mettez à jour un champ pour résoudre le problème.',
      },

      alerts: {
        summary:
          '{{errors}} problème{{errorPlural}} trouvé{{errorPlural}} dans {{rows}} ligne{{rowPlural}}. Cliquez sur Modifier pour les corriger.',
        noErrors: {
          title: 'Parfait ! Toutes les données sont validées',
          description:
            "Vos données sont propres et prêtes pour l'importation sans problème détecté",
        },
        tooManyErrors: {
          title: "Trop d'erreurs pour les modifier",
          description:
            "Ce fichier CSV contient trop d'erreurs pour être corrigé ici. Veuillez vérifier et corriger le fichier source, puis le télécharger à nouveau.",
        },
      },

      table: {
        title: {
          default: 'Données avec problèmes',
          editMode: 'Cliquez sur une cellule pour modifier',
        },
        headers: {
          row: 'Ligne',
          more: 'Plus',
          issues: 'Problèmes',
          actions: 'Actions',
        },
        moreFields: '+{{count}} champs',
        issueCount: '{{count}} problème{{plural}}',

        expanded: {
          issuesFound: 'Problèmes trouvés dans la ligne {{row}} :',
          editData: 'Modifier les données de la ligne :',
          viewData: 'Données de la ligne :',
          collapse: 'Réduire',
          expand: 'Développer pour voir tous les champs',
          enterValue: 'Entrez {{header}}',
          deletedNotice:
            "Cette ligne a été marquée pour suppression et sera retirée lors de l'importation.",
        },

        chips: {
          deleted: 'Supprimé',
          modified: 'Modifié',
        },

        showing: {
          all: 'Affichage de toutes les {{count}} lignes avec erreurs',
          partial: 'Affichage de {{shown}} sur {{total}} lignes avec erreurs',
        },

        buttons: {
          viewAll: 'Voir les {{count}} lignes avec erreurs',
          showLess: 'Afficher moins',
        },

        actions: {
          editRow: 'Modifier',
          deleteRow: 'Supprimer la ligne',
          undoDelete: 'Annuler la suppression',
        },

        badges: {
          modified: 'M',
          deleted: 'S',
        },

        empty: '-',
      },

      errors: {
        truncated: '+{{count}}',
      },

      tooltips: {
        showAll: 'Voir toutes les lignes avec erreurs',
        showLess: "Afficher l'aperçu uniquement",
      },
    },
    dataViewer: {
      title: 'Téléversement de Fichier',
      uploadCsvButton: 'Téléverser CSV',
      exportButton: 'Exporter',
      lastUpdated: 'dernière mise à jour : il y a {{relative}}',
      download: {
        tooltip: 'Télécharger le fichier traité le plus récent',
      },
      preview: {
        title: 'Aperçu des Données',
        showing: 'Affichage des {{shown}} premiers sur {{total}} enregistrements',
      },
      search: {
        placeholder: 'Rechercher des enregistrements...',
        clear: 'Effacer la recherche',
      },
      viewAll: 'Voir les {{total}} enregistrements',
      empty: {
        noRecords: "Aucun enregistrement d'abonné n'a encore été traité.",
        noMatches: 'Aucun enregistrement ne correspond à votre recherche.',
      },
      errors: {
        loadFailed: "Échec du chargement des enregistrements d'abonnés.",
      },
      export: {
        queued:
          "Préparation de l'exportation CSV. Vous recevrez une notification lorsqu'elle sera prête à télécharger.",
        error: "Échec du démarrage de l'exportation CSV.",
      },
      modal: {
        title: 'Tous les Enregistrements',
        subtitle: 'Total : {{total}} enregistrements',
        downloadCsv: 'Télécharger CSV',
        loadingMore: "Chargement de plus d'enregistrements...",
      },
    },
    preview: {
      title: "Vérifier et Confirmer l'Importation",
      subtitle: "Vérifiez vos données avant l'importation",
      summary: {
        title: "Résumé de l'Importation",
        fileName: 'Nom du Fichier',
        totalRecords: 'Total des Enregistrements',
        recordsCount: '{{count}} lignes',
        dataStatus: 'État des Données',
        allValid: 'Toutes les lignes valides',
        validWithIssues: '{{valid}} valides / {{errors}} avec problèmes',
        unknown: 'Inconnu',
      },
      alerts: {
        warning: {
          title: '{{count}} lignes ont des problèmes.',
          description:
            "Ces lignes peuvent échouer lors de l'importation. Vous pouvez revenir à l'étape précédente pour les corriger, ou procéder à l'importation.",
        },
        success: {
          title: 'Prêt à importer {{count}} enregistrements.',
          description:
            'Cliquez sur "Démarrer l\'Importation" pour commencer le processus.',
        },
      },
      dataPreview: {
        title: 'Aperçu des Données',
        showingAll: 'Affichage de toutes les {{count}} lignes',
        showingPartial: 'Affichage des {{shown}} premières lignes sur {{total}}',
        empty: 'vide',
        buttons: {
          showLess: 'Afficher Moins',
          viewAll: 'Voir Toutes les {{count}} Lignes',
        },
      },
      tooltips: {
        showAll: 'Voir toutes les lignes',
        showLess: "Afficher uniquement l'aperçu",
      },
    },
    results: {
      title: 'Importation Terminée',
      subtitle: 'Votre importation a été traitée',
      success: {
        title: 'Importation Réussie',
        description: '{{count}} enregistrements ont été importés dans votre système',
      },
      error: {
        title: "Échec de l'Importation",
        duplicateAccount:
          'Numéro de compte en double "{{account}}" trouvé à la ligne {{line}}',
      },
      summary: {
        title: "Résumé de l'Importation",
        fileName: 'Nom du Fichier',
        recordsCount: '{{count}} lignes',
        rowsProcessed: 'Lignes Traitées',
        completedAt: 'Terminé à',
        status: 'Statut',
        statusSuccess: 'Succès',
        statusFailed: 'Échec',
        unknown: 'Inconnu',
      },
      help: {
        title: 'Que faire ensuite :',
        items: {
          checkDuplicates:
            'Vérifiez les numéros de compte en double dans votre fichier CSV',
          ensureFields:
            'Assurez-vous que tous les champs requis sont correctement mappés',
          fixRows: 'Supprimez ou corrigez les lignes problématiques et réessayez',
          contactSupport: 'Contactez le support si le problème persiste',
        },
      },
      preview: {
        title: 'Aperçu des Enregistrements Importés',
        showingAll: 'Affichage de tous les {{count}} enregistrements importés',
        showingPartial: 'Affichage des {{shown}} premiers enregistrements importés',
        empty: 'vide',
        buttons: {
          showLess: 'Afficher Moins',
          viewAll: 'Voir Tous les {{count}} Enregistrements',
        },
      },
      tooltips: {
        showAll: 'Voir tous les enregistrements',
        showLess: "Afficher uniquement l'aperçu",
      },
    },
  },
  details: {
    label: 'Détails du service',
    loading: 'Chargement du service',
    error: {
      missingId: "Erreur : L'ID du service est manquant dans l'URL",
      loading: 'Erreur lors du chargement des détails du service',
      update: 'Erreur lors de la mise à jour du service : {{message}}',
      copy: "Échec de la copie de l'ID du service",
      create: 'Erreur lors de la création du service',
    },
    success: {
      update: 'Service mis à jour avec succès',
      create: 'Service créé avec succès',
      copy: 'Copié !',
    },
    header: {
      serviceId: 'ID : {{id}}',
      copyTooltip: "Copier l'ID",
      copyAriaLabel: "Copier l'ID du service",
      sectionLabel: 'Services',
      save: 'Enregistrer',
      saveChanges: 'Enregistrer les modifications',
      saving: 'Enregistrement',
      savingWithEllipsis: 'Enregistrement...',
      createService: 'Créer le service',
      creatingWithEllipsis: 'Création...',
      expandDetails: 'Développer les détails',
      collapseDetails: 'Réduire les détails',
    },
    sections: {
      serviceSettings: 'Paramètres du service',
      purchaseRates: "Tarifs d'achat",
      emailNotifications: 'Notifications par e-mail',
      domainManagement: 'Gestion des domaines',
      fileUpload: 'Téléchargement de fichier',
    },
    accordions: {
      generalSettings: {
        label: 'Paramètres généraux',
      },
      configuration: {
        label: 'Configuration',
      },
      customProperties: {
        label: 'Propriétés personnalisées',
      },
    },
    warnings: {
      title: 'Confirmer le changement',
      disabled: {
        enable: {
          message:
            "L'activation de ce service permettra aux utilisateurs d'acheter et de renouveler des abonnements. Êtes-vous sûr de vouloir activer ce service ?",
          confirmButton: 'Oui, activer le service',
        },
        disable: {
          message:
            'La désactivation de ce service annulera les abonnements et interrompra les renouvellements. Êtes-vous sûr de vouloir désactiver ce service ?',
          confirmButton: 'Oui, désactiver le service',
        },
      },
      hidden: {
        hide: {
          message:
            "Masquer ce service empêchera les utilisateurs de le voir, mais ils pourront toujours s'y lier automatiquement. Êtes-vous sûr de vouloir masquer ce service ?",
          confirmButton: 'Oui, masquer le service',
        },
        unhide: {
          message:
            'Afficher ce service le rendra visible aux utilisateurs sur le site Web. Êtes-vous sûr de vouloir afficher ce service ?',
          confirmButton: 'Oui, afficher le service',
        },
      },
      testmode: {
        enable: {
          message:
            "Le passage en mode test n'autorisera que les cartes de test pour les achats. Êtes-vous sûr de vouloir passer en mode test ?",
          confirmButton: 'Oui, passer en mode test',
        },
        disable: {
          message:
            "Le passage en mode réel n'autorisera que les vraies cartes de crédit pour les achats. Êtes-vous sûr de vouloir passer en mode réel ?",
          confirmButton: 'Oui, passer en mode réel',
        },
      },
    },
    fields: {
      name: 'Nom',
      description: 'Description',
      disabled: 'Désactivé',
      hidden: 'Masqué',
      testmode: 'Mode test',
      type: 'Type',
    },
    customProperties: {
      key: 'Clé',
      value: 'Valeur',
      add: 'Ajouter une propriété personnalisée',
      remove: 'Supprimer',
      errors: {
        keyEmpty: 'La clé ne peut pas être vide.',
        keyExists: 'La clé "{{key}}" existe déjà.',
      },
      title: 'Propriétés personnalisées',
      caption:
        "Les propriétés personnalisées vous permettent d'ajouter des métadonnées à votre service",
      about: {
        title: 'À propos des propriétés personnalisées',
        description:
          'Les propriétés sont des paires clé-valeur qui peuvent être utilisées pour stocker des données de configuration supplémentaires pour votre service.',
      },
      empty:
        'Aucune propriété personnalisée définie. Cliquez sur "Ajouter une propriété personnalisée" pour en créer une.',
      propertyName: 'Nom de la propriété',
      propertyValue: 'Valeur de la propriété',
      placeholders: {
        name: 'Entrez le nom de la propriété',
        value: 'Entrez la valeur de la propriété',
      },
      removeTooltip: 'Supprimer la propriété',
      removeAriaLabel: 'Supprimer la propriété {{name}}',
    },
    noDescription: 'Aucune description fournie',
    configuration: {
      loading: 'Chargement de la configuration...',
      noFields: 'Aucun champ de configuration disponible pour ce type de service.',
      sections: {
        service: 'Configuration du service',
        payment: 'Configuration du paiement',
        tax: 'Configuration fiscale',
        additional: 'Configuration supplémentaire',
      },
    },
    generalSettings: {
      fields: {
        serviceName: {
          label: 'Nom du service',
          tooltip: 'Entrez le nom de ce service',
        },
        notificationEmail: {
          label: 'E-mail de notification',
          help: 'Adresse e-mail pour les notifications de service',
          tooltip:
            "Entrez l'adresse e-mail où les notifications de service seront envoyées",
        },
        linkedAccounts: {
          label: 'Autoriser les comptes liés',
          help: 'Permettre aux utilisateurs de lier plusieurs comptes',
          tooltip:
            'Activez cette option pour permettre aux utilisateurs de connecter plusieurs comptes à ce service',
        },
        deliveryRequired: {
          label: "Exiger l'adresse de livraison",
          help: 'Rendre obligatoire les informations de livraison',
          tooltip:
            "Exiger des utilisateurs qu'ils fournissent des informations d'adresse de livraison",
        },
        disabled: {
          label: 'Service désactivé',
          help: 'Désactiver temporairement le service',
          tooltip: "Lorsqu'il est activé, ce service sera temporairement indisponible",
        },
        hidden: {
          label: 'Masquer au public',
          help: 'Masquer le service de la vue publique',
          tooltip:
            "Lorsqu'il est activé, ce service ne sera pas visible pour les utilisateurs",
        },
        testMode: {
          label: 'Mode test',
          help: "Activer l'environnement de test",
          tooltip: 'Activer le mode test pour le développement et les tests',
        },
        description: {
          label: 'Description du service',
          help: 'Fournissez des détails sur ce que ce service offre',
        },
      },
    },
    rates: {
      searchPlaceholder: 'Rechercher des tarifs...',
      searchAriaLabel: 'Rechercher des tarifs',
      clearTooltip: 'Effacer la saisie',
      clearAriaLabel: 'Effacer la recherche',
      activeOnly: 'Actifs uniquement',
      results: {
        count: '{{filtered}} sur {{total}} résultats',
        none: 'Aucun résultat.',
      },
      error: {
        loadFailed:
          'Échec du chargement des tarifs après {{attempts}} tentatives. Veuillez réessayer.',
        retry: 'Réessayer',
      },
      columns: {
        name: 'Nom',
        amount: 'Montant',
        duration: 'Durée',
        currency: 'Devise',
        isSaveRate: "Tarif d'épargne",
        activeUsers: 'Utilisateurs actifs',
      },
      isSaveRate: {
        yes: 'Oui',
        no: 'Non',
      },
    },
    domainManagement: {
      description: 'Gérez les domaines associés à ce service.',
      addButton: 'Ajouter',
      pasteButton: 'Coller',
      copyButton: 'Copier',
      sortButton: 'Trier',
      sortAsc: 'Trier de A à Z',
      sortDesc: 'Trier de Z à A',
      clearSort: 'Effacer le tri',
      noDomains: "Aucun domaine n'a encore été ajouté à ce service.",
      noResults: 'Aucun domaine ne correspond à votre recherche.',
      domainCount: '{{count}} domaine(s)',
      removeTooltip: 'Supprimer le domaine',
      pasteTooltip: 'Coller les domaines depuis le presse-papiers',
      copyTooltip: 'Copier tous les domaines dans le presse-papiers',
      sortTooltip: 'Trier les domaines alphabétiquement',
      searchPlaceholder: 'Rechercher des domaines...',
      searchAriaLabel: 'Rechercher des domaines',
      clearTooltip: 'Effacer la recherche',
      clearAriaLabel: 'Effacer la recherche',
      results: {
        count: '{{filtered}} sur {{total}} résultats',
        none: 'Aucun domaine',
      },
      success: {
        update: 'Domaines mis à jour avec succès',
        copy: 'Domaines copiés dans le presse-papiers',
        paste: '{{count}} domaine(s) ajouté(s)',
      },
      error: {
        update: 'Échec de la mise à jour des domaines: {{message}}',
        duplicate: 'Ce domaine existe déjà dans la liste',
        copy: 'Échec de la copie des domaines dans le presse-papiers',
        paste: 'Échec de la lecture du presse-papiers',
        noDomainsToPaste: 'Aucun domaine trouvé dans le presse-papiers',
      },
      info: {
        allDuplicates: 'Tous les domaines collés existent déjà dans la liste',
      },
      modal: {
        title: 'Ajouter un domaine',
        description: 'Entrez le nom du domaine que vous souhaitez ajouter à ce service.',
        label: 'Nom du domaine',
        placeholder: 'exemple.com',
        addButton: 'Ajouter le domaine',
        adding: 'Ajout en cours...',
        willBeAddedAs: 'Sera ajouté comme : {{domain}}',
        error: {
          empty: 'Veuillez entrer un nom de domaine',
          invalid: 'Veuillez entrer un nom de domaine valide (ex. exemple.com)',
          duplicate: 'Ce domaine existe déjà dans la liste',
        },
      },
    },
    notifications: {
      subscriberMessaging: 'Messagerie abonné',
      adminNotifications: 'Notifications administrateur',
    },
  },
  new: {
    title: 'Nouveau service {{type}}',
    error: {
      missingType: 'Le type de service est requis',
    },
  },
};

export const bloxFrenchMessages = {
  resources: {
    user: {
      fields: {
        address: 'Adresse',
        department: 'Département',
        email: 'Email',
        email_placeholder: 'Entrez l’adresse e-mail',
        email_required: 'L’email est requis.',
        first_name: 'Prénom',
        first_name_placeholder: 'Entrez le prénom',
        last_name: 'Nom',
        last_name_placeholder: 'Entrez le nom',
        municipality: 'Municipalité',
        password: 'Mot de passe',
        phone: 'Téléphone',
        postal_code: 'Code postal',
        screen_name: "Nom d'utilisateur",
        title: 'Titre',
      },
    },
    transactions: {
      name: 'Transactions',
      fields: {
        transactions_search: 'Toutes les transactions',
      },
    },
  },
  blox: {
    logs: {
      search_placeholder: 'Rechercher dans les messages du journal...',
      level: 'Niveau',
      date_range: 'Plage de dates',
      details: {
        title: 'Entrée de journal',
        time: 'Heure',
        status: 'Statut',
        driver: 'Pilote',
        level: 'Niveau',
        message: 'Message',
        fields: 'Détails',
        no_message: 'Aucun message.',
        copy_message: 'Copier le message',
        copy_value: 'Copier la valeur',
      },
      levels: {
        debug: 'Débogage',
        info: 'Information',
        warning: 'Avertissement',
        notice: 'Remarque',
        error: 'Erreur',
        fatal: 'Fatal',
      },
      error: {
        failed_to_load: 'Échec du chargement des journaux.',
      },
    },
    ai_chat: {
      label: 'Chat IA',
      try_asking: 'Essayez de poser une question comme :',
      need_any_help: 'Besoin d’aide?',
      assistant_name: 'Assistant numérique BLOX',
      input_placeholder: 'Posez une question…',
      send_message: 'Envoyer le message',
      clear_messages:
        'Supprimer tous les messages et fichiers, et réinitialiser le contexte de la conversation',
      stop_generating: 'Arrêter la génération',
      beta_program: 'Cette fonctionnalité est actuellement en version bêta.',
      ai_warning:
        "L'IA peut faire des erreurs, veuillez vérifier les informations importantes.",
      untitled_file: 'Fichier sans titre',
      attach_files: 'Joindre des fichiers',
      attached_files: 'Fichiers joints',
      files_context:
        'Ces fichiers seront inclus comme contexte supplémentaire pour assistant.',
      files_supported: 'Fichiers pris en charge: {{types}}.',
      max_files: 'Un maximum de {{max}} fichiers peuvent être joints.',
      unsupported_files: 'Fichier(s) non prisés: {{names}}',
      files_too_large: 'Fichier(s): {{names}} dépassent la taille maximale de {{size}}.',
      file_parse_failed: 'Échec de l’analyse du fichier: {{name}}',
      remove_all_files: 'Supprimer tous les fichiers',
      scroll_to_end: 'Défiler jusquà la fin',
      copy_to_clipboard: 'Copier dans le presse-papiers',
      regenerate_response: 'Régénérer la réponse',
      tools: {
        bias: {
          label: 'Vérificateur de biais',
          liberal: 'Libéral',
          leans_left: 'Penche à gauche',
          neutral: 'Neutre',
          leans_right: 'Penche à droite',
          conservative: 'Conservateur',
          summary: 'Cet article semble {{bias}} sur le plan politique.',
        },
      },
    },
    ai: {
      search: {
        toggle_label: 'Recherche intelligente',
        toggle_on_tooltip: 'Recherche intelligente (bêta)',
        toggle_off_tooltip: 'Revenir à la recherche standard',
        placeholder: 'Décrivez ce que vous recherchez…',
        submit_tooltip: 'Lancer la recherche intelligente',
      },
    },
    group: {
      form: {
        groupDetails: 'Détails du groupe',
        assignedCapabilities: 'Capacités attribuées',
        noCapabilities: 'Aucune capacité définie',
        addCapabilityModalTitle: 'Ajouter une capacité',
        addCapability: {
          label: 'Ajouter une capacité',
          apps: 'Applications',
          additionalOptions: 'Options supplémentaires',
          preview: 'Aperçu',
          noSelection: 'Aucune capacité sélectionnée',
          noOptionsSelected: 'Aucune option sélectionnée',
          editOptions: 'Modifier les options',
        },
        create: {
          success: 'Groupe créé',
          error: 'Erreur lors de la création du groupe',
          title: 'Créer un nouveau groupe',
          selectedCapabilities: 'Capacités sélectionnées',
        },
        edit: {
          title: 'Modifier le groupe',
        },
        name: {
          required: 'Le nom du groupe est requis',
          label: 'Nom du groupe',
          placeholder: 'Saisir le nom du groupe',
        },
        members: {
          label: 'Membres',
        },
      },
    },
    autosave: {
      autosaved: 'enregistré automatiquement',
      type_autosaved: '{{type}} enregistré automatiquement',
      tooltip: {
        saved: 'Dernier enregistrement {{time}}',
        autosaved: 'Modifications enregistrées automatiquement {{time}}',
        saving: 'Enregistrement automatique des modifications...',
        disabled: 'L’enregistrement automatique est désactivé',
        error:
          'L’enregistrement automatique est désactivé car la dernière tentative d’enregistrement automatique a échoué',
        revisions:
          'L’enregistrement automatique est désactivé lors de la consultation des révisions',
        form_error:
          'L’enregistrement automatique est désactivé tant que le formulaire contient des erreurs',
        asset_disabled:
          'L’enregistrement automatique est désactivé pour les ressources qui ne sont pas en brouillon',
      },
      dialog: {
        title: 'Modifications non sauvegardées',
        description:
          'Vous avez des modifications non sauvegardées. Que souhaitez-vous faire ?',
        actions: {
          discard: 'Abandonner les modifications',
          save: 'Sauvegarder les modifications',
        },
      },
      editorial: {
        revisions: {
          errors: {
            noRevisions: 'Aucun historique de révision trouvé.',
          },
          fields: {
            versionHistory: {
              label: 'Historique des versions',
              options: {
                all: 'Tout',
                currentUser: 'Utilisateur actuel',
              },
            },
            search: {
              label: 'Rechercher par commentaire ou email utilisateur',
            },
            viewHistorically: {
              label: 'Comparer historiquement',
            },
            revertModal: {
              label: 'Confirmer le retour',
              noComment: 'Aucun commentaire fourni.',
              cancel: 'Annuler',
              confirm: 'Revenir à cette version',
            },
          },
          notAvailableTooltip: 'Révision non disponible.',
          endOfResults: 'Plus de révisions à afficher.',
        },
      },
      beforeUnload:
        'Vous avez des modifications non sauvegardées. Êtes-vous sûr de vouloir quitter ?',
    },
    actions: {
      accept: 'Accepter',
      archive: 'Archiver',
      add: 'Ajouter',
      add_entry: 'Ajouter une entrée',
      new: 'Nouveau',
      apply: 'Appliquer',
      back: 'Retour',
      cancel: 'Annuler',
      cancel_uploads: 'Annuler les téléversements',
      clear_queue: 'Effacer la file d’attente',
      change: 'Changer',
      clear_all: 'Tout effacer',
      clear: 'Effacer',
      clone: 'Dupliquer',
      close: 'Fermer',
      collapse: 'Réduire',
      confirm: 'Confirmer',
      continue: 'Continuer',
      copied: 'Copié',
      copy: {
        label: 'Copier',
        clipboard: {
          label: 'Copier{{item}} dans le presse-papiers',
          copied: '{{item}} Copié dans le presse-papiers',
        },
      },
      create: 'Créer',
      crop: 'Rogner',
      remove_crop: 'Supprimer le rognage',
      delete: 'Supprimer',
      disable: 'Désactiver',
      discard: 'Abandonner',
      download: 'Télécharger',
      duplicate: 'Dupliquer',
      enable: 'Activer',
      enter_a_value: 'Entrez une valeur',
      export: 'Exporter',
      exporting: 'Exportation...',
      dropzone:
        'Faites glisser et déposez des fichiers ici, ou cliquez pour sélectionner.',
      edit: 'Modifier',
      editing: 'Modification',
      expand: 'Développer',
      expand_preview: 'Développer l’aperçu',
      failed: 'Échec',
      filter_options: 'Options de filtrage',
      include: 'Inclure',
      insert_selected: 'Insérer la sélection',
      add_to: 'Ajouter à...',
      keep: 'Garder',
      logout: 'Déconnexion',
      load_more: 'Charger plus',
      maximize: 'Maximiser',
      modify: 'Modifier',
      next: 'Suivant',
      open: 'Ouvrir',
      open_in_new_window: 'Ouvrir dans une nouvelle fenêtre',
      open_in_new_tab: 'Ouvrir dans un nouvel onglet',
      publish: 'Publier',
      purge: 'Purger',
      quick_edit: 'Édition rapide',
      refresh: 'Actualiser',
      reset_filters: 'Réinitialiser les filtres',
      remove: 'Ret',
      remove_all: 'Retirer tout',
      replace: 'Remplacer',
      required: 'Requis',
      reset: 'Réinitialiser',
      restore: 'Restaurer',
      retry: 'Réessayer',
      error_click_retry: 'Une erreur est survenue. Cliquez pour réessayer.',
      save: 'Enregistrer',
      saving: 'Enregistrement',
      saved: 'Enregistré',
      save_close: 'Enregistrer et fermer',
      save_reload: 'Enregistrer et recharger',
      save_changes: 'Enregistrer',
      save_draft: 'Enregistrer brouillon',
      save_as_draft: 'Enregistrer comme brouillon',
      save_publish: 'Enregistrer et publier',
      submit: 'Soumettre',
      publish_updates: 'Publier les mises à jour',
      select_action: 'Sélectionner une action',
      search: 'Rechercher',
      select: 'Sélectionner',
      select_all: 'Tout sélectionner',
      select_all_prompt: 'Souhaitez-vous tout sélectionner?',
      set_as_preview: 'Définir comme aperçu',
      set_as_teaser: 'Définir comme teaser',
      set_as_cover_art: 'Définir comme image de couverture',
      start_listening: 'Démarrer l’écoute',
      stop_listening: 'Arrêter l’écoute',
      success: 'Succès',
      show: 'Afficher',
      undo: 'Annuler',
      undo_deletion: 'Annuler la suppression',
      restore_success: 'Restauration réussie',
      restore_requested: 'Restauration demandée',
      unpin: 'Détacher',
      unlock: 'Déverrouiller',
      use_selected: 'Utiliser Sélectionné',
      update: 'Mettre à jour',
      upload: 'Téléverser',
      uploading: 'Téléversement en cours',
      view: 'Voir',
      fetching: 'Séduisants',
      copy_to_site: 'Copier vers le site...',
    },
    copy_to_site: {
      target_sites_label: 'Sites cibles',
      site_select: 'Sélectionner les sites de destination',
      please_select_sites: 'Veuillez sélectionner des sites pour continuer',
      no_target_sites:
        'Aucun autre site disponible. Vous êtes actuellement sur {{site}}, qui est le seul site auquel vous avez accès.',
      processing_progress: 'Traitement de {{count}} sites... {{progress}}',
      site_header: 'Site',
      status_header: 'Statut',
      summary: 'Copié avec succès vers {{success}} sur {{total}} sites.',
      summary_error: '{{error}} sites n’étaient pas compatibles.',
      confirm_close_title: 'Êtes-vous sûr de vouloir fermer?',
      confirm_close_content: 'Toutes les copies non encore traitées seront ignorées.',
      confirm_proceed_title: 'Êtes-vous sûr de vouloir continuer?',
      retryable_errors_summary: '{{count}} sites n’ont pas pu être traités',
    },
    errors: {
      generic: 'Une erreur est survenue.',
    },
    permissions: {
      msg: {
        required_short: 'Nécessite l’autorisation {{name}}',
        required_long: 'Votre compte nécessite l’autorisation {{name}}',
        required_list_short: 'Nécessite les autorisations {{names, list}}',
        required_list_long: 'Votre compte nécessite les autorisations {{names, list}}',
        access_restricted: 'Accès restreint',
        contact_admin:
          'Contactez votre administrateur système pour demander les autorisations nécessaires pour votre compte.',
      },
      site_admin: 'administrateur du site',
      full_access: 'accès complet',
      editorial: 'éditorial',
      editorial_settings: 'paramètres éditoriaux',
      syndication: 'syndication',
      create_assets: 'créer des ressources',
      modify_assets: 'modifier des ressources',
      delete_assets: 'supprimer des ressources',
      change_publish_status: 'changer le statut de publication',
      batch_edit_search: 'édition en lot de recherche',
      workflows: 'flux de travail',
      change_workflow: 'changer le flux de travail',
      change_process: 'changer le processus',
      site_tags: 'tags du site',
      keyword_tags: 'tags de mots-clés',
      access_rules: 'règles d’accès',
      asset_automations: 'automatisations des ressources',
      asset_settings: 'paramètres des ressources',
      contributed_content: 'contenu contribué',
      related_content_styles: 'styles de contenu associé',
      content_importers: 'importateurs de contenu',
      linked_sites_mapping: 'cartographie des sites liés',
      automated_article_export: 'export automatique d’articles',
      drm_policies: 'politiques DRM',
      semantic_analysis: 'analyse sémantique',
      section_maps: 'cartes de section',
      user: 'utilisateur',
      manage_user_accounts: 'gérer les comptes utilisateurs',
      manage_user_groups: 'gérer les groupes d’utilisateurs',
      assign_user_groups: 'assigner des groupes d’utilisateurs',
      user_groups_not_same:
        'Vous devez être dans les mêmes groupes que l’utilisateur pour assigner des groupes.',
      edit_profile: 'modifier le profil',
      change_avatar: 'changer l’avatar',
      change_authentication: 'changer l’authentification',
      override_concurrent_login_rules: 'outrepasser les règles de connexion simultanée',
      edit_custom_properties: 'modifier les propriétés personnalisées',
      import_content: 'importer du contenu',
      modify_channels: 'modifier les canaux',
      modify_importers: 'modifier les importateurs',
      broadcast: 'diffusion (notifier)',
      broadcast_full: 'accès complet à la diffusion',
      broadcast_change_settings: 'modifier les paramètres de diffusion',
      broadcast_read_notifications: 'lire les notifications de diffusion',
      broadcast_send_notifications: 'envoyer des notifications de diffusion',
      email_reach_full: 'portée des emails',
      access_control: 'contrôle d’accès',
      access_control_full: 'accès complet au contrôle d’accès',
      access_control_edit_rules: 'modifier les règles d’accès',
      access_control_create_rules: 'créer de nouvelles règles d’accès',
      access_control_delete_rules: 'supprimer des règles d’accès',
      access_control_settings: 'paramètres de contrôle d’accès',
      subscription_any: 'abonnement',
      subscription_full: 'accès complet à l’abonnement',
      subscription_edit: 'modifier les abonnements',
      subscription_create: 'créer des abonnements',
      subscription_edit_services: 'modifier les services d’abonnement',
      subscription_service_modify: 'modifier les services',
      pro_data_insights_any: 'aperçu des données pro',
      pro_data_insights_full: 'accès complet aux aperçus des données pro',
      pro_data_insights_view_reports: "afficher les rapports d'aperçu des données pro",
      pro_data_insights_export_data: "exporter les données d'aperçu des données pro",
    },
    assistant: {
      label: 'Assistant',
      score: {
        label: "Score d'optimisation",
        low: 'Faible',
        medium: 'Moyen',
        high: 'Élevé',
      },
      content: {
        label: 'Assistant de contenu',
        actions: {
          select: 'Sélectionner une action',
          complete: 'Compléter',
          emojify: 'Emojifier',
          extend: 'Étendre',
          rephrase: 'Reformuler',
          shorten: 'Raccourcir',
          simplify: 'Simplifier',
        },
      },
      keyword: {
        label: 'Assistant de mots-clés',
      },
      seo: {
        title: {
          label: 'Assistant de titre SEO',
        },
        description: {
          label: 'Assistant de description SEO',
        },
      },
      social_title: {
        label: 'Assistant de titre social',
      },
      social_summary: {
        label: 'Assistant de résumé social',
      },
      summary: {
        label: 'Assistant de résumé',
      },
      url_title: {
        label: `Assistant de titre de l'URL`,
      },
      suggestion: {
        label: 'Suggestion IA',
        current: 'Actuel',
        suggested_replacements: 'Remplacements Suggérés',
        dismiss: 'Ignorer',
        rules: {
          spell_check: {
            title: 'Orthographe',
            prompt: "Identifier et corriger les fautes d'orthographe",
          },
          grammar_check: {
            title: 'Grammaire',
            prompt: 'Identifier et corriger les erreurs grammaticales',
          },
        },
      },
    },
    framework: {
      user_menu: {
        theme: 'Thème',
        theme_description:
          'Sélectionnez votre préférence d’affichage globale pour l’interface. Choisissez entre un thème sombre ou clair pour convenir à votre confort visuel et à votre environnement de travail. Ce paramètre s’appliquera à l’ensemble de la plateforme, garantissant une apparence cohérente chaque fois que vous accédez à vos outils et contenus.',
        theme_options: {
          light: 'Clair',
          dark: 'Sombre',
          browser: 'Navigateur (requiert un rafraîchissement)',
        },
        dark_mode: 'Mode sombre',
        language: 'Langue',
        language_description:
          'Choisissez votre langue préférée pour l’interface. Cette préférence est utilisée pour votre compte et peut être modifiée à tout moment.',
        tooltip: 'Profil',
        view_site: {
          label: 'Aperçu du site',
          front: `Voir la page d'accueil`,
          front_anon: `Voir la page d'accueil anonymement`,
          time_preview: `Voir l'aperçu de la page d'accueil à un moment spécifique`,
          preview: `Voir l'aperçu de la page d'accueil`,
        },
        tracking: 'Suivi de session',
        tracking_description:
          'Choisissez si le suivi de session est activé pour votre expérience de compte. Cette préférence peut être mise à jour à tout moment.',
        my_preferences: 'Mes Préférences',
        preferences: {
          global: {
            label: 'Préférences Globales',
          },
          site: {
            label: 'Préférences du Site',
          },
          set_title: 'Définir {{screen}}',
          save_success: 'Préférences enregistrées avec succès.',
          save_error: "Erreur lors de l'enregistrement des préférences.",
          loading: 'Chargement des préférences...',
          notifications: {
            label: 'Notifications et Alertes',
          },
          default_asset_settings: {
            label: "Paramètres d'actifs par défaut",
          },
          start_time: {
            label: 'Heure de début par défaut',
            title: 'Définir l’heure de début par défaut',
            specify_time: 'Spécifier l’heure de début',
            description:
              "Utilisez cette préférence pour définir l'heure de début par défaut pour tous les nouveaux contenus que vous créez. Cette préférence ne durera que pendant la durée de votre session. Après vous être déconnecté et reconnecté, le système reviendra à l'utilisation de la date et l'heure actuelles jusqu'à ce que vous définissiez à nouveau cette préférence.",
            radio_current: "Définir l'heure de début à la date et l'heure actuelles",
            radio_specific: "Définir l'heure de début à une date et heure spécifiques",
            helper_text:
              'La date de publication utilise actuellement votre heure de début définie dans les paramètres.',
            invalid: 'Heure de début non valide',
          },
          workflow: {
            label: 'Workflow par défaut',
            title: "Définir le workflow d'actif par défaut",
            input_label: 'Flux de travail par défaut',
            none: 'Sélectionnez un flux de travail par défaut',
            tooltip:
              'Flux de travail pour attribuer automatiquement aux nouveaux actifs éditoriaux que vous créez.',
          },
          author: {
            label: 'Auteur par défaut',
            title: 'Auteur par défaut',
            description:
              'Vous définir automatiquement comme auteur des contenus que vous créez ?',
          },
          presentations: {
            title: 'Présentations par défaut',
            description:
              "Choisissez le mode de présentation appliqué aux nouveaux contenus que vous créez, par type. Il s'agit d'une préférence personnelle qui n'affecte pas les autres utilisateurs. Les nouveaux contenus héritent du mode sélectionné sauf s'il est remplacé sur le contenu. La valeur par défaut est Aucune.",
            none: 'Aucune',
          },
        },
      },
      card_view: {
        grid: 'Vue Grille',
        list: 'Vue Liste',
        summary: 'Vue Résumé',
        preview: 'Aperçu',
      },
    },
    batch_edit: {
      label: 'Modification par lot',
      actions: {
        edit: 'Modifier la sélection',
        edit_all: 'Modifier tous les résultats de recherche',
        clear: 'Effacer la sélection',
        undo_deletion: 'Annuler la suppression',
        undo_deletion_help:
          'Définit le champ Date de suppression sur Supprimer, ce qui restaure ces éléments.',
      },
      confirm: {
        change_count_one:
          'Vous êtes sur le point de modifier {{count}} résultat de recherche.',
        change_count_other:
          'Vous êtes sur le point de modifier {{count}} résultats de recherche.',
        type_count: 'Pour confirmer, veuillez saisir le nombre de résultats ({{count}})',
        input_placeholder: 'Entrez le nombre de résultats',
        input_error: 'Le nombre ne correspond pas au total des résultats',
      },
      help: {
        success: 'Tâche de modification en lot créée',
        selectionLimited: 'La sélection est limitée à {{count}} éléments.',
        selectionExceedsLimit:
          'Veuillez réduire votre sélection à {{count}} éléments ou utilisez l\'option "Modifier en lot les résultats de recherche" pour modifier tous les résultats de votre recherche.',
      },
      errors: {
        preflightFailed:
          'Échec du chargement des options de modification en lot.{{message}}',
        submitFailed:
          'Échec de la création de la tâche de modification en lot.{{message}}',
      },
    },
    batch_import: {
      importing_assets: 'Importation de ressource(s)',
      import_problems: 'Problème(s) avec une importation',
      group_label: 'Importation groupée · {{count}} fichiers',
      notifications: {
        bpm: {
          success_title: 'Téléchargement BPM terminé',
          success:
            'Téléchargement du fichier BPM réussi. Les ressources seront importées en arrière-plan',
          import_success_title: 'Importation BPM terminée',
          import_success:
            'Toutes les ressources de {{fileName}} ont été importées avec succès',
          import_success_link: 'Voir les ressources importées',
          warn_title: "Avis d'importation BPM",
          warn: "Le fichier BPM n'acceptera pas les préréglages pendant l'importation.",
          error_title: 'Échec du téléchargement BPM',
          error: 'Échec du téléchargement du fichier BPM',
        },
        single_upload_title: 'Téléchargement terminé',
        single_upload_body: '{{fileName}} a été téléchargé avec succès',
        single_upload_link: 'Modifier {{fileName}}',
        single_upload_failed_title: 'Échec du téléchargement',
        single_upload_failed_body: '{{errorMessage}}',
        wire_import_success_title: 'Importation Wire terminée',
        wire_import_success_body: '{{recordTitle}} a été importé avec succès',
        wire_import_success_link: 'Modifier {{recordTitle}}',
        wire_import_failed_title: "Échec de l'importation Wire",
        wire_import_failed_body: '{{errorMessage}}',
        group_complete_title: 'Import en lot terminé',
        group_complete_body_all_success:
          'Tous les {{total}} fichiers ont été téléchargés avec succès',
        group_complete_body_partial:
          '{{success}} fichier(s) sur {{total}} téléchargé(s) avec succès. Échecs : {{failedFiles}}',
        group_complete_body_all_failed: 'Tous les {{total}} fichiers ont échoué',
        group_complete_link: 'Voir les fichiers importés',
        // Legacy keys — retained for backward compatibility
        group_complete: '{{success}} fichier(s) sur {{total}} téléchargé(s) avec succès',
        single_success: 'Fichier téléchargé avec succès.',
        // Fallback notify messages (used when user notifications are disabled)
        notify_import_complete: 'Importation de {{fileName}} terminée.',
        notify_import_update_complete:
          "Mise à jour de l'importation de {{fileName}} terminée.",
        notify_import_failed: 'Importation de {{fileName}} échouée.',
        notify_upload_failed: 'Échec du téléchargement : {{errorMessage}}',
        notify_missing_binary_id:
          'Échec du téléchargement : ID binaire manquant dans la réponse.',
        notify_upload_canceled: "Téléchargement annulé par l'utilisateur.",
        notify_record_already_imported:
          'Enregistrement déjà importé, redirection vers la page de modification',
        notify_import_in_progress: 'Importation déjà en cours',
        notify_record_imported: 'Enregistrement importé avec succès',
        notify_record_importing: 'Importation en cours',
        notify_wire_import_failed:
          "Échec de l'importation : Impossible d'importer la ressource wire",
        notify_wire_import_error: "Erreur lors de l'importation : {{errorMessage}}",
      },
      columns: {
        upload_status: 'Statut du téléchargement',
        file_name: 'Nom du fichier',
      },
      presets: {
        label: 'Préréglages',
      },
    },
    export: {
      label: 'Exportation',
      msg: {
        export_success: "Tâche d'exportation créée avec succès",
        export_ready: "Le fichier d'exportation est prêt à être téléchargé.",
        export_error: "Échec de la création de la tâche d'exportation",
        download_success: "Fichier d'exportation téléchargé avec succès",
        download_error: "Échec du téléchargement du fichier d'exportation",
      },
    },
    import: {
      label: 'Importer',
      files: {
        import_success: 'Importations réussies',
        import_error: 'Une erreur est survenue lors des importations',
        upload_success: "Fichier d'importation téléchargé avec succès",
        upload_error: "Échec du téléchargement du fichier d'importation",
      },
      assets: {
        imported: 'Éléments importés',
      },
    },
    business: {
      label: 'Entreprise',
    },
    staticpages: {
      label: 'Pages statiques',
    },
    subscription: bloxFrenchSubscriptionMessages,
    transactions: bloxFrenchSubscriptionMessages.transactions,
    giftSubscription: {
      label: 'Abonnements cadeaux',
      noResults: 'Aucun abonnement cadeau disponible.',
      loading: 'Chargement des abonnements cadeaux...',
      loadingDetails: "Chargement des détails de l'abonnement cadeau...",
      loadMore: 'Charger plus',
      loadingMore: 'Chargement...',
      retry: 'Réessayer',
      errorLoadingGiftSubscriptions:
        'Impossible de charger les abonnements cadeaux. Veuillez réessayer.',
      purchased: 'Acheté le {{date}}',
      toRecipient: 'À : {{email}}',
      redeemed: 'Utilisé le {{date}}',
      close: 'Fermer',
      status: {
        redeemed: 'Utilisé',
        notRedeemed: 'Non utilisé',
      },
      detail: {
        loadingHeader: 'Chargement des détails du cadeau...',
        redeemedBy: 'Utilisé par',
        viewRecipientProfile: 'Voir le profil du destinataire',
        notRedeemed: 'Non utilisé',
        giftDetails: 'Détails du cadeau',
        rateName: 'Nom du tarif',
        rate: 'Tarif',
        termExpires: 'Le terme expire',
        termExpired: 'Le terme a expiré',
        subscriptionStart: "Début de l'abonnement",
        giftCode: 'Code cadeau',
        purchaseDate: "Date d'achat",
        deliveryDate: 'Date de livraison',
        redeemedDate: "Date d'utilisation",
        purchaser: 'Acheteur',
        purchaserName: "Nom de l'acheteur",
        recipient: 'Destinataire',
        region: 'Région',
        postalCode: 'Code postal',
        country: 'Pays',
        recipientName: 'Nom du destinataire',
        email: 'E-mail',
        deliveryAddress: 'Adresse de livraison',
        deliveryMunicipality: 'Municipalité de livraison',
        deliveryRegion: 'Région de livraison',
        deliveryPostalCode: 'Code postal de livraison',
        deliveryCountry: 'Pays de livraison',
        deliveryPhone: 'Téléphone de livraison',
        transaction: 'Transaction',
        transactionDate: 'Date de transaction',
        amount: 'Montant',
        duration: 'Durée',
        transactionId: 'ID de transaction',
        price: 'Prix',
        taxRate: "Taux d'imposition",
      },
    },

    user: {
      label: 'Utilisateurs',
      title: 'Profil utilisateur',
      unknown_user: 'Utilisateur inconnu',
      account_type: {
        admin: 'Administrateur',
        normal: 'Normal',
        any: 'Tous',
      },
      actions: {
        sending: 'Envoi en cours...',
        send_password_reset: 'Envoyer la réinitialisation du mot de passe',
        send_instant_login: 'Envoyer la connexion instantanée',
        send_admin_invite: "Envoyer l'invitation d'administrateur",
        invite_to_site: 'Inviter vers le site...',
        reset_password: 'Réinitialiser le mot de passe',
        instant_login: 'Connexion instantanée',
        set_password: 'Définir le mot de passe',
        edit_profile: {
          label: 'Modifier le profil',
          title: "Modification du profil de l'utilisateur",
        },
        edit_user: {
          title: "Modification de l'utilisateur",
          title_admin: "Modification de l'administrateur",
        },
        edit_groups: {
          title: 'Groupes',
          submit_success: 'Groupes mis à jour',
          errors: {
            min: 'Veuillez sélectionner au moins un groupe.',
          },
        },
        change_password: {
          name: 'Mot de passe',
          label: 'Changer le mot de passe',
          label_alt: 'Entrer le mot de passe',
          help: 'Le mot de passe doit comporter au moins {{minLength}} caractères.',
          placeholder: 'Nouveau mot de passe',
          confirm_placeholder: 'Confirmer le nouveau mot de passe',
          password_mismatch: 'Les mots de passe ne correspondent pas',
          required: 'Le mot de passe est requis.',
          success: 'Mot de passe mis à jour avec succès',
          error: 'Échec de la mise à jour du mot de passe',
          user_option: 'Permettre à l’utilisateur de définir son propre mot de passe',
          user_option_help:
            'Activez cette option pour envoyer un e-mail de réinitialisation du mot de passe à l’utilisateur, lui permettant de définir en toute sécurité son propre mot de passe après la création.',
        },
        new_subscription: 'Nouvel abonnement',
        viewUser: 'Voir le profil public',
        auth_group: 'Sécurité du compte',
        user_settings: {
          label: "Paramètres d'administration des utilisateurs",
        },
        admin_invite: {
          submit_success: "E-mail d'invitation d'administrateur envoyé avec succès",
          submit_error: "Échec de l'envoi de l'e-mail d'invitation d'administrateur",
          email_validation: {
            error: "Échec de la validation de l'e-mail",
            error_groups: 'Veuillez sélectionner au moins un groupe.',
          },
          form: {
            create_note:
              "Un e-mail d'invitation d'administrateur sera envoyé avec un compte créé lors de l'acceptation.",
            sending_to: "Envoi d'un e-mail d'invitation d'administrateur à",
            email_label: 'E-mail',
            email_placeholder: "Entrez l'adresse e-mail",
            select_groups:
              'Sélectionnez les groupes dans lesquels inscrire cet utilisateur.',
          },
        },
        downgrade: {
          label: "Supprimer les privilèges d'administrateur",
          title: "Supprimer les privilèges d'administrateur pour {{user}}",
          description:
            "Cette action supprimera les privilèges d'administrateur de cet utilisateur. Il n'aura plus accès aux fonctionnalités et paramètres d'administration.",
          warning: 'Êtes-vous sûr de vouloir rétrograder cet utilisateur ?',
          confirm_msg:
            'Êtes-vous sûr de vouloir rétrograder cet utilisateur à un compte normal ?',
          confirm_btn: "Oui, supprimer les privilèges d'administrateur",
          submit_success: "L'administrateur a été rétrogradé",
          submit_error:
            "Échec de l'envoi de la demande de rétrogradation de l'administrateur",
        },
      },
      avatar: {
        label: 'Avatar',
        remove: "Supprimer l'avatar",
        max_size_err: 'La taille du fichier dépasse le maximum de 5 Mo.',
        invalid_format:
          'Format de fichier invalide. Veuillez télécharger un fichier image (jpg, png, gif).',
        uploading: 'Téléchargement en cours...',
        upload_success: 'Avatar mis à jour avec succès',
        upload_error: "Échec de la mise à jour de l'avatar. Veuillez réessayer.",
        drop_image_here: 'Déposez une image ici, ou cliquez pour sélectionner un fichier',
        drag_to_replace: "Glisser-déposer pour remplacer l'avatar",
        drag_to_upload: "Glisser-déposer une image d'avatar ici",
        click_browse: 'ou cliquez pour parcourir',
        formats: 'JPG, PNG, ou GIF (max 5 Mo)',
      },
      msg: {
        instant_login_success: 'E-mail de connexion instantanée envoyé',
        instant_login_error: "Échec de l'envoi",
        password_reset_success:
          'E-mail de réinitialisation du mot de passe envoyé avec succès',
        password_reset_error: "Échec de l'envoi",
      },
      activity_stream: {
        label: 'Flux d’activité',
        loading: 'Chargement du flux d’activité...',
        refreshing: 'Actualisation...',
        error: 'Erreur lors du chargement du flux d’activité.',
        no_results: 'Aucune donnée de flux d’activité disponible.',
        end_results: 'Aucun flux d’activité supplémentaire disponible.',
      },
      subscriptions: {
        no_results: 'Aucun abonnement disponible.',
      },
      payment_methods: {
        label: 'Moyens de paiement',
      },
      linked_accounts: {
        label: 'Comptes associés',
        no_subscriptions_to_share: 'Aucun abonnement disponible à partager.',
        no_linked_accounts: 'Aucun compte associé disponible.',
        add_account: 'Ajouter un compte',
        add_linked_account: 'Ajouter un compte associé',
        adding: 'Ajout',
        add: 'Ajouter',
        revoke: 'Révoquer',
        revoking: 'Révocation...',
        revoke_access: "Révoquer l'accès",
        confirm_revoke_title: "Confirmer la révocation de l'accès",
        confirm_revoke_message:
          "Êtes-vous sûr de vouloir révoquer l'accès pour {{email}} ?",
        user_no_subscriptions: "L'utilisateur n'a aucun abonnement",
        email_prompt: "Saisissez l'adresse e-mail du compte que vous souhaitez associer.",
        view_user_in_new_tab: "Afficher l'utilisateur dans un nouvel onglet",
        granted: 'Accordé',
        invited: 'Invité',
        status_in: '{{status}} en {{date}}',
        granted_access_to: 'Accès accordé à {{email}} en {{date}}',
        linked_subscription_inactive: 'Abonnement du compte associé inactif',
        grantor_subscription_inactive: 'Abonnement du concédant inactif',
      },
      audiences: {
        label: 'Audiences',
        loading: 'Chargement des audiences utilisateur...',
        error: 'Erreur lors du chargement des audiences. Veuillez réessayer.',
        no_user_id: "Aucun identifiant d'utilisateur fourni.",
        no_description: 'Aucune description disponible.',
        view_description_aria: 'Voir la description de {{label}}',
        dmp_unavailable:
          "Le suivi des données comportementales n'est pas disponible pour ce profil car votre site n'a pas activé le CDP/DMP. Veuillez contacter votre administrateur de site pour discuter de l'activation de cette fonctionnalité.",
        no_audiences: 'Aucune audience disponible.',
      },
      search: {
        action: 'Rechercher des comptes utilisateurs...',
        loading: 'Chargement de la recherche d’utilisateurs...',
        user_account: 'Compte utilisateur',
        admin_account: 'Compte administrateur',
        multisite: {
          title: 'Contacts / Recherche multi-sites',
          help: 'Recherchez pour afficher les comptes utilisateurs sur plusieurs sites.',
        },
        admin: {
          action: 'Rechercher des comptes administrateur...',
        },
      },
      groups: {
        label: 'Groupes',
        no_groups: 'Aucun groupe disponible.',
        edit_groups: 'Modifier les groupes',
        copy: {
          label: 'Copier les groupes vers le site',
          fetching_groups: 'Récupération des données des groupes...',
          groups_to_copy: 'Groupes à copier ({{count}})',
          group_fallback_name: 'Groupe {{id}}',
          members_count_one: '{{count}} membre',
          members_count_other: '{{count}} membres',
          name_too_long: 'Le nom du groupe doit comporter 100 caractères ou moins',
          count_with_word: '{{count}} {{word}}',
          group_word_one: 'groupe',
          group_word_other: 'groupes',
          site_word_one: 'site',
          site_word_other: 'sites',
          summary_copied_part: '{{groupCountText}} copiés vers {{siteCountText}}',
          summary_error_part: '{{siteCountText}} avec des erreurs',
          row_groups_copied_one: '{{count}} groupe copié',
          row_groups_copied_other: '{{count}} groupes copiés',
          row_groups_failed_one: '{{count}} groupe non copié',
          row_groups_failed_other: '{{count}} groupes non copiés',
          confirm_copy_header: 'Confirmer la copie des groupes',
          confirm_copy_sub_text_one: 'Copier les groupes vers {{count}} site.',
          confirm_copy_sub_text_other: 'Copier les groupes vers {{count}} sites.',
          confirm_copy_sub_text_all: 'Copier les groupes vers tous les sites.',
          confirm_copy_button: 'Oui, Copier',
        },
        form: {
          assignedCapabilities: 'Capacités assignées',
          noCapabilities: 'Aucune capacité définie',
          addCapabilityModalTitle: 'Ajouter une capacité',
          totalCapabilities: 'Total des capacités',
          removeCapability: 'Supprimer la capacité',
          addCapability: {
            label: 'Ajouter une capacité',
            apps: 'Applications',
            additionalOptions: 'Options supplémentaires',
            preview: 'Aperçu',
            noSelection: 'Aucune capacité sélectionnée',
            noOptionsSelected: 'Aucune option sélectionnée',
            editOptions: 'Modifier les options',
          },
          create: {
            success: 'Groupe créé',
            error: 'Erreur lors de la création du groupe',
            title: 'Créer un nouveau groupe',
          },
          edit: {
            title: 'Modifier le groupe',
          },
          name: {
            required: 'Le nom du groupe est requis',
            label: 'Nom du groupe',
            placeholder: 'Entrez le nom du groupe',
          },
        },
      },
      profile_information: {
        label: 'Informations de profil',
        edit_profile: 'Modifier le profil',
        about: 'À propos',
        topic_focus: 'Sujet principal',
        location_focus: 'Emplacement principal',
        demographic_focus: 'Focalisation démographique',
        languages: 'Langues',
        memberships: 'Adhésions',
        awards: 'Récompenses',
        also_available: 'Également disponible',
        no_information: 'Aucune information de profil disponible.',
        edit_field_tooltip: "Saisissez la valeur du champ {{field}} de l'utilisateur",
        update_success: 'Profil mis à jour avec succès',
        update_error: 'Erreur lors de la mise à jour du profil',
      },
      fields: {
        location: 'Emplacement',
        birthday: 'Anniversaire',
        country: 'Pays',
        region: 'Région',
        facebook: 'Facebook',
        linkedin: 'LinkedIn',
        x: 'X',
        social_url_tooltip: 'URL du compte {{account}}',
      },
      sections: {
        details: 'Détails',
        addresses: 'Adresses supplémentaires',
        byline: 'Signature',
        tagline: 'Slogan',
        personal_info: 'Informations personnelles',
        address_info: 'Adresse',
        professional_info: 'Informations professionnelles',
        admin_info: 'Informations administrateur',
        social_info: 'Réseaux sociaux',
      },
      empty: {
        address: 'Aucune adresse fournie',
      },
      meta: {
        created: 'Rejoint',
      },
      settings: {
        admins: {
          label: 'Administrateurs',
          manage: 'Gérer les administrateurs',
          groups: 'Groupes',
          invite: 'Inviter un administrateur',
        },
      },
      quick_filters: {
        label: 'Filtres rapides',
        no_saved_searches: 'Aucun filtre rapide.',
        columns: {
          name: 'Nom',
          application: 'Application',
        },
      },
      invite_to_site: {
        title: 'Inviter vers le site',
        button_label: 'Inviter vers le site...',
        send_button: 'Envoyer les invitations',
        groups_label: 'Groupes à attribuer ({{count}} sélectionnés)',
        users_to_invite: 'Utilisateurs à inviter ({{count}})',
        select_groups_error: 'Veuillez sélectionner au moins un groupe',
        groups_help_text:
          "Les groupes qui n'existent pas sur le site cible seront créés.",
        search_groups_placeholder: 'Rechercher des groupes...',
        selected_groups_one: '{{count}} sélectionné',
        selected_groups_other: '{{count}} sélectionnés',
        no_groups_match: 'Aucun groupe ne correspond à la recherche',
        group_ensure_error:
          'Impossible de préparer le groupe "{{group}}" sur {{domain}} : {{error}}',
        invite_error: "Impossible d'inviter {{email}} sur {{domain}} : {{error}}",
        summary_success_one: '{{count}} utilisateur invité vers {{siteCountText}}',
        summary_success_other: '{{count}} utilisateurs invités vers {{siteCountText}}',
        summary_partial_success_one:
          '{{count}} utilisateur invité vers {{siteCountText}}',
        summary_partial_success_other:
          '{{count}} utilisateurs invités vers {{siteCountText}}',
        site_count_one: '{{count}} site',
        site_count_other: '{{count}} sites',
        row_users_invited_one: '{{count}} utilisateur invité',
        row_users_invited_other: '{{count}} utilisateurs invités',
        row_users_failed_one: '{{count}} échoué',
        row_users_failed_other: '{{count}} échoués',
        row_invite_failed_one: '{{count}} invitation échouée',
        row_invite_failed_other: '{{count}} invitations échouées',
        row_groups_failed_one: '{{count}} groupe non ajouté',
        row_groups_failed_other: '{{count}} groupes non ajoutés',
        group_not_added: 'Groupe non ajouté : {{group}}',
        confirm_close_title: 'Êtes-vous sûr de vouloir fermer?',
        confirm_close_content:
          'Toutes les invitations non encore traitées seront ignorées.',
        confirm_invite_header: "Confirmer l'invitation",
        confirm_invite_sub_text_one: 'Inviter des utilisateurs vers {{count}} site.',
        confirm_invite_sub_text_other: 'Inviter des utilisateurs vers {{count}} sites.',
        confirm_invite_sub_text_all: 'Inviter des utilisateurs vers tous les sites.',
        confirm_invite_button: 'Oui, Inviter',
      },
    },
    adowl: {
      label: 'Ad Owl',
    },
    calendar: {
      label: 'Calendrier',
    },
    classifieds: {
      label: 'Petites annonces',
    },
    eedition: {
      label: 'E-Édition',
    },
    electionsstats: {
      label: 'Statistiques électorales',
    },
    email: {
      label: 'Email',
    },
    form: {
      label: 'Formulaire',
    },
    html: {
      label: 'HTML',
    },
    search: {
      label: 'Recherche',
      placeholder: 'Rechercher du contenu...',
      runtime: 'Exécution de la recherche enregistrée',
      actions: {
        return: 'Retour à la recherche',
        returnAlt: 'Retour aux résultats de recherche',
      },
      view: {
        card_view: 'Vista de tarjetas',
        list_view: 'Vista de lista',
        summary_view: 'Vista de resumen',
      },
      sort: {
        label: 'Trier',
        sorted: 'Trié',
        sorted_label_dir: 'Trié : {{label}} ({{direction}})',
        ascending: 'Ascendant',
        descending: 'Descendant',
        remove_sort: 'Supprimer le tri',
      },
      // saved search / quick filters
      saved: {
        shared_with_org: "Partagé avec l'organisation",
        shared: 'Partagé',
        quick_filters: 'Filtres rapides',
        saved_filters: 'Filtres enregistrés',
        my_filters: 'Mes filtres',
        shared_filters: 'Filtres partagés',
        create_new_filter: 'Créer un nouveau filtre',
        applied_filter: 'Filtre appliqué',
        new_quick_filter: 'Nouveau filtre rapide',
        new_quick_filter_desc:
          'Enregistrez les critères de recherche actuels comme filtre rapide.',
        replace_quick_filter: 'Remplacer le filtre rapide',
        replace_quick_filter_desc:
          'Remplacez un filtre rapide existant par les critères de recherche actuels.',
        quick_filter_name: 'Nom du filtre rapide',
        for_working_privately: 'Pour travailler en privé',
        for_share_with_org: 'Pour partager avec votre organisation',
        save_quick_filter: 'Enregistrer le filtre rapide',
        edit_quick_filter: 'Modifier le filtre rapide',
        delete_success: 'Filtre rapide supprimé avec succès.',
        delete_confirm: '"{{name}}" sera supprimé.',
        this_quick_filter: 'Ce filtre rapide',
        default_modal: {
          title: {
            remove: 'Supprimer par défaut',
            replace: 'Remplacer par défaut',
            confirm: 'Confirmer par défaut',
          },
          content: {
            remove:
              'Confirmer la suppression de <b>{{name}}</b> comme recherche par défaut?',
            replace:
              'Remplacer <b>{{currentName}}</b> par <b>{{newName}}</b> comme recherche par défaut?',
            set: 'Définir <b>{{name}}</b> comme recherche par défaut?',
          },
          actions: {
            cancel: 'Annuler',
            confirm: 'Confirmer',
          },
        },
      },
      batch: {
        label: 'Modifier en lot les résultats de recherche',
      },
      multisite: {
        domains: {
          label: 'Domaines',
          action: 'Sélectionner des domaines',
          help: 'Domaines sélectionnés',
          filter: 'Rechercher des domaines...',
          all: 'Tous les sites',
        },
      },
      table: {
        last_modified_by: 'Dernière modification par',
        owner: 'Propriétaire',
        default: 'Par défaut',
        categories: 'Catégories',
        uuid: 'UUID',
        created_date: 'Date de création',
        domain: 'Domaine',
        subscription_state: "État de l'abonnement",
        term: 'Durée',
        services: 'Services',
        rate_name: 'Nom du tarif',
        term_expires: 'Échéance du terme',
        service_icon: 'Icône de service',
        service_title: 'Titre du service',
        service_type: 'Type de service',
        active_subscribers: 'Abonnés actifs',
        new_subscribers: 'Nouveaux abonnés',
        stopped_subscribers: 'Abonnés arrêtés',
        payment_handler: 'Gestionnaire de paiement',
        service_id: 'ID du service',
        author: 'Auteur',
        created: 'Créé',
        actions: 'Actions',
        search_templates: 'Rechercher des modèles...',
      },
    },
    asset_library: {
      label: "Bibliothèque d'Actifs",
      action: {
        drag: 'Faites glisser et déposez des ressources depuis la bibliothèque de ressources.',
      },
    },
    editorial: {
      label: 'Éditorial',
      loading: 'Chargement de l’éditorial...',
      help: {
        no_access: 'Permission de modification des ressources requise',
      },
      infobar: {
        status: 'Statut',
        online: 'En ligne',
        published: 'Publié',
        unpublished: 'Non publié',
        offline: 'Hors ligne',
        revision: 'Rév',
        access: 'Accès',
        expires: 'Expire',
        workflow: 'Flux de travail',
        title: 'Titre',
        words: 'Mots',
        characters: 'Caract.',
        web: '(Web)',
        words_print: 'Mots (Impr.)',
        depth: 'Profondeur',
        images: 'Images',
        rich_media: 'Médias',
        new: 'Nouveau',
        draft: 'Brouillon',
        live: 'En direct',
        yes: 'Oui',
        no: 'Non',
        default: 'Par défaut',
        scheduled: 'Programmé',
        rev_no_live: 'Cette ressource est publiée sans révision en direct.',
        rev_not_loaded: 'En direct (rév. non chargée)',
        rev_not_loaded_tip:
          "Cette ressource est en ligne mais la révision publiée n'a pas été récupérée. Consultez l'historique des révisions pour plus de détails.",
      },
      batchImport: {
        label: 'Téléchargement en lot',
      },
      templates: {
        newStory: 'Nouvel article',
        createMenu: {
          heading: "Modèles d'article",
          empty:
            "Aucun modèle d'article pour le moment. Créez-en un pour réutiliser sa structure et ses métadonnées.",
          error: "Impossible de charger les modèles d'article.",
          createFromAria: 'Créer à partir du modèle : {{title}}',
          untitled: 'Modèle sans titre',
        },
      },
      assetQuickLaunch: {
        createTitle: 'Créer {{label}}',
        createAction: 'Créer {{label}}',
        duplicateTitle: 'Dupliquer {{label}}',
        duplicateAction: 'Dupliquer {{label}}',
        templateTitle: 'Enregistrer en tant que modèle {{label}}',
        createTemplateTitle: 'Nouveau modèle {{label}}',
        templateAction: 'Créer un modèle',
        template: {
          nameLabel: 'Titre du modèle',
          nameHelp: 'Optionnel — utilise le titre existant par défaut',
          nameHelpNew: 'Optionnel — vous pourrez renommer le modèle plus tard',
        },
        useTemplate: {
          title: 'Créer {{label}} à partir du modèle',
          action: 'Créer {{label}}',
        },
        apply: {
          warning_duplicate:
            "Impossible d'appliquer les valeurs de lancement rapide à la duplication.",
        },
        workflows: {
          error:
            'Impossible de charger les workflows pour le moment. Vous pouvez réessayer ou continuer sans workflow.',
        },
        workflow: {
          label: 'Workflow',
          helper: 'Facultatif — revient aux paramètres par défaut du site.',
          untitled: 'Workflow sans titre',
        },
        startTime: {
          label: 'Heure de début',
          helper: 'Facultatif — enregistré dans {{timeZone}}.',
        },
        slug: {
          label: 'Identifiant',
          placeholder: 'Saisissez un identifiant',
          helper: "Facultatif — pré-remplit l'identifiant d'impression de la ressource.",
          helper_duplicate:
            'Facultatif — laisser vide pour générer automatiquement à partir du titre.',
        },
        storyTemplate: {
          label: 'Modèle de récit',
          helper:
            'Sélectionnez un modèle pour pré-remplir la ressource avec du contenu et des métadonnées prédéfinis.',
          blank: 'Vide',
          error:
            'Impossible de charger les modèles de récit pour le moment. Vous pouvez continuer avec une ressource vide.',
        },
      },
      asset: {
        // Save messaging...
        created: '{{type}} créé',
        updated: '{{type}} mis à jour',
        saved: '{{type}} enregistré',
        saved_draft: '{{type}} enregistré comme brouillon.',
        workflow_updated: 'Workflow mis à jour',
        workflow_process_updated: 'Processus du workflow mis à jour',
        confirm_publish: 'Confirmer et publier',
        confirm_demotion: 'Confirmer la rétrogradation',
        confirm_demotion_and_publish: 'Confirmer la rétrogradation et publier',
        confirm_promotion: 'Confirmer la promotion',
        confirm_promotion_and_publish: 'Confirmer la promotion et publier',
        promote_to: 'Promouvoir vers',
        demote_to: 'Rétrograder vers',
        promote_and_publish_to: 'Promouvoir et publier vers',
        demote_and_publish_to: 'Rétrograder et publier vers',
        published_draft: 'Le statut est brouillon et publié.',
        published_live: 'Le statut est en ligne et publié.',
        unpublished_draft: 'Le statut est brouillon et non publié.',
        unpublished_live: 'Le statut est en ligne et non publié.',
        dates_updated: 'Dates mises à jour',
        delete_date_updated: 'Date de suppression mise à jour',
        archive_date_updated: "Date d'archivage mise à jour",
        archive_and_delete_updated: "Date de suppression d'archivage mise à jour",

        // Asset fields
        title: {
          label: 'Titre principal',
          label_alt: 'Titre',
          help_alt: 'Saisir un titre...',
          help_alt_poll: 'Saisissez une question...',
        },
        byline: {
          label: 'Signature',
          help: 'Saisir une ligne de signature...',
        },
        caption: {
          label: 'Légende',
          help: 'Saisissez une légende...',
          description:
            'Déposez un nouveau fichier de sous-titres pour ajouter un autre format',
          supported_formats: 'Formats pris en charge : WebVVT (.vtt), SubRip (.srt)',
          invalid_format: "L'URL ne se termine pas par .vtt ou .srt",
        },
        content: {
          label: 'Contenu',
        },
        content_characters: {
          label: 'Caractères',
        },
        cover: {
          label: 'Image de couverture',
          description:
            "Téléchargez une image de couverture pour l'affichage dans la mise en page de l'article.",
          properties: {
            label: "Propriétés d'affichage de l'image de couverture",
            description: "Définir les propriétés d'affichage de l'image de couverture",
            cover_img: {
              label: "Image de l'image de couverture",
              help: 'Glissez-déposez ou cliquez dans la zone ci-dessus pour téléverser une nouvelle image de couverture',
              invalid:
                "L'URL ne se termine pas par .jpeg, .jpg, .png, .gif, .tiff ou .bmp",
            },
            cover_align_horizontal: {
              label: 'Alignement horizontal du texte',
              options: {
                center: 'Centré',
                left: 'Gauche',
                right: 'Droite',
              },
            },
            cover_align_vertical: {
              label: 'Alignement vertical du texte',
              options: {
                top: 'Haut',
                middle: 'Milieu',
                bottom: 'Bas',
              },
            },
            cover_text_color: {
              label: 'Couleur du texte',
              options: {
                light: 'Clair',
                dark: 'Foncé',
              },
            },
            cover_text_background: {
              label: 'Arrière-plan du texte',
              options: {
                none: 'Aucun',
                background_box: 'Boîte de fond',
                text_in_a_box: 'Texte dans une boîte',
              },
            },
            cover_effect: {
              label: 'Effet',
              options: {
                none: 'Aucun',
                parallax: 'Parallaxe',
                ken_burns: 'Panoramique et zoom',
                blur: 'Flou',
                grayscale: 'Niveaux de gris',
                sepia: 'Sépia',
                desaturate: 'Désaturer',
              },
            },
          },
        },
        tagline: {
          label: 'Slogan',
        },
        address: {
          label: 'Adresse',
        },
        municipality: {
          label: 'Ville',
        },
        postal_code: {
          label: 'Code postal',
        },
        country: {
          label: 'Pays',
        },
        region: {
          label: 'Région',
        },
        related_content: {
          label: 'Contenu associé',
          relationships_label: 'Relations',
          actions: {
            insert: {
              label: 'Créer et insérer du contenu associé',
            },
            add: {
              label: 'Ajouter aux relations',
              label_specific: 'Ajouter à {{relationship}}',
            },
            view_selected: 'Voir la sélection',
            close_selected: 'Fermer la sélection',
            unselect_all: 'Désélectionner tous les éléments',
            remove: {
              label: 'Supprimer les éléments sélectionnés',
              confirm: 'Confirmer la suppression',
              help_one:
                'Êtes-vous sûr de vouloir supprimer {{count}} élément associé de cette ressource ?',
              help_other:
                'Êtes-vous sûr de vouloir supprimer {{count}} éléments associés de cette ressource ?',
              warn: 'Impossible de supprimer les éléments en ligne',
              note: 'Remarque : les éléments en ligne ne peuvent pas être supprimés.',
            },
            search: {
              label: 'Rechercher du contenu associé...',
            },
            move_to_top: 'Déplacer en haut',
            move_to_bottom: 'Déplacer en bas',
          },
          table: {
            type: 'Type',
            title: 'Titre',
            start_date: 'Date de début',
            status: 'Statut',
          },
          aria_labels: {
            drag_handle: 'Glisser pour réorganiser',
            more_options: "Plus d'options",
          },
          moving: 'Déplacement...',
          notifications: {
            added: '{{count}} ajouté(s) à {{relationship}}.',
            added_with_duplicates:
              '{{count}} ajouté(s) à {{relationship}}. (Doublons : {{duplicates}})',
            all_duplicates:
              'Tous les éléments sélectionnés étaient déjà dans {{relationship}}.',
          },
          help: {
            no_selection: 'Aucun élément sélectionné',
          },
          parents: {
            label: 'Parents',
          },
          siblings: {
            label: 'Associés',
          },
          related_content: {
            label: 'Contenu',
          },
        },
        latitude: {
          label: 'Latitude',
        },
        longitude: {
          label: 'Longitude',
        },
        archive_time: {
          label: `Date d'archivage`,
        },
        delete_time: {
          label: 'Date de suppression',
        },
        files: {
          label: 'Fichiers',
          social: {
            label: 'Image de prévisualisation sociale',
          },
        },
        flags: {
          label: 'Étiquettes',
        },
        keywords: {
          label: 'Mots-clés',
          confirm_delete: {
            header: 'Confirmer la suppression',
            title: 'Êtes-vous sûr de vouloir supprimer ?',
            description: 'Cette action est irréversible.',
            pre_confirm: 'Veuillez saisir',
            post_confirm: 'ci-dessous pour autoriser la suppression.',
            input_label: 'Confirmation',
            cancel: 'Annuler',
            confirm: 'Oui, supprimer',
          },
          help: 'Rechercher ou ajouter des mots-clés',
          not_found: 'Aucun résultat trouvé. Appuyez sur Entrée pour ajouter.',
          caption:
            'Attribuez des mots-clés pour améliorer la découverte de votre vidéo sur les sites web, applications et flux. Ces mots-clés aident à associer votre vidéo aux recherches pertinentes.',
        },
        site_tags: {
          label: 'Balises du site',
        },
        children: {
          label: 'Enfants',
          add_to_children: 'Ajouter à Enfants',
        },
        parents: {
          label: 'Parents',
          add_to_parents: 'Ajouter aux parents',
        },
        siblings: {
          label: 'Associés',
          add_to_siblings: 'Ajouter aux associés',
        },
        url: {
          label: 'URL',
        },
        properties: {
          label: 'Propriétés',
          abuse: {
            label: 'Signalé comme abus',
            description:
              'Indique si la communauté a collectivement signalé cet élément comme étant en violation des politiques du site.',
            reset_by_admin: 'réinitialisé par l’administrateur',
          },
          altext: {
            label: 'Texte alternatif',
            help: "Entrez un texte alternatif, pour l'accessibilité...",
          },
          article_type: {
            label: 'Type de travail',
            description:
              'Catégorisez ce contenu en fonction des définitions de schema.org.',
            placeholder: 'Sélectionnez le type de travail',
          },
          app: {
            label: 'Application source',
            help: 'Lecture seule',
          },
          canonical_url: {
            label: 'URL Canonique',
            description: `L'URL canonique entièrement qualifiée pour cet élément. Principalement utile si le contenu provient d'une source tierce. Les URLs doivent contenir un protocole, un hôte et un chemin pour être considérées comme entièrement qualifiées.`,
          },
          custom: {
            label: 'Propriétés personnalisées',
            name: {
              label: 'Nom',
              help: {
                spaces: 'Les espaces ne sont pas autorisés',
                unique: 'Le nom doit être unique',
                required: 'Le nom est requis',
              },
            },
            value: {
              label: 'Valeur',
              help: {
                required: 'La valeur est requise',
              },
            },
          },
          external_id: {
            label: 'Identifiant CMS importé',
            help: 'Lecture seule',
          },
          hammer: {
            label: 'Titre accrocheur',
          },
          kicker: {
            label: `Titre d'accroche`,
          },
          subheadline: {
            label: 'Sous-titre',
          },
          no_publish: {
            label: 'Ne pas publier',
            label_alt: 'Statut de publication',
            description: 'Définir le statut de publication',

            // Remove/Restore Web Modal
            remove_from_web: 'Retirer du web',
            restore_to_web: 'Restaurer sur le web',
            type_removed_from_web: '{{type}} retiré du web',
            type_restored_to_web: '{{type}} restauré sur le web',
            choose_web_version: 'Choisissez la version à restaurer sur le web',
            saves_all_as_draft:
              'Enregistre toutes les modifications actuelles en brouillon',
            remove_current_version: 'Supprimer la version publiée (ne pas publier)',
            remove_current_version_desc:
              'La ressource ne sera plus visible sur le site web.',
            apply_latest_changes:
              'Appliquer les dernières modifications (Publier les mises à jour)',
            apply_latest_changes_desc:
              'Enregistre toutes les modifications actuelles en ligne et les publie sur le web',
            restore_prior_version: 'Restaurer une version précédemment publiée',
            restore_prior_version_desc:
              'Rétablit la visibilité sur le web de la dernière version publiée.',
            disabled_in_create_mode:
              'Cette option sera disponible une fois que la ressource aura été créée.',
            controlled_by_workflow: 'Contrôlé par le workflow',
            disabled_in_draft:
              'Cette option est désactivée tant que le statut est en brouillon.',

            help: {
              workflow:
                'Le processus de workflow actuel est prêt pour le web et ne peut pas être dépublié',
              permission: 'Permission requise pour changer le statut de publication',
              allow: 'Ok pour publier',
              scheduled: 'Planifié',
              disallow: 'Publication désactivée',
            },
          },
          no_reactions: {
            label: 'Réactions des utilisateurs',
            help: 'Lorsqu’il est activé, tous les outils de réaction (par exemple, les likes, les réactions emoji) sont disponibles pour l’élément s’ils sont configurés sur la section ou la page. La désactivation des réactions pour cet élément remplacera tous les paramètres au niveau du site ou de la section.',
          },
          no_comments: {
            label: 'Commentaires',
            help: 'Lorsqu’il est activé, les commentaires des utilisateurs sont disponibles sur l’élément si les commentaires sont configurés sur la section ou la page. La désactivation des commentaires pour cet élément remplacera tous les paramètres au niveau du site ou de la section.',
          },
          video360: {
            label: 'Mode vidéo 360°',
            help: 'Si activé, la vidéo sera affichée en mode 360.',
          },
          disable_advertising: {
            label: 'Désactiver la publicité',
            help: "Si activé, ce paramètre empêchera l'application de balises publicitaires à cette vidéo.",
            warning: 'Publicité désactivée. Cette vidéo sera lue sans publicités.',
            confirm_title:
              'La désactivation des publicités aura un impact sur les revenus',
            confirm_description:
              'La désactivation de la publicité pour cette vidéo empêchera tout appel publicitaire et réduira les revenus publicitaires potentiels. Êtes-vous sûr de vouloir continuer ?',
          },
          photo_sales: {
            label: 'Vente de photos',
          },
          priority: {
            label: `Priorité d'affichage`,
            help: 'Chiffres uniquement',
            placeholder: 'Entrez une priorité numérique',
          },
          seo_description: {
            label: 'Description SEO',
          },
          seo_title: {
            label: 'Titre SEO',
            description: 'Le titre à utiliser pour le SEO.',
            warning_length:
              'Le titre SEO dépasse les 60 caractères recommandés pour un référencement optimal.',
          },
          social_title: {
            label: 'Titre social',
            description: `Titre alternatif à servir sur les réseaux sociaux. Par défaut, utilise le titre principal de l'élément s'il est vide.`,
          },
          social_summary: {
            label: 'Résumé social',
            description: `Résumé alternatif à servir sur les réseaux sociaux. Par défaut, utilise le résumé principal de l'élément s'il est vide.`,
          },
          social_twitter_card: {
            label: 'Carte',
            description: `Définir l'affichage de la carte X lorsqu'elle est présentée.`,
            auto: 'Automatique',
            large_image: 'Grande image',
            summary: 'Résumé',
          },
          url_title: {
            label: `Titre de l'URL`,
            description: `Un titre cohérent à afficher dans l'URL si les titres dans les URL sont activés. Tous les titres seront affichés dans l'URL en minuscules avec uniquement des lettres, des chiffres, des espaces et des tirets.`,
          },

          workflow: {
            label: 'Flux de travail',
            current_workflow: 'Flux de travail actuel: {{workflow}}',
            default_workflow: 'Flux de travail par défaut',
            default_workflow_description_p1:
              'Le flux de travail par défaut prend en charge un processus de publication simple, du brouillon à la mise en ligne. Le contenu est créé en mode brouillon, où il peut être modifié librement. Une fois prêt, utilisez « Enregistrer et publier » pour publier la ressource sur le Web.',
            default_workflow_description_p2:
              'Pour les ressources déjà en ligne, l’option « Enregistrer le brouillon » vous permet d’effectuer des mises à jour sans affecter la version publiée. La dernière version en ligne reste visible jusqu’à ce que vous sélectionniez « Enregistrer et publier » pour publier les modifications.',
            default_workflow_description_p3:
              'Vous pouvez retirer une ressource du site en sélectionnant « Retirer du web ». Tant que la ressource n’est pas publiée, vous pouvez continuer à enregistrer des modifications. Lorsque vous êtes prêt à la remettre en ligne, sélectionnez « Restaurer sur le web » pour publier la version mise à jour.',
            change_workflow_or_process: 'Modifier le workflow ou le processus',
            new_workflow_and_process: 'Nouveau workflow et processus',
            no_workflow_assigned: 'Aucun workflow attribué',
            no_site_workflows: 'Aucun workflow disponible pour ce site.',
            // Warnings for save actions
            change_warning:
              'Attention : Changer le workflow déplacera cette ressource vers un processus éditorial différent.',
            workflow_please_be_aware:
              'Cette ressource est dans un flux de travail ; veuillez prendre connaissance des points suivants.',
            process_forces_draft: 'Le processus forcera le brouillon.',
            process_forces_live: 'Le processus forcera la mise en ligne.',
            process_resets_start_time: 'Le processus réinitialisera l’heure de début.',
            process_returns_on_draft: 'Le processus reviendra au brouillon.',

            actions: {
              change: 'Modifier le workflow',
              remove: 'Supprimer le workflow actuel',
            },
          },

          workflow_process: {
            label: 'Processus',
            current_process: 'Processus actuel: {{process}}',
            select_process_step: 'Sélectionnez une étape de processus',
            print_ready: 'Prêt pour l’impression',
            web_ready: 'Prêt pour le web',
            no_syndicate: 'Bloquer la syndication',
            reset_start_time: 'Réinitialiser l’heure de début',
            force_draft: 'Forcer en brouillon',
            force_live: 'Forcer en ligne',
            return_on_draft: 'Revenir au brouillon',
            disable_collaboration: 'Désactiver la collaboration',
            help: {
              change: 'Modifier le processus de workflow',
              restricted: 'Modification du processus de workflow restreinte',
              promote:
                'Utilisez le menu déroulant Enregistrer les modifications pour promouvoir à travers les étapes du workflow.',
            },
          },

          publish: {
            live_view: 'Vue en direct',
            copy_live_url: 'Copier l’URL en direct',
            help: {
              force_draft_workflow:
                'Le workflow sélectionné impose le statut de publication',
            },
          },
        },
        update_time: {
          label: 'Dernière mise à jour',
        },
        authors: {
          label: 'Auteurs',
          label_one: 'Auteur',
          help: 'Ajouter des auteurs...',
          help_reorder: 'Le premier auteur de cette liste est le lead.',
          primary_tooltip: 'Lead',
        },
        body_copy: {
          label: 'Corps du Texte',
          help: 'Saisissez le corps du texte...',
        },

        creators: {
          label: 'Créateurs',
          help: 'Ajouter des créateurs...',
        },
        description: {
          label: 'Description',
          help: 'Ajouter une description...',
        },
        captions: {
          label: 'Sous-titres',
          help: 'Ajouter des sous-titres...',
          description:
            'Téléchargez des fichiers de sous-titres pour fournir du texte aux personnes malentendantes. Les formats pris en charge incluent WebVTT (.vtt) et SubRip (.srt).',
          invalid_format: "L'URL ne se termine pas par .vtt, .srt ou .ttml",
        },
        video: {
          label: 'Vidéo',
          help: 'Ajouter une vidéo...',
          poster: {
            label: 'Affiche',
            description: "L'image d'affiche du lecteur.",
          },
          preview: {
            label: 'Aperçu',
            description: "L'image affichée dans l'aperçu du bloc.",
          },
        },
        start_time: {
          label: 'Date de publication',
          alt_label: 'Heure de début',
          errors: {
            invalid: 'Heure de début invalide',
          },
        },
        draft: {
          label: 'Brouillon',
          description: 'Présente des modifications non publiées',
        },
        save: {
          label: 'Enregistrer',
          ariaLabel: 'Enregistrer et actions de workflow',
        },
        publish: {
          label: 'Publier',
          aria_label: 'Publier et actions de workflow',
          buttons: {
            cancel: {
              label: 'Annuler',
            },
            publish: {
              label: 'Mettre à jour',
            },
          },
          fields: {
            revision_comment: {
              label: 'Commentaire de révision',
              placeholder: 'Ajouter un commentaire à cette mise à jour...',
            },
            mark_important: {
              label: 'Marquer cette mise à jour comme importante',
            },
            do_not_publish: {
              label: 'Ne pas publier',
              set_publish: 'Définir le statut de publication',
              current_workflow:
                'Le processus de workflow actuel est prêt pour le web et ne peut pas être dépublié',
              change_publish: 'Permission requise pour modifier le statut de publication',
            },
            optimization: {
              label: "Score d'optimisation",
            },
            pub_date: {
              label: 'Date de publication',
            },
          },
        },
        source: {
          label: 'Source',
          description: `L'agence qui a généré le contenu de cet actif.`,
        },
        sections: {
          label: 'Sections',
          search_view: 'recherche',
          tree_view: 'arborescence',
          switch_view: 'Passer à la vue {{view}}',
          error_fetch_tree:
            'Erreur lors de la récupération de l’arborescence des sections',
          caption:
            'Attribuez des balises de section pour guider l’emplacement de la vidéo sur votre site et dans les flux de contenu. Ces balises aident le système à décider où placer la vidéo.',
          help_reorder:
            'La première section de cette liste sera la section principale pour ce {{type}}.',
          help_drag_drop: 'Faites glisser et déposez les éléments pour les réorganiser.',
        },
        summary: {
          label: 'Résumé',
          description: `Entrez ici un résumé concis de votre élément. Il s'agit d'un aperçu bref, idéalement ne dépassant pas 150-200 mots, qui met en évidence les points ou thèmes principaux du contenu.`,
        },
        teaser: {
          label: `Image d'accroche`,
          label_preview: 'Image de prévisualisation',
          description: {
            article: `Utilisez le champ Image d'accroche pour télécharger une image de prévisualisation pour votre histoire. Cette image apparaîtra sous forme de vignette ou de prévisualisation dans les listes d'articles et les résultats de recherche. Elle est distincte des images de contenu principal et ne sera pas affichée sur la page d'accueil de l'article. Idéale pour attirer l'attention des lecteurs et fournir un résumé visuel du sujet de l'article.`,
            image: `Cette image apparaîtra lorsque cet élément sera présenté sous forme de prévisualisation ou de vignette.`,
            default: `Cette image apparaîtra comme la prévisualisation ou la vignette pour cet élément.`,
          },
        },
        type: {
          label: 'Type',
        },
        update_comment: {
          label: 'Commentaire de révision',
          description: 'Ajoutez un commentaire à cette mise à jour...',
        },
        important_update: {
          label: 'Mise à jour importante',
          description: 'Marquez cette mise à jour comme importante',
        },
        presentation: {
          label: 'Présentation',
          description:
            'Sélectionnez comment ce contenu doit être présenté aux lecteurs. Différents styles de présentation peuvent aider à mettre en valeur certains aspects de votre contenu.',
        },
        poll: {
          answer: 'Réponse',
          answers: 'Réponses',
          add_answer: 'Ajouter une Réponse',
          add_answer_desc:
            'Appuyez sur le bouton "Ajouter une Réponse" pour ajouter des choix.',
          remove_choice: 'Supprimer le Choix',
          votes: 'Votes',
          color: 'Couleur',
          bar_graph: 'Graphique à Barres',
          pie_chart: 'Graphique Circulaire',
          total_votes: 'Total des Votes',
        },
      },
      collab: {
        disconnected: 'Déconnecté',
        disconnect_warning:
          'Veuillez vérifier votre connexion internet, car vous semblez être déconnecté ou hors ligne.',
        sessions: 'Sessions',
        current_session: 'Session actuelle',
        other_sessions: 'Autres sessions',
        no_other_sessions: 'Aucune autre session',
        collaborators: 'Collaborateurs',
        no_other_collaborators: 'Aucun autre collaborateur',
      },
      metadata: {
        group: {
          uuid: {
            label: 'UUID',
          },
          workflow: {
            label: 'Flux de travail',
            help: {
              restricted: 'Accès restreint pour ce workflow',
              reset_start_time:
                'L’heure de début est réinitialisée sur "Maintenant" par le processus de workflow attribué',
            },
          },
          dates: {
            label: 'Dates',
          },
          label: 'Emplacement',
          map: {
            invalid_coordinates: 'Coordonnées invalides',
            helper:
              "Entrez des latitude et longitude valides pour voir l'emplacement sur la carte",
          },
          seo: {
            label: 'SEO',
            description: `Définissez comment l'article apparaîtra dans les résultats de recherche.`,
          },
          social: {
            label: 'Sociaux',
            description: `Définissez comment l'article apparaîtra sur les réseaux sociaux.`,
          },
          print_depth: {
            label: 'Profondeur d’impression',
            label_alt: 'Plage de profondeur d’impression',
          },
          print_publication: {
            label: 'Publication imprimée',
            fields: {
              publication: {
                label: 'Publication',
              },
              edition: {
                label: 'Édition',
              },
              section: {
                label: 'Section',
              },
              zone: {
                label: 'Zone',
              },
              page: {
                label: 'Page',
              },
              location: {
                label: 'Emplacement',
              },
              date: {
                label: 'Date',
              },
              placed: {
                label: 'Placement',
              },
            },
          },
          print_publication_date_range: {
            label: 'Plage de dates de publication imprimée',
            help: 'Sélectionnez une publication pour définir une plage de dates',
          },
          print_publication_status: {
            label: 'Statut de publication imprimée',
            help: 'Sélectionnez une publication pour sélectionner le statut',
          },
          print_ready: {
            label: 'Prêt pour l’impression',
          },
          print_slug: {
            label: 'Identifiant',
            placeholder: "Entrez un identifiant d'impression",
            help: "Trouver l'identifiant exact...",
            description:
              "Un Identifiant sert d'ID de projet pour votre contenu, contenant des lettres, des chiffres, des traits de soulignement, des tirets, des espaces, et plus encore. Il est utilisé pour le suivi interne, la gestion du flux de travail et l'organisation du contenu dans Blox CMS.",
          },
          print: {
            label: "Propriétés d'impression",
            ready: {
              label: "Prêt pour l'impression",
              description: '',
            },
            not_ready: {
              label: "Pas prêt pour l'impression",
            },
            headline: {
              label: 'Titre',
              description: 'Titre personnalisé à imprimer.',
            },
            subheadline: {
              label: 'Sous-titre',
              description: 'Sous-titre personnalisé à imprimer.',
            },
            printpriority: {
              label: 'Priorité',
              description: 'Détermine l’ordre d’impression de l’actif.',
            },
            printImageColor: {
              label: 'Couleur',
              description: 'Sélectionnez la couleur de l’impression.',
            },
            printImageBlackWhite: {
              label: 'Noir et blanc',
              description: 'Sélectionnez l’impression en noir et blanc.',
            },
            jumpkeyword: {
              label: 'Mot-clé de saut',
              description: 'Mot-clé utilisé pour les références de saut.',
            },
            jumphead: {
              label: 'Tête de saut',
              description: 'Titre personnalisé pour un contenu continu.',
            },
            notes: {
              label: 'Remarques',
              description: 'Informations complémentaires à imprimer.',
            },
          },
        },
      },
      // For article asset type
      article: {
        label: 'Article',
      },
      // For image asset and image general use where applicable
      image: {
        label: 'Image',
        description: 'Le fichier associé à cette ressource.',
        help: 'Faites glisser ou cliquez dans la zone ci-dessus pour téléverser une nouvelle image.',
        invalid: "L'URL ne se termine pas par .jpeg, .jpg, .png, .gif, .tiff, ou .bmp",
        view_full_size: 'Voir en taille réelle',
        dropzone: {
          label:
            'Faites glisser et déposez une image ici, ou cliquez pour en sélectionner une.',
        },
        photo_sales: {
          label: 'Vente de photos',
          description:
            "Indiquez si des tirages de cette photo peuvent être vendus. L'option Automatique examinera les données de la ressource pour déterminer si la photo est vendable.",
          options: {
            automatic: 'Automatique',
            //Enabled and Disabled use blox.general.enabled and blox.general.disabled for consistency in the UI
          },
        },
      },
      audio: {
        dropzone: {
          label:
            'Faites glisser et déposez un fichier audio ici, ou cliquez pour en sélectionner un.',
        },
      },
      file: {
        success: 'Fichier téléchargé avec succès.',
        transfering: 'Transfert en cours...',
        dropzone: {
          label: 'Glissez-déposez un fichier ici, ou cliquez pour en sélectionner un.',
        },
        error: {
          asset: 'Impossible de définir à partir de la ressource fournie',
          invalid: "L'URL ne se termine pas par une extension de fichier acceptée.",
          failed: "Erreur lors de l'obtention du fichier depuis l'URL.",
        },
      },
      video: {
        dropzone: {
          label:
            'Faites glisser et déposez un fichier vidéo ici, ou cliquez pour en sélectionner un.',
        },
        processing:
          "Votre vidéo est en cours de conversion vers un format compatible avec le web et n'est pas encore disponible à la lecture.",
        drop_to_upload: 'Déposez pour téléverser une nouvelle vidéo.',
        blackbird: {
          not_configured: 'Blackbird n’est pas configuré pour ce site.',
        },
      },
      revisions: {
        label: 'Révisions',
        endOfResults: 'Plus de révisions...',
        noChanges: 'Aucun changement trouvé.',
        notAvailableTooltip: 'Révision non disponible',
        buttons: {
          restore_previous: 'Restaurer la révision précédente',
          restore_selected: 'Restaurer la révision sélectionnée',
          selected_revision: 'Révision sélectionnée',
          most_recent_save: 'Dernière sauvegarde',
          previous_revision: 'Révision précédente',
          restore: 'Restaurer cette version',
          duplicate_revision: 'Dupliquer depuis la révision {{revisionId}}',
          duplicate_revision_simple: 'Dupliquer {{assetType}}',
        },
        before: {
          label: 'Avant',
        },
        after: {
          label: 'Après',
        },
        removed: {
          label: 'Supprimé',
        },
        fields: {
          versionHistory: {
            label: 'Historique des versions',
            options: {
              all: 'Tout',
              currentUser: 'Votre historique de révision',
            },
          },
          search: {
            label: 'Rechercher des révisions...',
          },
          viewHistorically: {
            label: 'Voir historiquement',
          },
          revertModal: {
            label: 'Revenir à la révision suivante ?',
            confirm: 'Confirmer',
            cancel: 'Annuler',
            noComment: 'Aucun commentaire fourni',
          },
        },
        current: {
          label: 'Actuel',
        },
        previous: {
          label: 'Précédent',
        },
        unknownUser: {
          label: 'Utilisateur inconnu',
        },
        errors: {
          revert: 'Il y a eu une erreur lors du traitement de votre demande.',
          noRevisions: 'Aucun révision trouvée.',
          noRevisionsCurrentUser: "Aucun révision trouvée pour l'utilisateur actuel.",
          header: `Il y a eu une erreur lors de la récupération des révisions.`,
          duplicate_error: 'Erreur lors de la duplication de la révision.',
        },
        duplicate_success: 'Révision {{revisionId}} dupliquée',
        quick_launch: {
          revision_label: 'Révision {{revisionId}}',
          revision_label_fallback: 'Révision',
        },
        asset_fallback: 'Contenu',
        viewableTooltip: 'Visible',
        draftTooltip: 'Rédiger',
      },
      settings: {
        label: 'Paramètres',
        help: 'Sélectionnez un paramètre dans la barre latérale pour afficher et modifier sa configuration.',
        ai: {
          label: 'Paramètres AI',
          help: 'Paramètres AI éditoriaux.',
          summary: `Contrôlez diverses fonctionnalités pilotées par l'IA pour améliorer votre flux de travail éditorial. Activez ou désactivez les suggestions d'assistant pour les titres, les résumés et les métadonnées, ou activez des options avancées d'édition de contenu telles que la reformulation et l'extension de texte avec des extensions de contenu.`,
          siteLevel: "Ces paramètres s'appliquent uniquement à: ",
          fields: {
            assistantSuggestions: {
              label: "Activer les suggestions de l'assistant",
              description:
                'Activez ou désactivez les suggestions pour les titres, les résumés et les éléments de métadonnées.',
            },
            contentExtensions: {
              label: 'Activer les extensions de contenu',
              description:
                "Activez l'accès à des options avancées d'édition de contenu telles que la reformulation et l'extension de phrases ou de paragraphes à l'aide de la palette de formatage.",
            },
            contentSuggections: {
              label: 'Activer les suggestions de contenu',
              description:
                "Activez ou désactivez les suggestions pour les améliorations de grammaire et d'orthographe du contenu.",
            },
          },
        },
        relatedContentStyles: {
          label: 'Styles de contenu associé',
          help: 'Paramètres pour les styles de contenu associé.',
          addButton: 'Ajouter nouveau',
          updateButton: 'Mettre à jour',
          cancelButton: 'Annuler',
          error: "Une erreur s'est produite.",
          drawer: {
            new: {
              title: 'Ajouter un nouveau style de contenu associé',
            },
            edit: {
              title: 'Modifier le style de contenu associé',
            },
          },
          columns: {
            name: 'Nom du style',
            type: 'Taper',
            edit: 'Modifier le style',
            delete: 'Supprimer le style',
            deleteConfirmation:
              'Êtes-vous sûr de vouloir supprimer ce style de contenu associé ?',
          },
          fields: {
            name: {
              label: 'Nom',
              requiredMsg: 'Requis.',
            },
            type: {
              label: 'Type',
              requiredMsg: 'Le type est requis',
              placeholder: 'Sélectionnez le type',
            },
            default_title: {
              label: 'Titre par défaut',
              invalid: 'Invalide',
            },
            force_title: {
              label: "Forcer l'utilisation du titre par défaut",
              helpText: "Forcer l'utilisation du titre par défaut",
            },
          },
          notifications: {
            deleted: 'Style de contenu associé supprimé.',
            error: 'Erreur lors de la mise à jour du style de contenu associé.',
            deleteError: 'Erreur lors de la suppression du style de contenu associé.',
            success: 'Style de contenu associé enregistré.',
          },
        },
      },
      collection: {
        label: 'Collection',
        add_items:
          "Utilisez la bibliothèque d'actifs pour ajouter des éléments à la collection.",
        insert_or_drag:
          "Insérez ou faites glisser des éléments depuis la bibliothèque d'actifs pour les ajouter à la collection.",
        max_limit: 'Les collections ont un maximum de {{max}} éléments.',
        duplicates: 'Aucun nouvel élément ajouté. (Doublons ignorés : {{count}})',
        selectionLimited: 'La sélection est limitée à {{count}} éléments.',
        selectionLimitedSelectAll: 'Sélection limitée aux {{count}} premiers éléments.',
        added_one: '{{count}} élément ajouté à la collection.',
        added_other: '{{count}} éléments ajoutés à la collection.',
        added_with_duplicates_one:
          '{{count}} élément ajouté à la collection. (Doublons ignorés : {{duplicates}})',
        added_with_duplicates_other:
          '{{count}} éléments ajoutés à la collection. (Doublons ignorés : {{duplicates}})',
        hide_headlines: {
          label: 'Masquer les titres',
          tooltip: 'Masque les titres des éléments enfants.',
        },
        hide_details: {
          label: 'Masquer les détails',
          tooltip:
            'Masque la signature, la légende et autres détails des éléments enfants.',
        },
        upload: {
          label: 'Téléverser dans la collection',
          description: 'Téléversez des fichiers dans cette collection.',
          user_cancel: 'Annulé par l’utilisateur',
          close_warning:
            'Les fichiers téléversés ne seront pas ajoutés à la collection. Les téléversements restants seront annulés.',
          rejected_files: 'Fichier(s) non pris en charge : {{rejectedNames}}',
          untitled_file: 'Fichier sans titre',
          preview_of: 'Aperçu de {{name}}',
        },
      },
      dynamic_collection: {
        label: 'Collection dynamique',
        curated: 'Curée',
        dynamic: 'Dynamique',
        curated_info:
          'Les collections curées sont gérées manuellement ; ajoutez et réorganisez les ressources via la Bibliothèque de ressources.',
        dynamic_info:
          'Les collections dynamiques se mettent à jour automatiquement lorsque de nouveaux contenus correspondent à vos règles de recherche.',
        change_type_header: 'Changer le type de collection ?',
        modify_search: 'Modifier la recherche',
        create_search: 'Créer une recherche',
        search_info:
          'Remplissez automatiquement cette collection avec des ressources correspondant aux critères de recherche.',
      },
      moreActions: {
        button: 'Plus d’actions',
        saveTemplate: 'Enregistrer comme modèle',
        duplicate: 'Dupliquer',
        archive_and_delete_date: 'Date d’archivage et de suppression',
        archive_date: 'Date d’archivage',
        delete_date: 'Date de suppression',
        useTemplate: 'Utiliser le modèle',
        duplicate_disabled: 'Dupliquer désactivé',
        duplicate_failed: 'Échec de la duplication: {{error}}',
        save_template_failed: 'Échec de la sauvegarde du modèle: {{error}}',
        archive: 'Archiver',
        delete: 'Supprimer',
        archiveDeleteForm: {
          successNotify: 'Date de {{action}} du {{recordLabel}} mise à jour avec succès',
          saveSuccessful: 'Enregistrement réussi',
          removeSchedule: 'Supprimer la planification',
          reschedule: 'Replanifier',
          schedule: 'Planifier',
          close: 'Fermer',
          cancel: 'Annuler',
          archiveDate: "Date d'archivage",
          deleteDate: 'Date de suppression',
          archived: 'archivage',
          deleted: 'suppression',
        },
      },
      template: {
        label: 'Ceci est un modèle {{type}}',
        live_view: {
          tooltip: "Les modèles n'offrent pas de vue en direct",
        },
      },
      deleted: {
        banner: 'Cet élément a été supprimé.',
      },
      inline: {
        insert_inline: 'Insérer en ligne',
        placeholder: 'Espace réservé',
        align: 'Aligner',
        width: 'Largeur',
        presentation: 'Présentation',
        displayProperties: {
          alignment: {
            left: 'Gauche',
            center: 'Centre',
            right: 'Droite',
            default: 'Par défaut',
          },
          width: {
            default: 'Par défaut',
            'one-third': 'Un tiers',
            half: 'Moitié',
            'two-thirds': 'Deux tiers',
            full: 'Complet',
          },
          presentation: {
            default: 'Par défaut',
            headline: 'Lien de titre',
            summary: 'Résumé',
            short_summary: 'Résumé court',
            presentation: "Présentation de l'élément",
            parallax: 'Parallaxe',
            fullbleed: 'Pleine page',
            hide_details: 'Masquer les détails',
            player: 'Lecteur multimédia',
            html: 'HTML',
            preview: 'Aperçu',
            download: 'Lien de téléchargement',
            pdf: 'Aperçu PDF',
            poll: 'Sondage',
            mosaic: 'Mosaïque',
            table: 'Tableau',
          },
        },
        article_specific: 'Remplacé',
        asset_value: 'Outrepasser',
        article_specific_tooltip: "Utilisation de la valeur spécifique à l'article",
        asset_value_tooltip: "Utilisation de la valeur originale de l'élément",
        reset_to_asset: "Réinitialiser à la valeur de l'élément {{field}}",
        override_save_reminder:
          "Les personnalisations spécifiques à l'article ont été modifiées. Enregistrez l'article pour appliquer ces modifications.",
      },
      locked: {
        label: 'Contenu verrouillé',
        reason: {
          env: 'Ce contenu est verrouillé dans un autre environnement.',
          user: 'Ce contenu est verrouillé par un autre utilisateur.',
          default: 'Ce contenu est verrouillé.',
        },
        action: {
          force_unlock: {
            label: 'Forcer le déverrouillage dans l’Administrateur Hérité',
            help: 'Cet élément est actuellement en cours d’édition dans l’Administrateur Hérité par {{user}}. Forcer le déverrouillage peut entraîner la perte du travail de l’autre utilisateur. Êtes-vous sûr de vouloir continuer ?',
            success: 'Élément déverrouillé',
            error: 'Erreur lors du déverrouillage de l’élément',
          },
        },
        origin: 'Origine du verrouillage :',
        by: 'Verrouillé par :',
        help: {
          readonly: 'Vous êtes en mode lecture seule',
        },
      },
      toolbar: {
        search_replace: {
          tooltip: 'Rechercher et remplacer',
          find: {
            label: 'Rechercher',
            placeholder: 'Rechercher...',
          },
          replace: {
            label: 'Remplacer',
            placeholder: 'Remplacer par...',
          },
          match_case: 'Respecter la casse',
          match_whole_word: 'Mot entier',
          results: 'Résultats : {{current}} / {{total}}',
          button: {
            previous: 'Précédent',
            next: 'Suivant',
            replace: 'Remplacer',
            replace_all: 'Tout remplacer',
          },
        },
        undo: 'Annuler | Ctrl+Z',
        undo_change: 'annuler la modification',
        redo: 'Rétablir | Ctrl+Y',
        redo_change: 'rétablir la modification',
        heading_level: 'niveau de titre',
        bold: 'Gras | Ctrl+B',
        italic: 'Italique | Ctrl+I',
        underline: 'Souligné | Ctrl+U',
        insert_link: 'Insérer un lien',
        link_to_url: 'Lien vers une URL',
        link_to_asset: 'Lien vers une ressource',
        edit_link: 'Modifier le lien',
        remove_link: 'Supprimer le lien',
        insert_comment: 'Insérer un commentaire',
        edit_comment: 'Modifier le commentaire',
        remove_comment: 'Supprimer le commentaire',
        bullet_list: 'Liste à puces | Ctrl+Shift+8',
        bullet_list_aria: 'liste à puces',
        numbered_list: 'Liste numérotée | Ctrl+Shift+7',
        horizontal_rule: 'Ligne horizontale',
        horizontal_rule_aria: 'ligne horizontale',
        page_break: 'Saut de page',
        page_break_aria: 'saut de page',
        inline_note: 'Note intégrée',
        omitted_from_published: 'Sera omis du contenu publié',
        print_trim: "Suppression d'impression",
        trim_from_print: "Supprimer de l'impression",
        omitted_from_print: 'Sera omis du contenu imprimé',
        block_quote: 'Bloc de citation',
        table: 'Tableau',
        more: 'Plus',
        open_more_options: "Ouvrir plus d'options",
        widgetselect: {
          dividers: {
            utilities: 'Utilitaires',
            headlines: 'Titres',
          },
          inline_assets: {
            insert_type: 'Insérer {{type}}',
            image: 'Image',
            audio: 'Audio',
            video: 'Vidéo',
            link: 'Lien',
            html: 'HTML',
            file: 'Fichier',
            open_asset_in_new_window: 'Ouvrir la ressource dans une nouvelle fenêtre',
          },

          plaintext: {
            label: 'Coller en texte brut',
            description: 'Insérer le contenu du presse-papiers en texte brut.',
            error: 'Erreur lors du collage en texte brut.',
            empty: 'Le presse-papiers est vide.',
          },
        },
      },
      syndication: {
        actions: {
          add_to_site: 'Ajouter au site',
          view_original: 'Voir loriginal',
          view_remote: 'Voir la ressource distante',
          cancel: 'Annuler',
          save: 'Enregistrer',
          add_rules: 'Ajouter des règles',
          update_rules: 'Mettre à jour les règles',
        },
        channels: {
          label: 'Canaux',
          confirm_delete: {
            help: "Êtes-vous sûr de vouloir supprimer le canal {{channel}} de l'actif ?",
          },
        },
        labels: {
          category_map: 'Carte de catégorie',
          category_map_for: 'Carte de catégorie pour {{name}}',
          channel_category_map_for: 'Carte de catégorie de canal pour {{name}}',
          channels: 'Canaux',
          channels_info: "Vous permet d'accéder et de gérer les flux de syndication.",
          add_channel: 'Ajouter un canal',
          settings: 'Paramètres des chaînes',
          select_driver: 'Sélectionner le pilote',
          choose_categories: 'Choisissez une ou plusieurs catégories de canal...',
          categories: 'Catégories',
          categories_hint: 'Appuyez sur Entrée ou Tab pour ajouter',
          choose_sections: 'Choisissez les sections du site pour les associer...',
          sections: 'Sections',
          rules_info:
            "Les règles ci-dessous seront utilisées pour convertir les catégories de canal en sections lorsque des actifs sont ajoutés à votre site. La règle d'une catégorie parente sera utilisée pour tous ses enfants qui ne sont pas présents dans leurs propres règles.",
          no_rules: 'Catégorie non mappée ou actif non catégorisé',
        },
        errors: {
          select_category: 'Veuillez sélectionner au moins une catégorie',
          select_section: 'Veuillez sélectionner au moins une section',
        },
        notifications: {
          channel_config_updated: 'Configuration du canal mise à jour',
          channel_config_created: 'Configuration du canal créée',
          category_map_deleted:
            'Carte de catégorie pour la configuration {{name}} supprimée',
          category_map_updated:
            'Carte de catégorie pour la configuration {{name}} mise à jour',
          failed_to_edit_setting: 'Échec de la modification du paramètre : {{error}}',
          error: 'Erreur : {{error}}',
        },
      },
      save: {
        successful: 'Enregistrement réussi',
      },
      buttons: {
        save_workflow_actions: 'Enregistrer et actions de workflow',
      },
      status: {
        published: {
          label: 'Publié',
          label_alt: 'Publier',
          description: 'Le contenu est en ligne et disponible',
        },
        draft: {
          label: 'Brouillon',
          description: 'Travail en cours',
        },
        scheduled: {
          label: 'Planifié',
          description: 'Prévu pour être publié à une date ultérieure',
          scheduled_date: 'Prévu pour être publié le {{date}}',
        },
        unpublished: {
          label: 'Non publié',
          label_alt: 'Ne pas publier',
          description: 'Retiré de la publication',
        },
        processing: {
          label: 'Traitement en cours',
          description: 'Le contenu est en cours de traitement',
        },
        deleted: {
          label: 'Supprimé',
          description: 'Le contenu a été supprimé',
        },
        unpublished_changes: {
          label: 'Modifications non publiées',
          description: 'Publié avec des brouillons en attente',
        },
      },
    },
    static: {
      label: 'Statique (sans ressources)',
    },
    urlmap: {
      label: 'Constructeur de pages',
      input: {
        label: "Plan d'URL",
        help: "Sélectionnez un plan d'URL",
      },
      actions: {
        add_url: 'Ajouter une URL enfant',
        set_skin: "Définir la peau de l'URL",
        inherit_skin: 'Hériter de la peau du parent',
        confirm_delete: {
          label: 'Confirmer la suppression',
          help: 'Êtes-vous sûr de vouloir supprimer cette URL ? Cette action est irréversible.',
        },
        restore_alias: {
          label: 'Restaurer',
          help: "Restaurer la valeur de l'URL de redirection",
        },
        search: {
          label: 'Rechercher des pages',
        },
        cancel_alias: {
          label: 'Annuler la redirection',
          help: 'Annuler et revenir à la modification',
        },
        filter: {
          label: 'Filtrer les résultats',
          alias: 'Redirections uniquement',
          application: 'Filtrer par application',
        },
      },
      customizations: {
        label: 'Personnalisations de la page',
        notifications: {
          saved: 'Les personnalisations de la page ont été enregistrées avec succès',
          error: 'Erreur lors de l’enregistrement des personnalisations de la page',
          reset:
            'Les personnalisations de la page ont été réinitialisées aux valeurs précédentes',
          empty: 'Aucune personnalisation de page disponible',
        },
        confirmations: {
          reload: {
            title: 'Modifications non enregistrées',
            message:
              'Vous avez des personnalisations de page non enregistrées sur cette page. Êtes-vous sûr de vouloir recharger et perdre ces modifications ?',
            confirm: 'Recharger quand même',
          },
          navigation: {
            title: 'Modifications non enregistrées',
            message:
              'Vous avez des personnalisations de page non enregistrées. Voulez-vous continuer sans enregistrer ?',
            confirm: 'Continuer',
          },
        },
        validation: {
          invalid_before_saving:
            'Veuillez corriger les valeurs invalides avant d’enregistrer.',
        },
      },
      properties: {
        label: 'Propriétés de la page',
      },
      map: {
        name: {
          label: 'Nom de la carte',
        },
        global: {
          label: 'Peau globale',
          help: 'Définir la peau globale',
        },
        template_library: {
          label: 'Bibliothèque de modèles',
        },
      },
      node: {
        label: 'Propriétés de la page',
        name: {
          label: 'Nom',
          description: "Le nom de l'URL.",
          help: 'Le nom est requis',
        },
        app: {
          label: 'Application',
        },
        alias: {
          label: 'URL de redirection',
          short_label: 'Redirection',
          help: "L'URL de redirection est requise",
          warning:
            "Définir une URL de redirection peut entraîner la perte du placement des blocs de cette page et d'autres paramètres.",
        },
        title: {
          label: 'Titre de la page',
          description:
            "Une phrase succincte et lisible par l'homme pour décrire cette page que les moteurs de recherche utilisent pour déterminer la pertinence de la page, augmentant ainsi votre classement.",
        },
        node_label: {
          label: 'Étiquette',
          description:
            'Un mot ou une phrase descriptif très court qui décrit cette page et qui peut contribuer à la détermination de la pertinence par les moteurs de recherche.',
        },
        parent: {
          label: 'URL parent',
        },
        allow_archiving: {
          label: "Autoriser l'archivage",
        },
        prevent_indexing: {
          label: "Empêcher l'indexation",
        },
        searchable: {
          label: 'Recherchable',
        },
        template: {
          label: 'Peau',
        },
      },
      help: {
        select_view: 'Sélectionnez une URL à afficher.',
        select_edit: 'Sélectionnez une URL à modifier.',
        no_results: 'Aucune URL retournée.',
        redirects_to: 'Cette page redirige vers',
      },
    },
    dashboards: {
      label: 'Tableaux de bord',
      titles: {
        default: 'Tableau de bord',
        editorial: 'Tableau de bord éditorial',
        subscription: 'Tableau de bord utilisateur',
        emailreach: 'Tableau de bord des campagnes',
        journeys: 'Tableau de bord des parcours',
      },
      table: {
        no_data: 'Aucune donnée',
        rows_per_page: 'Lignes par page :',
        of: 'sur',
        more_than: 'plus de',
      },
      errors: {
        error: 'Une erreur inconnue est survenue.',
        noData: 'Aucune donnée disponible.',
      },
      exports: {
        title: 'Exporter en CSV',
        description:
          'Les données exportées correspondront aux filtres actuellement appliqués.',
        description_all: 'Toutes les données seront exportées.',
        button: 'Exporter le CSV',
        download: "Démarrer l'exportation",
        download_started:
          'Votre exportation CSV est en cours de préparation et le téléchargement commencera sous peu.',
        export_started: 'Exportation CSV démarrée',
        export_failed: "Échec de l'exportation CSV",
        preparing: 'Préparation de votre exportation CSV...',
        error:
          'Une erreur est survenue lors de la préparation de votre exportation CSV. Veuillez réessayer.',
        table_field: {
          label: 'Spécifiez la quantité de données à exporter :',
          all: 'Toutes les lignes',
          25: '25 premières lignes',
          50: '50 premières lignes',
          100: '100 premières lignes',
        },
      },
      needHelp: {
        header: 'Besoin d’aide?',
        subtitle: 'Vous êtes au bon endroit.',
        title: 'Commencer',
        resources: 'Ressources',
        bloxUniversity: {
          title: 'Université BLOX',
          subtitle: 'Parcourez nos cours de formation vidéo',
        },
        documentation: {
          title: 'Documentation',
          subtitle: 'Parcourez notre documentation',
        },
        support: {
          title: 'Support',
          subtitle:
            "Obtenez de l'aide pour résoudre un problème ou consultez vos demandes",
        },
        updates: {
          title: 'Quoi de neuf dans BLOX NXT',
          subtitle: 'Découvrez les dernières mises à jour et améliorations du produit',
        },
      },
      kpis: {
        trend_sprites: {
          up: 'En hausse par rapport à {{priorValue}}',
          down: 'En baisse par rapport à {{priorValue}}',
          neutral: 'Aucun changement par rapport à la période précédente',
        },
        kpi_bar: {
          filters: {
            title: 'Filtres',
            description:
              'Appliquez des filtres pour mettre à jour les données affichées dans ce ticker.',
          },
        },
      },
      charts: {
        funnel: {
          percent_diff: '{{percent}}% {{direction}} par rapport au précédent',
        },
      },
      loading_chip: {
        live: 'En direct',
        live_on:
          'Mises à jour en direct ACTIVÉES - Actualisation toutes les {{refresh}} secondes',
        live_off:
          'Mises à jour en direct DÉSACTIVÉES - Actualisation toutes les {{refresh}} secondes',
        updating: 'Mise à jour',
        error: 'Erreur',
        refresh: 'Mise à jour toutes les {{refresh}} minutes',
        min15: 'Mises à jour toutes les 15 minutes',
        min30: 'Mises à jour toutes les 30 minutes',
        hour: 'Mises à jour toutes les heures',
        off: 'DÉSACTIVÉ',
      },
      mask: {
        title: 'Déverrouiller les analyses de {{title}}',
        gen_title: 'Déverrouiller les analyses',
        dashboard: 'Déverrouiller les analyses',
        description:
          'Accédez à des analyses et des insights détaillés avec notre module complémentaire Analytics.',
        tooltip: 'Disponible avec le forfait Pro DataInsights.',
      },
      controls: {
        error: "Impossible d'appliquer les filtres.",
        success: 'Succès, mise à jour des données du tableau de bord',
        filters_tip:
          'Utilisez les filtres pour personnaliser les données affichées sur le tableau de bord. Les options de filtre peuvent varier selon le widget.',
        filters_warning: 'Tous les widgets ne prennent pas en charge ces filtres.',
      },
      widgets: {
        applied_filters: 'Filtres appliqués : {{count}}',
        widget_has_custom_parameters:
          'Ce widget est configuré avec des filtres spécifiques.',
        dashboard_filters_may_not_apply:
          "Les filtres du tableau de bord ne s'appliqueront pas.",
        filters: 'filtres',
        filter: 'filtre',
        the: 'Les',
        do_not_apply: "ne s'appliquent pas",
        does_not_apply: "ne s'applique pas",
        to_this_widget: 'à ce widget.',
        filters_still_apply: "filtres s'appliquent toujours.",
        filter_still_applies: "filtre s'applique toujours.",
        all_other_filters_applied: 'Tous les autres filtres ont été appliqués.',
        locked_widget: 'Widget verrouillé',
        filter_info: 'Informations sur les filtres',
      },
      user_permissions: {
        title: 'Autorisations manquantes',
        description:
          'Vous n’avez actuellement pas accès pour voir ce tableau de bord. Contactez votre administrateur de compte pour demander l’accès.',
      },
      custom_dashboards: {
        search: {
          title: 'Titre',
          status: 'Statut',
          publish: 'Public',
          private: 'Privé',
          created_by: 'Créé par',
          columns: {
            title: 'Nom du tableau de bord',
            status: 'Statut',
            created_by: 'Créé par',
          },
          app: {
            label: 'Application',
            placeholder: 'Sélectionnez une application',
            options: {
              editorial: 'Éditorial',
              community: 'Communauté',
            },
          },
          name: {
            label: 'Nom du tableau de bord',
            placeholder: 'Entrez le nom du tableau de bord',
          },
          type: {
            all: {
              label: 'Tous',
              desc: 'Tous les tableaux de bord auxquels vous avez accès',
            },
            public: {
              label: 'Public',
              desc: 'Disponible pour tous les utilisateurs',
            },
            private: {
              label: 'Privé',
              desc: 'Visible uniquement pour vous',
            },
          },
        },
        edit: {
          title: 'Modifier le tableau de bord : {{dashboardName}}',
          title_disabled:
            'Activez la modification pour changer le nom du tableau de bord',

          success: 'Tableau de bord mis à jour avec succès',
          error: 'Erreur lors de la mise à jour du tableau de bord. Veuillez réessayer.',
          label: 'Modifier le titre du tableau de bord',
          close_btn: 'Quitter le mode édition et prévisualiser le tableau de bord',
          configure_widget: 'Configurer le widget - Bientôt disponible',
          change_layout: 'Changer la mise en page',
          column_empty_msg:
            "Faites glisser un widget dans cette colonne pour l'ajouter à votre tableau de bord",
          cancel_title: 'Vous avez des modifications non enregistrées',
          cancel_confirmation:
            'Vous avez des modifications non enregistrées. Êtes-vous sûr de vouloir les abandonner et quitter le mode édition ?',
          save_success: 'Tableau de bord enregistré avec succès',
          save_error: "Échec de l'enregistrement du tableau de bord",
          changes_discarded: 'Modifications abandonnées',
          module: {
            modify: 'Configurer le widget',
            remove_confirm: 'Supprimer le widget?',
            remove_msg:
              'Êtes-vous sûr de vouloir supprimer "{{widgetTitle}}" du tableau de bord?',
            tooltip:
              "Modifiez les filtres du tableau de bord, tels que la plage de dates, le nom d'hôte, etc.",
            save_error:
              'Erreur lors de la sauvegarde de la configuration du widget. Veuillez réessayer.',
            save_success: 'Configuration du widget enregistrée avec succès',
            display_type: "Type d'affichage",
            display_type_help:
              'Sélectionnez comment vous souhaitez afficher les données de ce widget',
          },
        },
        create: {
          title: 'Créer un tableau de bord',
          success: 'Tableau de bord créé avec succès',
          error: 'Erreur lors de la création du tableau de bord. Veuillez réessayer.',
          form: {
            title: {
              req: 'Le titre est obligatoire.',
              min: 'Le titre doit contenir au moins 3 caractères.',
              label: 'Titre du tableau de bord',
              placeholder: 'Entrez le titre du tableau de bord',
            },
            select_layout: 'Sélectionner la mise en page',
          },
        },
        duplicate: {
          title: 'Dupliquer le tableau de bord',
          success: 'Tableau de bord dupliqué avec succès',
          error: 'Erreur lors de la duplication du tableau de bord. Veuillez réessayer.',
          form: {
            title: {
              req: 'Le titre est obligatoire.',
              max: 'Le titre ne peut pas dépasser 140 caractères.',
              min: 'Le titre doit contenir au moins 3 caractères.',
              label: 'Titre du tableau de bord',
              placeholder: 'Entrez le titre du tableau de bord',
            },
            duplicate_restrictions: {
              label: "Dupliquer les restrictions d'accès",
              caption:
                'Copiez les utilisateurs et groupes qui peuvent voir ce tableau de bord.',
            },
            copy_suffix: {
              placeholder: 'Copie de {{title}}',
            },
          },
        },
        widget_library: {
          title: 'Bibliothèque de widgets',
          desc: 'Cliquez pour ajouter ou glissez les w`idgets sur votre tableau de bord',
          coming_soon:
            "Remarque : L'intégration de la bibliothèque de widgets est en développement (CMSADMIN-721)",
          search_placeholder: 'Rechercher des widgets...',
          drag_help:
            'Faites glisser les widgets sur votre tableau de bord pour les ajouter',
          save_success: 'Widget ajouté avec succès',
          save_error: "Échec de l'ajout du widget, veuillez réessayer",
          drag_success: 'Widget déplacé avec succès',
          drag_error: 'Impossible de déplacer le widget, veuillez réessayer',
          delete_success: 'Widget supprimé',
          delete_error: 'Impossible de supprimer le widget, veuillez réessayer',
        },
        no_access: {
          header: 'Application non activée',
          details:
            "Le domaine sélectionné n'a actuellement pas accès à cette application.",
          contact: "Veuillez contacter votre administrateur pour plus d'informations.",
          not_owner_header: 'Accès refusé',
          not_owner_details:
            'Vous ne pouvez modifier que les tableaux de bord personnalisés que vous possédez. Ce tableau de bord appartient à un autre utilisateur.',
        },
        errors: {
          loading: 'Erreur lors du chargement du tableau de bord. Veuillez réessayer.',
        },
      },
      alerts: {
        label: 'Alertes',
        set_alert: 'Définir une alerte pour {{widgetTitle}}',
        manage_alerts: 'Gérer les alertes pour {{title}}',
        create_alert: 'Créer une alerte pour {{title}}',
        edit_alert: "Modifier l'alerte pour {{title}}",
        create_new: 'Créer une nouvelle alerte',
        cadence: 'Cadence',
        domains: 'Domaines',
        no_more_alerts: "Plus d'alertes",
        form: {
          when_the: 'Quand le ',
          of: 'de',
          when_value_of_prefix: 'Quand la valeur de ',
          when_value_of_suffix: ' est : ',
          description:
            'Configurez des alertes pour surveiller les indicateurs clés de performance et recevez des notifications lorsque des seuils spécifiques sont atteints, permettant des décisions et des actions opportunes.',
        },
        delete: {
          title: "Supprimer l'alerte ?",
          warning:
            'Êtes-vous sûr de vouloir supprimer cette alerte ? Cette action ne peut pas être annulée.',
        },
        success: {
          create: 'Alerte créée avec succès',
          update: 'Alerte mise à jour avec succès',
          delete: 'Alerte supprimée avec succès',
        },
        errors: {
          no_alerts: 'Aucune alerte définie',
          no_fields: 'Impossible de créer une alerte',
        },
      },
    },
    dynamic_fields: {
      image: {
        dropzone: {
          subtitle: "Déposez l'image ici",
          caption:
            "Faites glisser et déposez l'image ou cliquez pour parcourir les fichiers",
          uploading: 'Téléchargement...',
        },
      },
    },
    block_manager: {
      block_library: {
        label: 'Bibliothèque de blocs',
      },
      duplicate_block: {
        label: 'Dupliquer le bloc',
        success: 'Bloc dupliqué avec succès',
        error: 'Échec de la duplication',
      },
      copy_block: {
        error_no_template_library_for_domain:
          'Bibliothèque de modèles introuvable pour ce domaine',
        error_template_library_mismatch:
          "Incompatibilité de bibliothèque de modèles sur la carte d'URL active",
        error_fetch_all_sites: 'Échec de la récupération de tous les sites',
        error_invalid_domain: 'Domaine invalide',
        error_no_active_url_map: 'Aucune carte d’URL active trouvée',
        error_fetch_url_map: 'Échec de la récupération de la carte d’URL',
        error_missing_ids: 'ID de carte ou ID de bloc manquant',
        label: 'Copier vers le site',
        site_select: 'Sélectionner les sites vers lesquels copier',
        target_sites_label: 'Sites cibles',
        no_target_sites:
          'Aucun autre site disponible pour la copie. Vous êtes actuellement sur {{site}}, qui est le seul site auquel vous avez accès.',
        processing_progress: 'Traitement de {{count}} sites... {{progress}}',
        processing_progress_one: 'Traitement de {{count}} site... {{progress}}',
        retryable_errors_summary: '{{count}} sites ont échoué au traitement',
        retryable_errors_summary_one: '{{count}} site a échoué au traitement',
        summary: 'Copié avec succès vers {{success}} sur {{total}} sites.',
        summary_one: 'Copié avec succès vers {{total}} site.',
        summary_error: '{{error}} sites n’étaient pas compatibles.',
        summary_error_one: '{{error}} site n’était pas compatible.',
        site_header: 'Site',
        status_header: 'Statut',
        confirm_close_title: 'Êtes-vous sûr de vouloir fermer ?',
        confirm_close_content: 'Toutes les copies non encore traitées seront annulées.',
        confirm_copy_header: 'Confirmer la copie du bloc',
        confirm_copy_sub_text_one: 'Copier ce bloc vers {{count}} site',
        confirm_copy_sub_text_other: 'Copier ce bloc vers {{count}} sites.',
        confirm_copy_sub_text_all: 'Copier ce bloc vers tous les sites.',
        confirm_copy_button: 'Oui, Copier',
      },
      create_block: {
        label: 'Créer un nouveau bloc',
        app_not_installed: 'Application requise non installée',
      },
      edit_block: {
        label: 'Modifier le bloc {{type}} n°{{id}}',
        loading: 'Chargement des données du bloc...',
        error: 'Erreur lors de l’enregistrement du bloc',
        fail: 'Échec du chargement des données du bloc',
        validation: {
          name_required: 'Le nom du bloc est requis',
        },
      },
      delete_block: {
        label: 'Supprimer le bloc',
        confirm:
          'Êtes-vous sûr de vouloir supprimer ce bloc ? Cette action est irréversible.',
        success: 'Bloc supprimé avec succès',
        error: 'Échec de la suppression du bloc',
      },
      unsaved_changes: {
        title: 'Modifications non enregistrées',
        message:
          'Vous avez des modifications de mise en page de blocs non enregistrées. Voulez-vous enregistrer ces modifications avant de quitter ?',
      },
      place_block: {
        label: 'Placer le bloc',
        help: 'Veuillez sélectionner des blocs à placer depuis la bibliothèque de blocs',
        status: 'Placée',
      },
      search_blocks: {
        label: 'Rechercher des blocs',
        empty: 'Aucun bloc trouvé',
        filter: {
          label: 'Options de filtrage',
          options: {
            all: 'Tous',
            app_business: 'app : Affaires',
            app_calendar: 'app : Calendrier',
            app_classifieds: 'app : Petites annonces',
            app_editorial: 'app : Éditorial',
            app_electionstats: 'app : Statistiques électorales',
            app_eedition: 'app : e-Édition',
            app_static: 'app : Blocs statiques',
            placed_yes: 'Placés : Oui',
            placed_no: 'Placés : Non',
            sort_name_asc: 'Trier : Nom (croissant)',
            sort_date_created_desc: 'Trier : Date créée (décroissant)',
            sort_date_modified_desc: 'Trier : Date modifiée (décroissant)',
          },
        },
      },
      query_results: {
        label: 'Résultats de la requête',
        empty: 'Aucun résultat retourné',
        actions: {
          pin: {
            label: 'Épingler un actif',
            description: 'Ne pas désépingler automatiquement',
            help: "L'actif restera épinglé jusqu'à ce qu'il soit désépinglé manuellement.",
          },
          pin_multiple: {
            label: 'Épingler des actifs',
          },
          unpin: {
            label: 'Désépingler un actif',
          },
          pin_options: 'Options des actifs épinglés',
          schedule_unpin: {
            label: 'Planifier le désépinglage',
            description: 'Désépingler un actif à une date et une heure spécifiques',
          },
          edit: {
            help: {
              draft_no_publish:
                "Note: Cet actif est un brouillon et ne peut pas être modifié. Veuillez publier l'actif pour activer la modification.",
            },
          },
          override_display: {
            label: "Remplacer l'affichage",
            toggle: {
              label: "Remplacer les propriétés d'affichage",
              description: 'Cochez pour activer les remplacements',
              description_off: 'Décochez pour utiliser les valeurs des actifs',
            },
            fields: {
              title: {
                label: 'Titre',
                description: 'Entrez un remplacement pour le titre de cet actif',
                help: 'Le titre est requis',
              },
              summary: {
                label: 'Résumé',
                description: 'Entrez un remplacement pour le résumé de cet actif',
              },
            },
          },
        },
      },
      query_rules: {
        label: 'Règles de requête',
        add: 'Ajouter une règle de requête',
        help: 'Sélectionnez la règle de requête à appliquer',
        empty: 'Aucune règle de requête définie',
      },
      query_size: {
        label: 'Modifier la taille de la requête',
        first_result: 'Premier résultat',
        max_results: 'Nombre maximum de résultats',
        tooltip_first_result: 'Définir le résultat de départ',
        tooltip_max_results: 'Définir le nombre maximum de résultats à afficher',
        error_first_result: 'La valeur doit être supérieure à 0',
        error_max_results: 'La valeur doit être comprise entre 1 et 50',
      },
      sort_rules: {
        label: 'Règles de tri',
        add: 'Ajouter une règle de tri',
        help: 'Sélectionnez la règle de tri à appliquer',
        empty: 'Aucune règle de tri définie',
        random: {
          label: 'Trier aléatoirement',
          help: 'Les éléments seront triés aléatoirement.',
        },
        direction: 'Direction',
      },
      customizations: {
        label: 'Personnalisations',
        search: 'Rechercher des personnalisations',
        loading: 'Chargement des options d’apparence...',
        error: 'Erreur lors du chargement des options d’apparence',
      },
      block_title: {
        label: 'Titre du bloc',
        help: 'Entrez le titre du bloc',
      },
      block_title_link: {
        label: 'URL du lien du titre',
        help: 'Entrez une URL pour lier le titre',
        new_window: 'Ouvrir le lien dans une nouvelle fenêtre',
        error: 'Entrez une URL valide (https://example.com)',
      },
      links: {
        label: 'Liens',
        empty: 'Aucun lien saisi',
        help: 'Ajouter un nouveau lien',
        help_edit: 'Modifier le lien',
        options: {
          use_url_map: {
            label: 'Sélectionner depuis la carte de la page',
          },
        },
        fields: {
          link_label: {
            label: 'Étiquette',
            help: 'Entrez l’étiquette du lien',
          },
          link_url: {
            label: 'URL',
            help: 'Entrez l’URL pour le lien',
            error_duplicate: 'Ce lien existe déjà tel qu’il est saisi',
            error_invalid: 'Entrez une URL valide (https://exemple.com)',
          },
        },
      },
      configuration: {
        label: 'Configuration',
        fields: {
          name: {
            label: 'Nom du bloc',
            description: 'Saisissez un nom de bloc',
            help: 'Le nom du bloc est requis',
          },
          description: {
            label: 'Description',
            description: 'Saisissez une description pour le bloc',
          },
          tag: {
            label: 'Ajouter un tag',
            description: 'Saisissez des tags pour le bloc',
          },
        },
        help: 'Sélectionnez la configuration à appliquer',
        empty: 'Aucune configuration définie',
      },
      css_classes: {
        label: 'Classes CSS',
        help: 'Accepte plusieurs classes',
        count: '{{count}} au total',
      },
      block_preview: { label: 'Aperçu du bloc' },
      block_usage: {
        label: 'Utilisation du bloc',
        empty: 'Ce bloc n’est actuellement utilisé sur aucune page.',
      },
      template: {
        label: 'Modèle',
        selected: 'Modèle sélectionné',
        loading: 'Chargement des options de modèle...',
        not_found: 'Aucun modèle {{app}} trouvé pour « {{search}} »',
      },
      application: {
        label: 'Type de bloc',
        no_edit: 'Le type de bloc ne peut pas être modifié',
      },
    },
    region_manager: {
      page_rendering_failures: 'Des erreurs de rendu de page se sont produites.',
      region: {
        label: 'Régions de la page',
        options: 'Options',
        add_blocks: 'Ajouter des blocs',
        disinherit_blocks: 'Desheriter les blocs',
        inherit_blocks: 'Heriter les blocs',
        unlock_region: 'Debloquer la region',
        lock_region: 'Verrouiller la region',
        thumbnail_alt: 'Miniature de region',
        full_size_image_alt: 'Image en taille reelle',
        search: {
          label: 'Rechercher des régions',
          no_results: 'Aucun bloc ou région trouvé',
        },
        filter: {
          label: 'Filtrer les régions',
          description: 'Afficher les régions contenant des blocs de :',
        },
      },
      utility_region: {
        label: 'Régions utilitaires',
        ungrouped: 'Sans groupe',
        block_count_one: '{{count}} bloc',
        block_count_other: '{{count}} blocs',
      },
      navigation_region: {
        label: 'Régions de navigation',
        search: {
          label: 'Rechercher dans la navigation',
        },
      },
    },
    state: {
      disabled: 'Désactivé',
      enabled: 'Activé',
    },
    email_reach: {
      actions: {
        new: 'Nouveau',
        reconnect: 'Reconnecter le fournisseur de service e-mail',
      },
      common: {
        lists: 'Listes',
        default: 'Par défaut',
        status: {
          label: "Statut de l'abonnement",
          active: 'Abonné',
          unsubscribed: 'Désabonné',
        },
      },

      // Search functionality
      search: {
        title: 'Recherche Email Reach',
        contact_lists: 'Listes de contacts',
        loading: 'Chargement des listes de contacts...',
        loading_contacts: 'Chargement des contacts...',
        loading_messages: 'Chargement des messages...',
        loading_campaigns: 'Chargement des campagnes...',
        no_results: 'Aucune liste de contacts trouvée',
        error: 'Erreur lors du chargement des listes de contacts',
        label: 'Rechercher un contact spécifique...',
        placeholder: 'Rechercher des listes de contacts...',
        kpi_bar: {
          date_range: 'Changer la plage de dates',
          start: 'Début',
          end: 'Fin',
        },
      },

      // Account management
      account: {
        loading: 'Chargement des comptes...',
        error: 'Erreur lors du chargement des comptes',
        empty:
          'Aucun compte disponible. Veuillez créer un compte ESP pour utiliser cette fonctionnalité.',
        placeholder: 'Sélectionner un compte',
        aria_label: 'Sélectionner un compte EmailReach',
        creating: 'Création du compte…',
        notifications: {
          connected: 'Compte ESP connecté avec succès !',
          create_failed: 'Échec de la création du compte : {{error}}',
        },
        defaults: {
          account_name: 'Mon compte ESP',
        },
        table: {
          name: 'Nom',
          provider: "Fournisseur d'e-mail",
          default: 'Par défaut',
        },
        connect_modal: {
          header: 'Connecter un compte de service e-mail',
          section: {
            account_information: 'Informations sur le compte',
          },
          fields: {
            account_name: {
              label: 'Nom du compte',
              placeholder: 'Saisissez un nom reconnaissable',
              help: 'Ce nom vous aidera à identifier cette connexion dans votre tableau de bord',
            },
            email_provider: {
              label: "Fournisseur d'e-mail",
              placeholder: "Sélectionnez un fournisseur d'e-mail",
              help: 'Sélectionnez le service e-mail que vous souhaitez connecter',
              no_vendors: 'Aucun fournisseur disponible',
            },
          },
          alert_redirect:
            'Vous serez redirigé vers {{vendor}} pour autoriser cette connexion.',
          error_loading_vendors:
            'Échec du chargement des fournisseurs. Veuillez réessayer.',
          connect_button: 'Connecter le compte',
        },
      },

      // Account dropdown
      account_dropdown: {
        label: 'Compte',
        tooltip: 'Sélectionner un compte Email Reach',
        switch_account: 'Changer de compte',
      },

      // Pre-search content
      pre_search: {
        welcome: 'Bienvenue sur Email Reach',
        select_account: 'Sélectionnez un compte pour voir les listes de contacts',
        getting_started: 'Commencer',
      },

      // Contact management
      contact: {
        modal: {
          create_title: 'Créer un nouveau contact',
          edit_title: 'Modifier le contact',
          loading_contact: 'Chargement du contact...',
          initializing: 'Initialisation...',
        },
        fields: {
          email: {
            from_email: 'Adresse e-mail de réponse',
            label: 'Adresse e-mail',
            required: "L'e-mail est requis",
            invalid: 'Entrez un e-mail valide',
            email_optional_replies:
              'Adresse e-mail de réponse facultative pour que les destinataires puissent répondre',
          },
          first_name: {
            label: 'Prénom',
            placeholder: 'Jean',
          },
          last_name: {
            label: 'Nom de famille',
            placeholder: 'Dupont',
          },
          lists: {
            label: 'Listes de contacts',
            placeholder: 'Sélectionner les listes de contacts...',
            help: 'Ajouter ce contact à une ou plusieurs listes (optionnel)',
          },
        },
        actions: {
          create: 'Créer le contact',
          update: 'Mettre à jour le contact',
          creating: 'Création en cours…',
          updating: 'Mise à jour en cours…',
          delete: {
            title: 'Supprimer le contact',
            warning: 'Cette action ne peut pas être annulée.',
          },
        },
        subscription: {
          toggle_label: 'Abonnement aux e-mails',
          toggle_helper:
            'Définissez si ce contact doit recevoir les e-mails Constant Contact.',
          button_unsubscribe: 'Désinscrire le contact',
          button_resubscribe: 'Réinscrire le contact',
          status_active:
            "Désinscrivez globalement cet utilisateur de tous les e-mails envoyés par vous en tant qu'expéditeur. Cette action ne peut pas être annulée dans Email Reach.",
          status_unsubscribed:
            'Ce contact est désinscrit globalement. Cliquez ci-dessous pour envoyer un e-mail de confirmation de réabonnement.',
          description:
            'La désinscription arrête les e-mails Constant Contact tout en conservant les appartenances aux listes.',
          resubscribe_tooltip:
            'Un e-mail de confirmation sera envoyé au contact. Il doit confirmer avant de recevoir à nouveau des e-mails.',
          resubscribe_lists_helper:
            'Sélectionnez au moins une liste avant de tenter de réinscrire ce contact.',
          errors: {
            no_lists:
              'Sélectionnez au moins une liste avant de tenter de réinscrire ce contact.',
          },
        },
        resubscribe_modal: {
          header: 'Confirmer le réabonnement',
          title: 'Réinscrire le contact',
          description:
            'La réinscription enverra un e-mail de confirmation à ce contact. Il doit cliquer sur le lien de confirmation avant de pouvoir recevoir des e-mails à nouveau.',
          impact_notice:
            "Le contact recevra un e-mail de confirmation et doit confirmer explicitement avant d'être réinscrit. Son statut d'abonnement sera affiché comme en attente jusqu'à confirmation.",
          consent_checkbox:
            'Je confirme que cet utilisateur a explicitement demandé à être réinscrit et a donné son consentement pour recevoir des e-mails.',
          confirm_button: "Envoyer l'e-mail de réabonnement",
        },
        notifications: {
          created: 'Contact créé avec succès',
          updated: 'Contact mis à jour avec succès',
          deleted: 'Contact supprimé avec succès',
          unsubscribed: 'Contact désinscrit avec succès',
          resubscribed:
            'E-mail de réabonnement envoyé avec succès. Le contact doit confirmer pour terminer le réabonnement.',
        },
        errors: {
          no_account: 'Aucun identifiant de compte',
          no_account_selected: 'Aucun compte e-mail sélectionné.',
          not_found: 'Contact non trouvé',
          load_failed: 'Échec du chargement du contact',
          create_failed: 'Échec de la création du contact',
          update_failed: 'Échec de la mise à jour du contact',
          delete_failed: 'Échec de la suppression du contact',
          missing_ids: 'Identifiants manquants',
          name_max_length: 'Doit contenir au maximum {{max}} caracteres',
          unknown: 'Erreur inconnue',
          subscription_failed: "Échec de la mise à jour du statut d'inscription",
        },
        lists: {
          no_lists_available: 'Aucun domaine disponible',
          loading_more: 'Chargement de plus…',
          all_loaded_prefix: 'Toutes les listes chargées',
          total: 'au total',
          unnamed: 'Liste sans nom',
        },
        table: {
          email: 'Adresse e-mail',
          first_name: 'Prénom',
          last_name: 'Nom de famille',
        },
      },

      export: {
        button: 'Exporter',
        preparing: 'Préparation…',
        queued: 'Export demandé. Préparation du téléchargement…',
        success: 'Export de contacts téléchargé.',
        failed: 'Impossible d’exporter les contacts.',
        timeout: 'L’export prend plus de temps que prévu. Veuillez réessayer.',
        account_required: 'Sélectionnez un compte pour exporter des contacts.',
        list_required: 'Sélectionnez une liste pour exporter des contacts.',
        single_list: 'Exportez une seule liste à la fois.',
        default_title: 'Exportation des contacts Email Reach',
        menu_label: 'Contacts Email Reach',
      },

      // Contact list management
      contact_list: {
        modal: {
          create_title: 'Créer une nouvelle liste de contacts',
          edit_title: 'Modifier la liste de contacts',
          loading_contact_list: 'Chargement de la liste de contacts...',
          initializing: 'Initialisation...',
        },
        fields: {
          name: {
            label: 'Nom de la liste',
            required: 'Le nom de la liste est requis',
            min_length: 'Le nom de la liste doit contenir au moins 2 caractères',
          },
          from_name: {
            label: "Nom de l'expéditeur",
            required: "Le nom de l'expéditeur est requis",
            min_length: "Le nom de l'expéditeur doit contenir au moins 2 caractères",
          },
          priority: {
            label: 'Priorité',
            required: 'La priorité est requise',
            min: 'La priorité doit être au moins 1',
            max: 'La priorité ne peut pas dépasser 99',
            help: 'Les listes avec une priorité plus élevée sont affichées en premier (1-99)',
          },
          icon: {
            label: 'Icône',
            options: {
              email: 'E-mail',
              newsletter: 'Bulletin',
              announcement: 'Annonce',
              marketing: 'Marketing',
              notification: 'Notification',
              update: 'Mise à jour',
              promotion: 'Promotion',
              event: 'Événement',
              news: 'Actualités',
              alert: 'Alerte',
            },
          },
          frequency: {
            label: 'Fréquence',
            options: {
              daily: 'Quotidien',
              weekly: 'Hebdomadaire',
              bi_weekly: 'Bimensuel',
              monthly: 'Mensuel',
              quarterly: 'Trimestriel',
              as_needed: 'Au besoin',
              never: 'Jamais',
            },
          },
          toggles: {
            title: 'Paramètres de la liste',
          },
          anonymous: {
            label: 'Liste anonyme',
            help: "Permet aux utilisateurs de s'inscrire sans créer de compte ni se connecter",
          },
          display_on_signup: {
            label: "Afficher lors de l'inscription",
            help: "Affiche cette liste comme option lors de l'inscription des utilisateurs du site",
          },
          hide: {
            label: 'Masquer la liste',
            help: "Masque cette liste partout sauf dans l'administration",
          },
        },
        actions: {
          create: 'Créer la liste',
          update: 'Mettre à jour la liste',
          creating: 'Création…',
          updating: 'Mise à jour…',
          delete: {
            title: 'Supprimer la liste de contacts',
            warning:
              'Cette action ne peut pas être annulée. Tous les contacts seront retirés de cette liste.',
          },
        },
        notifications: {
          created: 'Liste de contacts créée avec succès',
          updated: 'Liste de contacts mise à jour avec succès',
          deleted: 'Liste de contacts supprimée avec succès',
        },
        errors: {
          no_account: 'Aucun ID de compte fourni',
          no_account_selected:
            "Aucun compte e-mail sélectionné. Veuillez d'abord sélectionner un compte.",
          not_found: 'Liste de contacts non trouvée',
          load_failed: 'Échec du chargement de la liste de contacts',
          create_failed: 'Échec de la création de la liste de contacts',
          update_failed: 'Échec de la mise à jour de la liste de contacts',
          delete_failed: 'Échec de la suppression de la liste de contacts',
          missing_ids: 'IDs requis manquants',
          name_max_length: 'Utilisez {{max}} caractères ou moins',
          unknown: "Une erreur inconnue s'est produite",
        },
        table: {
          name: 'Nom de la liste',
          contacts: 'Contacts',
        },
      },
      message_modal: {
        header: {
          message_details: 'Détails du message',
          loading_message: 'Chargement du message...',
          no_subject: '(Aucun sujet)',
        },
        status: {
          not_sent: 'Non envoyé',
          invalid_date: 'Date invalide',
        },
        status_labels: {
          sent: 'Envoyé',
          completed: 'Terminé',
          delivered: 'Livré',
          active: 'Actif',
          queued: "En file d'attente",
          processing: 'En cours de traitement',
          bounced: 'Rebondi',
          failed: 'Échec',
          error: 'Erreur',
          spam: 'Spam',
          blocked: 'Bloqué',
        },
        metrics: {
          title: 'Métriques de performance',
          sent: 'Envoyé',
          opens: 'Ouvertures',
          clicks: 'Clics',
          forwards: 'Transferts',
          bounces: 'Rebonds',
          spam: 'Spam',
        },
        links: {
          title: 'Liens suivis',
          total: 'total',
          url_header: 'URL',
          clicks_header: 'Clics',
          no_tracked_links: 'Aucun lien suivi',
        },
        technical: {
          title: 'Détails techniques',
          uuid: 'UUID',
          campaign_id: 'ID de campagne',
          external_id: 'ID externe',
          no_value: '—',
        },
        loading: 'Chargement...',
        error: {
          failed_to_load: 'Échec du chargement du message',
          missing_account_id: 'ID de compte ou de message manquant',
          message_not_found: 'Message non trouvé',
        },
      },
      messages: {
        search: {
          label: 'Rechercher un message spécifique...',
        },
        filter: {
          label: 'Filtrer par',
          placeholder: 'Sélectionner le type',
          all_types: 'Tous les types',
          list: 'Liste',
          segment: 'Segment',
          list_type_label: 'Type de liste',
          campaign_type_label: 'Type de campagne',
          select_list_or_segment: 'Sélectionner liste/segment',
          scheduled: 'Planifié',
          single_run: 'Exécution unique',
          unnamed_list: 'Liste sans nom',
          unnamed_segment: 'Segment sans nom',
          unknown: "Une erreur inconnue s'est produite",
          fetch_lists: 'Échec de la récupération des listes de contacts',
          invalid_account: 'Compte sélectionné invalide',
        },
        table: {
          title: 'Titre',
          status: 'Statut',
          sent_date: "Date d'envoi",
          name: 'Nom de la liste',
          contacts: 'Contacts',
          frequency: 'Fréquence',
          last_updated: 'Dernière mise à jour',
          actions: 'Actions',
        },
        status: {
          active: 'Actif',
          inactive: 'Inactif',
          hidden: 'Masqué',
          anonymous: 'Anonyme',
        },
        loading: {
          lists: 'Chargement des listes de contacts...',
          more: 'Chargement de plus de listes...',
          account: 'Chargement des données du compte...',
        },
        empty: {
          title: 'Aucune liste de contacts',
          description: 'Créez votre première liste de contacts pour commencer',
          create_button: 'Créer une liste de contacts',
        },
        pagination: {
          showing: 'Affichage {{start}} - {{end}} de {{total}} listes',
          load_more: 'Charger plus',
          next_page: 'Page suivante',
          previous_page: 'Page précédente',
        },
      },
      campaign: {
        pre_search: {
          filter_label: 'Audience',
          all_campaigns: 'Toutes les campagnes',
          active_filter: 'Filtre actif',
          loading_more: 'Chargement en cours...',
          scroll_for_more: 'Faites défiler pour en voir plus',
        },
        modal: {
          create_title: 'Créer une campagne',
          edit_title: 'Modifier la campagne',
        },
        table: {
          active: 'Actif',
          schedule: 'Horaire',
          title: 'Titre',
          subject: "Objet de l'e-mail",
        },
        mini_menu: {
          duplicate: 'Dupliquer',
          edit: 'Modifier',
        },
        logs: {
          action: 'Voir les journaux',
          title: 'Journaux de la campagne',
          log_date: 'Date du journal',
          loading_more: 'Chargement...',
          no_results: 'Aucun journal trouvé pour cette campagne.',
          unavailable:
            'Les journaux sont indisponibles ou ont expiré pour cette campagne.',
          column: {
            time: 'Heure',
            status: 'Statut',
            driver: 'Pilote',
            message: 'Message',
          },
          target_status: {
            success: 'Réussi',
            failed: 'Erreur',
            warning: 'Avertissement',
            info: 'Info',
            unknown: 'Inconnu',
          },
          error: {
            failed_to_load: 'Échec du chargement des journaux de la campagne.',
            missing_params: 'Informations de campagne manquantes.',
          },
        },
        steps: {
          type: {
            label: 'Type de campagne',
            title: 'Sélectionnez le type de campagne',
            required: 'Veuillez sélectionner un type de campagne',
          },
          details: {
            label: 'Détails',
            title: 'Détails de la campagne',
          },
          schedule: {
            label: 'Planification',
            title: 'Configuration de la planification',
          },
          recurrence: {
            label: 'Récurrence',
            title: 'Configuration de la récurrence',
          },
          review: {
            label: 'Relecture',
            title: 'Revoir la campagne',
          },
        },
        types: {
          single: {
            title: 'Campagne ponctuelle',
            description:
              'Une campagne ponctuelle délivre un message ciblé unique pour favoriser un engagement immédiat.',
          },
          scheduled: {
            title: 'Campagne planifiée',
            description:
              'Une campagne planifiée automatise une série d’e-mails pour un engagement durable.',
          },
          single_run: 'campagne ponctuelle',
          campaign: 'campagne',
        },
        fields: {
          type: {
            label: 'Type de campagne',
          },
          audience: {
            label: 'Sélectionner une audience',
            help: 'Choisissez si vous souhaitez envoyer à une liste de contacts spécifique ou à un segment dynamique',
            required: 'Veuillez sélectionner une audience',
            type_required: 'Veuillez sélectionner un type d’audience',
            select: 'Sélectionner {{type}}',
            all_loaded: 'Toutes les {{type}} sont chargées',
          },
          title: {
            label: 'Titre de la campagne',
            required: 'Le titre de la campagne est requis',
          },
          url: {
            label: 'URL de la campagne',
            help: 'URL de la page de destination vers laquelle les destinataires seront dirigés',
            required: 'L’URL est requise',
            invalid: 'Veuillez saisir une URL valide commençant par http:// ou https://',
            placeholder: 'https://www.exemple.com/page-destination',
          },
          custom_subject: {
            label: 'Utiliser un objet personnalisé',
            help: 'Remplacez la ligne d’objet par défaut par un objet personnalisé',
          },
          subject: {
            label: 'Objet de l’e-mail',
            required: 'L’objet personnalisé est requis',
          },
          disable: {
            label: 'Désactiver la campagne',
            help: 'Créer la campagne à l’état désactivé. Vous pourrez l’activer plus tard.',
          },
          schedule_type: {
            label: 'Type de planification',
            help: 'Choisissez la fréquence d’exécution de la campagne',
            required: 'Veuillez sélectionner un type de planification',
          },
          start_date: {
            label: 'Date de début',
            required: 'La date de début est requise',
            future: 'La date de début ne peut pas être dans le passé',
          },
          send_time: {
            label: 'Heure d’envoi',
            required: 'L’heure d’envoi est requise',
          },
          run_indefinitely: {
            label: 'Exécuter indéfiniment',
            help: 'La campagne continuera jusqu’à ce qu’elle soit arrêtée manuellement',
          },
          end_date: {
            label: 'Date de fin',
            required: 'La date de fin est requise',
            after_start: 'La date de fin doit être postérieure à la date de début',
          },
          interval: {
            label: 'Intervalle de récurrence',
            required: 'L’intervalle est obligatoire',
            recur_every: 'Répéter tous les',
            week: 'semaine',
            weeks: 'semaines',
            min: 'L’intervalle doit être d’au moins 1 semaine',
            max: 'L’intervalle ne peut pas dépasser 52 semaines',
          },
          days_of_week: {
            label: 'Jours de la semaine',
            help: 'Sélectionnez les jours d’envoi de la campagne',
            required: 'Veuillez sélectionner au moins un jour',
          },
          monthly_type: {
            label: 'Type de récurrence mensuelle',
            required: 'Veuillez sélectionner un type de récurrence',
            specific_date: 'Date précise chaque mois',
            specific_weekday: 'Jour précis de la semaine chaque mois',
          },
          day_of_month: {
            label: 'Jour du mois',
            required: 'Le jour du mois est requis',
            range: 'Le jour doit être compris entre 1 et 31',
          },
          occurrence: {
            label: 'Occurrence',
            required: 'L’occurrence est requise',
            select: 'Sélectionner une occurrence',
          },
          weekday: {
            label: 'Jour de la semaine',
            required: 'Le jour de la semaine est requis',
            select: 'Sélectionner le jour',
          },
          timezone_notice:
            'Tous les horaires sont dans le fuseau horaire de votre site ({{timezone}}).',
          timezone_utc: "L'heure d'envoi sélectionnée est {{utcTime}} UTC.",
        },
        recurrence: {
          description:
            'Choisissez la fréquence de répétition de la campagne et les jours d’envoi.',
          frequency_label: 'Fréquence',
          frequency_options: {
            weekly: 'Chaque semaine',
            biweekly: 'Toutes les deux semaines',
            every_four_weeks: 'Toutes les quatre semaines',
          },
          custom_label: 'Personnalisé',
          custom_every_prefix: 'Toutes les',
          week_singular: 'semaine',
          week_plural: 'semaines',
          days_heading: 'Jours d’envoi',
          days_presets: {
            weekdays: 'Jours ouvrés',
            weekends: 'Week-end',
            mwf: 'Lun., Mer., Ven.',
            tth: 'Mar. & Jeu.',
          },
          monthly_heading: 'Planification mensuelle',
          monthly: {
            options: {
              specific_date: {
                title: 'Date précise',
                description: 'Par exemple, le 15 de chaque mois',
              },
              specific_weekday: {
                title: 'Jour précis de la semaine',
                description: 'Par exemple, le premier lundi du mois',
              },
            },
            select_day: 'Sélectionnez le jour',
            day_option: 'Jour {{day}}',
            last_day: 'Dernier jour',
            custom_input_label: 'Jour du mois :',
            configure_weekday: 'Configurer le jour de la semaine',
            weekday_occurrence_prompt: 'Quelle occurrence ?',
            weekday_day_prompt: 'Quel jour ?',
          },
        },
        sections: {
          information: 'Informations sur la campagne',
          time_duration: 'Planifier l’horaire et la durée',
        },
        audience: {
          contact_list: 'Liste de contacts',
          segment: 'Segment',
          lists: 'listes',
          segments: 'segments',
        },
        schedule: {
          weekly: 'Hebdomadaire',
          monthly: 'Mensuel',
        },
        schedule_preview: {
          upcoming: 'Prochains envois',
          summary_label: 'Planification :',
        },
        schedule_details: {
          single: {
            summary: 'Planifié comme un envoi unique.',
            detail: 'Cette campagne sera envoyée une seule fois à la date prévue.',
          },
          incomplete: {
            summary: 'Complétez la planification pour afficher un résumé.',
          },
          weekly: {
            summary_every_week: 'Se répète chaque semaine.',
            summary_every_interval: 'Se répète toutes les {{interval}} semaines.',
            days_label: 'Jours d’envoi',
          },
          monthly: {
            summary_specific_date: 'Se répète le jour {{day}} de chaque mois.',
            day_label: 'Jour du mois',
            warning_short_months:
              'Les mois comportant moins de {{day}} jours seront ignorés.',
            summary_specific_weekday:
              'Se répète le {{occurrence}} {{day}} de chaque mois.',
            weekday_label: 'Envoi mensuel',
          },
          time_label: 'Heure d’envoi',
          not_set: 'Non défini',
          start_label: 'Date de début',
          end_label: 'Date de fin',
          duration_label: 'Durée',
          run_indefinitely: 'En continu',
        },
        occurrence: {
          first: 'premier',
          second: 'deuxième',
          third: 'troisième',
          fourth: 'quatrième',
          last: 'dernier',
        },
        occurrence_short: {
          first: '1er',
          second: '2e',
          third: '3e',
          fourth: '4e',
          last: 'Dernier',
        },
        review: {
          campaign_type: 'Type de campagne',
          audience: 'Audience',
          details: 'Détails de la campagne',
          schedule: 'Planification',
          disabled_state: 'La campagne sera créée à l’état désactivé',
          ready_message: {
            create_scheduled:
              'Votre campagne est prête ! Cliquez sur « Créer une campagne » pour continuer.',
            create_single:
              'Votre campagne ponctuelle est prête à être envoyée ! Cliquez sur « Créer une campagne ponctuelle » pour continuer.',
            edit: 'Vérifiez vos modifications puis cliquez sur « Mettre à jour la campagne » pour enregistrer.',
          },
        },
        actions: {
          creating: 'Création en cours...',
          create_single_run: 'Créer une campagne ponctuelle',
          create_campaign: 'Créer une campagne',
          update_campaign: 'Mettre à jour la campagne',
          updating: 'Mise à jour...',
          back_to_review: 'Retour à la relecture',
        },
        notifications: {
          created: '{{type}} créée avec succès !',
          updated: 'Campagne mise à jour avec succès !',
          load_failed: 'Échec du chargement de la campagne',
          update_failed: 'Échec de la mise à jour de {{type}}',
          duplicate_expired_dates:
            'Les dates de la campagne originale ont expiré. Veuillez mettre à jour les dates de début et de fin.',
        },
        errors: {
          no_account: 'Aucun compte sélectionné',
          not_found: 'Campagne introuvable',
          create_failed: 'Échec de la création de {{type}}',
          update_failed: 'Échec de la mise à jour de {{type}}',
          load_failed: 'Échec du chargement de la campagne',
        },
        loading: 'Chargement de la campagne...',
        loading_description: 'Préparation des détails de votre campagne...',
      },

      // Reauthentication
      reauth: {
        success_notification: 'Reconnecté à {{vendor}} avec succès !',
        error_start_login: 'Échec du démarrage de la connexion. Veuillez réessayer.',
        success_message: 'Compte reconnecté avec succès !',
        error_message:
          'Un problème est survenu lors de la reconnexion de votre compte. Veuillez réessayer.',
        prompt_message:
          'Votre session {{vendor}} a expiré. Veuillez vous reconnecter pour continuer.',
        success_title: 'Connexion rétablie',
        success_description: 'Votre compte {{vendor}} a été reconnecté avec succès.',
        redirect_message: 'Redirection vers {{vendor}}...',
        warning_verify_account:
          'Veuillez vérifier que vous vous connectez au bon compte {{vendor}}.',
        loading_provider: 'Chargement des informations du fournisseur...',
        done_button: 'Terminé',
      },

      // Widget de la vue utilisateur
      user_widget: {
        title: 'Listes de newsletters',
        add_button: 'Ajouter',
        save_button: 'Enregistrer',
        saving_button: 'Enregistrement...',
        cancel_button: 'Annuler',
        unsubscribe_all_button: "Désinscrire l'utilisateur globalement",
        unsubscribing_button: 'Désinscription en cours...',
        remove_button: 'Retirer',
        email_newsletter_list_header: 'Liste de newsletters par e-mail',
        newsletter_subscriptions_header: 'Abonnements aux newsletters',
        account_label: 'Compte',
        email_reach_lists_label: 'Listes Email Reach',
        select_lists_help:
          'Sélectionnez les listes de newsletters pour {{email}}. Faites défiler pour charger plus de listes.',
        all_lists_loaded: 'Toutes les listes disponibles sont chargées.',
        newsletter_actions_aria: 'Actions de newsletter pour {{listName}}',
        remove_from_list: 'Retirer de {{listName}}',
        list_fallback: 'la liste',
        untitled_list: 'Liste sans titre',
        empty: {
          requires_permission: 'Nécessite {{permission}}.',
          no_account: "Aucun compte Email Reach n'est configuré.",
          setup_cta: 'Configurer Email Reach',
          no_email: "Cet utilisateur n'a pas d'adresse e-mail.",
          globally_unsubscribed: 'Ce contact est désabonné globalement.',
          no_lists_available: "Aucune liste de newsletters Email Reach n'est disponible.",
          unsubscribed_from_all:
            'Ce contact est désabonné de toutes les newsletters Email Reach.',
          no_subscriptions: 'Aucun abonnement à une newsletter disponible.',
        },
        unsubscribe_all_modal: {
          title: "Désinscrire l'utilisateur globalement ?",
          description:
            'Cela désabonnera globalement {{email}} des e-mails Email Reach pour cet expéditeur.',
          warning:
            "Cet utilisateur aura le statut désabonné et ne pourra plus recevoir d'e-mails de cet expéditeur. Cette action ne peut pas être annulée depuis la section Contacts de NXT, et les utilisateurs devront confirmer par e-mail pour redevenir abonnés.",
          acknowledgement:
            'Je comprends que ce contact ne peut pas être réabonné depuis cette interface.',
        },
        notifications: {
          subscriptions_updated: 'Abonnements aux newsletters mis à jour.',
          subscriptions_update_failed:
            'Échec de la mise à jour des abonnements aux newsletters.',
          create_contact_failed: 'Échec de la création du contact Email Reach.',
          unsubscribed_all: 'Contact désabonné de toutes les newsletters Email Reach.',
          unsubscribe_failed: 'Échec du désabonnement du contact.',
          cannot_resubscribe:
            'Ce contact est désabonné globalement et ne peut pas être réabonné ici.',
        },
      },
    },
    modal: {
      confirmClose: 'Confirmer la fermeture',
      confirmClosePrimary: 'Êtes-vous sûr de vouloir fermer ?',
      confirmCloseSecondary:
        'Cette action annulera toutes les modifications non enregistrées !',
      cancelCloseBtn: 'Annuler',
      confirmCloseBtn: 'Oui, fermer',
      prompt_delete: 'Êtes-vous sûr de vouloir supprimer: {{name}}?',
      prompt_delete_basic: 'Êtes-vous sûr de vouloir supprimer cet élément?',
      no_undo: 'Cette action ne peut pas être annulée.',
      confirm_close: {
        header: 'Confirmer la fermeture',
        title: 'Êtes-vous sûr de vouloir fermer ?',
        description: 'Cette action annulera toutes les modifications non enregistrées !',
        cancel: 'Annuler',
        confirm: 'Oui, fermer',
      },
      confirm_delete: {
        header: 'Confirmer la suppression',
        title: 'Êtes-vous sûr de vouloir supprimer ?',
        description: 'Cette action est irréversible.',
        pre_confirm: 'Veuillez saisir',
        post_confirm: 'ci-dessous pour autoriser la suppression.',
        input_label: 'Confirmation',
        cancel: 'Annuler',
        confirm: 'Oui, supprimer',
      },
      simple_confirm: {
        header: 'Confirmer',
        title: 'Êtes-vous sûr ?',
        description: '',
        cancel: 'Annuler',
        confirm: 'Confirmer',
      },
      simple_confirm_delete: {
        header: 'Confirmer la suppression',
        title: 'Êtes-vous sûr de vouloir supprimer ?',
        description: 'Tous les éléments sélectionnés seront supprimés.',
        cancel: 'Annuler',
        confirm: 'Oui, supprimer',
        purge: {
          header: 'Confirmer la suppression définitive',
          title: 'Êtes-vous sûr de vouloir supprimer définitivement ?',
          description:
            "Cette action est irréversible. L'élément sélectionné, {{name}}, sera définitivement supprimé.",
          cancel: 'Annuler',
          confirm: 'Oui, supprimer définitivement',
        },
        undo_deletion: {
          header: 'Confirmer la restauration',
          title: 'Êtes-vous sûr de vouloir restaurer cet élément ?',
          description: "L'élément sélectionné, {{name}}, sera restauré.",
          description_multiple: '{{count}} éléments sélectionnés seront restaurés',
          cancel: 'Annuler',
          confirm: 'Oui, restaurer',
        },
      },
    },
    nav_builder: {
      header: 'Modifier la région de navigation "{{navRegionKey}}"',
      edit_navigation: 'Modifier la navigation',
      no_regions_found: 'Aucune région de navigation trouvée.',
      region_type_tab: 'Type de région',
      navigation_items_tab: 'Éléments de navigation',
      custom_item: 'Élément blanc',
      url_map_link: "Lien de carte d'URL",
      empty_state:
        'Aucun élément de navigation pour le moment. Cliquez sur Ajouter pour créer des éléments.',
      edit_navigation_item: "Modifier l'élément de navigation",
      save_success: 'Navigation enregistrée avec succès',
      save_error: "Erreur lors de l'enregistrement de la navigation",
      autofill_selector: {
        placeholder: "Sélectionner l'URL de la carte",
        error: 'Veuillez sélectionner une URL de la carte',
        manage_exclusions: 'Gérer les URL exclues ({{count}})',
      },
      exclusions: {
        header: 'Exclusions de remplissage automatique',
        empty_state: 'Aucune exclusion ajoutée pour le moment.',
      },
      title: {
        label: 'Titre',
        error: 'Le titre est obligatoire',
      },
      link: {
        label: 'Lien',
        url_map_node: "Lien vers le nœud de la carte d'URL",
        custom_url: 'Lien vers une URL personnalisée',
        none: 'Ne lier à rien',
        placeholder_select: "Sélectionner l'URL de la carte",
        placeholder_enter: "Entrer l'URL",
      },
      children: {
        label: 'Enfants',
        manual: 'Créer des enfants manuellement (en utilisant le menu Ajouter)',
        autofill: "Remplir automatiquement les enfants à partir de la carte d'URL",
      },
      region_types: {
        inherit: {
          label: "Hériter de la navigation de l'URL parent",
          description:
            'Cette région utilisera les éléments de navigation définis ou hérités par une région portant le même nom sur une URL parent.',
        },
        define: {
          label: 'Définir une nouvelle navigation à cette URL',
          description:
            'Définissez de nouveaux éléments de navigation pour cette région. Les régions portant le même nom sur les URL enfants hériteront de ceux-ci.',
        },
        autofill: {
          label: "Remplir automatiquement la navigation à partir de la carte d'URL",
          description:
            "La région sera automatiquement remplie avec les descendants de l'URL sélectionnée.",
        },
        blank: {
          label: "N'afficher aucune navigation à cette URL",
          description:
            "Définir cela comme vide garantit que la région n'apparaîtra pas. Les régions portant le même nom sur les URL enfants hériteront de cet état vide.",
        },
      },
      region_metadata_labels: {
        inherited_from: 'Hérité de {{sourcePath}}',
        autofilled_from: 'Rempli automatiquement à partir de {{sourcePath}}',
        blank_display: 'Ne pas afficher',
      },
    },
    site_selector: {
      // Site Selector and NoCosmosPermissions
      no_permissions: 'Pas d’autorisations',
      message: 'Ce site ou compte ne participe actuellement pas à BLOX NXT Admin.',
      contact:
        'Veuillez essayer un autre site ou contacter un’administrateur pour plus d’informations.',
      list_error:
        'Désolé, une erreur est survenue lors de la récupération des données de la liste des sites.',
      default_error:
        'Désolé, une erreur est survenue lors de la récupération des données du site par défaut.',
      redirected_to_1: 'Vous avez été redirigé vers:',
      redirected_to_2: 'car vous n’aviez pas accès à',
      switch_default_domain:
        'Passez à un autre site pour changer votre site de connexion par défaut.',
      enable_login_default:
        'Activez pour définir le site actuel comme votre site de connexion par défaut.',
      on_current_site: 'Vous êtes actuellement sur ce site.',
      active_site: {
        label: 'Site actif',
        placeholder: 'Filtrer la liste des sites...',
      },
    },
    common: {
      days: {
        short: {
          sun: 'Dim',
          mon: 'Lun',
          tue: 'Mar',
          wed: 'Mer',
          thu: 'Jeu',
          fri: 'Ven',
          sat: 'Sam',
        },
        full: {
          sunday: 'Dimanche',
          monday: 'Lundi',
          tuesday: 'Mardi',
          wednesday: 'Mercredi',
          thursday: 'Jeudi',
          friday: 'Vendredi',
          saturday: 'Samedi',
        },
      },
      address_suggestions: {
        searching: "Recherche d'adresses...",
        empty_prompt: 'Tapez pour commencer à rechercher des adresses',
      },
    },
    general: {
      anywhere: 'Partout',
      asset_types: {
        article: 'Article',
        image: 'Image',
        collection: 'Collection',
        audio: 'Audio',
        file: 'Fichier',
        flash: 'Flash',
        html: 'HTML',
        link: 'Lien',
        pdf: 'PDF',
        poll: 'Sondage',
        table: 'Tableau',
        video: 'Vidéo',
        youtube: 'YouTube',
        zip: 'ZIP',
      },
      aspect_ratio: 'Format d’image',
      please_be_aware: 'Veuillez prendre connaissance des points suivants.',
      no_access: "Désolé, vous n'avez pas accès à cette fonctionnalité.",
      no_options: "Désolé, aucune option n'est disponible.",
      contact_us: 'Contactez-nous',
      contact_blox: "Contactez-nous pour plus d'informations.",
      any: 'Tous',
      auto: 'Automatique',
      appearance: 'Apparence',
      asset: 'Ressource',
      assets: 'Ressources',
      block: 'Bloc',
      blocks: 'Blocs',
      blox: 'BLOX',
      beta: 'Bêta',
      beta_feature: 'Cette fonctionnalité est actuellement en version bêta.',
      canceled_by_user: 'Annulé par l’utilisateur',
      canceled: 'Annulé',
      characters: 'caractères',
      close_without_applying: 'Fermer sans appliquer',
      coming_soon: 'Bientôt disponible',
      comments: 'Commentaires',
      created: 'créé',
      configuration: 'Configuration',
      contact_sales: 'Contacter les ventes',
      contributed: 'Contribué',
      default: 'Par défaut',
      disabled: 'Désactivé',
      count_selected: '{{count}} sélectionné',
      show_count_results: 'Affichage de {{count}} résultat',
      count_total: '{{count}} au total',
      count_results: '{{count}} résultats',
      count_results_one: '{{count}} résultat',
      count_results_other: '{{count}} résultats',
      will_delete_one: '{{count}} élément sera supprimé.',
      will_delete: '{{count}} éléments seront supprimés.',
      collaborators: 'Collaborateurs',
      current: 'Actuel',
      disconnected: 'Déconnecté',
      no_results: 'Aucun résultat',
      search_text_disabled_placeholder: 'Recherche de texte désactivée...',
      flags: 'Indicateurs',
      date: {
        label: 'Date',
        start_date: 'Date de début',
        end_date: 'Date de fin',
        range: {
          custom: 'Plage de dates personnalisée',
          week: '7 derniers jours',
          month: '30 derniers jours',
          year: 'Année dernière',
          select: 'Sélectionner une plage de dates',
        },
      },
      date_range: {
        select: 'Sélectionner une plage de dates',
        invalid_input: 'Entrée non valide.',
        range_invalid:
          'Plage non valide : la date de fin est antérieure à la date de début.',
        start_prefix: 'Début : {{date}}',
        end_prefix: 'Fin : {{date}}',
        clear_input: "Effacer l'entrée",
        help_text:
          'Ce champ prend en charge les formats de date relatifs et absolus, tels que les exemples ci-dessous.',
        presets: {
          today: "Aujourd'hui",
          yesterday: 'Hier',
          tomorrow: 'Demain',
          last_30_days: '30 derniers jours',
          next_30_days: '30 prochains jours',
        },
        examples: {
          standard_textual: 'Dates textuelles standard',
          american_mdy: 'Mois/jour/année américain',
          month_and_year: 'Mois et année',
          start_of_today: "Début d'aujourd'hui",
          start_of_next_monday: 'Début du lundi prochain',
          days_ago: 'Il y a 7 jours',
          weeks_from_now: 'Dans 2 semaines',
        },
      },
      deleted: 'Supprimé',
      description: 'Description',
      end_of_results: 'Fin des résultats',
      entry: 'Entrée',
      enter_type: 'Entrez {{type}}',
      enter_a_type: 'Entrez un {{type}}',
      no_entries: 'Aucune entrée',
      no_fields_configured: 'Aucun champ configuré',
      items: 'Articles',
      design: 'Conception',
      display: 'Affichage',
      error: 'Erreur',
      filter: 'Filtrer',
      filters: 'Filtres',
      import_mode: 'Mode d’importation',
      import: 'Importer',
      invalid_url_help: 'URL non valide ou doit commencer par http:// ou https://',
      export: 'Exporter',
      export_mode: 'Mode d’exportation',
      include_children: 'Inclure les enfants',
      edit_not_supported: 'La modification de {{type}} n’est pas prise en charge',
      importing: 'Importation',
      label: 'Étiquette',
      loading: 'Chargement...',
      initializing: 'Initialisation...',
      login: 'Connexion',
      more: 'Plus',
      name: 'Nom',
      new: 'Nouveau',
      no: 'Non',
      no_selections: 'Aucune sélection',
      none: 'Aucun',
      preview: 'Aperçu',
      primary: 'Principal',
      live: 'En direct',
      live_view: 'Vue en direct',
      group: 'Groupe',
      no_preview: 'Aperçu non disponible',
      no_more_results: 'Aucun résultat supplémentaire',
      no_results_found: 'Aucun résultat trouvé',
      off: 'Désactivé',
      on: 'Activé',
      options: 'Options',
      origin: 'Origine',
      original: 'Original',
      permission_required: 'Permission requise',
      placed_on_page: 'Placé sur la page',
      provide_url: 'Fournir une URL',
      publications: 'Publications',
      processing: 'Traitement',
      privacy: 'Confidentialité',
      private: 'Privé',
      range: 'Plage',
      readonly: 'Lecture seule',
      relationships: 'Relations',
      required: 'Requis',
      retry: 'Réessayer',
      results_of_total_one: 'Affichage de {{results}} sur {{count}} résultat',
      results_of_total_other: 'Affichage de {{results}} sur {{count}} résultats',
      save_success: 'Enregistrement réussi',
      search: 'Rechercher',
      searchEllipsis: 'Rechercher...',
      search_groups: 'Rechercher des groupes...',
      search_url: 'Rechercher ou coller une URL',
      search_results: 'Résultats de recherche',
      select_date: 'Sélectionner la date',
      selected_assets: 'Éléments sélectionnés',
      selected: 'sélectionné',
      send_to_top: 'Envoyer en haut',
      set_as_origin: 'Définir comme origine',
      search_or_add: 'Rechercher ou ajouter',
      showing_total_results: 'Affichage de {{total}} résultats au total',
      no_results_press_enter_to_add:
        'Aucun résultat trouvé. Appuyez sur Entrée pour ajouter.',
      menu_of: 'Menu - {{label}}',
      remove_item: 'Supprimer {{label}}',
      remove_origin: 'Supprimer l’origine',
      settings: 'Paramètres',
      sessions: 'Sessions',
      showing: 'Affichage',
      status: 'Statut',
      status_primary: 'Statut principal',
      suggestion: 'Suggestion',
      ignore: 'Ignorer',
      shareable: 'Partageable',
      shared: 'Partagé',
      success: 'Succès',
      title: 'Titre',
      target: 'Cible',
      type: 'Type',
      test: 'Test',
      hidden: 'Caché',
      updated: 'mis à jour',
      untitled: 'Sans titre',
      use_url: 'Utiliser l’URL',
      update_required: 'Mise à jour requise',
      update_app_help:
        'Une nouvelle version de BLOX NXT est prête. Cliquez pour mettre à jour tous les onglets.',
      update_app_suggest:
        'Une nouvelle version de BLOX NXT est prête. Procédez à la mise à jour de tous les onglets, mais assurez-vous de sauvegarder toutes les modifications dans les onglets ouverts avant de continuer.',
      valid_hex: 'Entrez un hexadécimal valide (par exemple, #FF0000)',
      words: 'mots',
      yes: 'Oui',
      message: {
        label: 'Message',
        unexpectedError: "Une erreur inattendue s'est produite.",
        no_preview: 'Aucun aperçu disponible',
        oops: "Oups ! Quelque chose s'est mal passé",
      },
      noAccess: "Désolé, vous n'avez pas accès à cette fonctionnalité.",
      noAccessSimple: 'Accès requis',
      contactBlox: "Contactez-nous pour plus d'informations.",
      screenshot: "Créer une capture d'écran",
      capture_screenshot: "Capturer une capture d'écran",
      play_video_to_capture: "Lire la vidéo pour capturer une capture d'écran",
      screenshot_not_supported:
        "La capture d'écran n'est pas prise en charge pour cette vidéo",
      value_added_content: 'Contenu à valeur ajoutée',
      view_at_site: 'Voir sur le site',
    },
    error: {
      label: 'Erreur',
      invalid_form: 'Le formulaire est invalide. Veuillez corriger les erreurs.',
      unexpectedError: 'Une erreur inattendue s’est produite.',
      bad_request: 'Requête incorrecte',
      oops: 'Oups! Une erreur s’est produite',
      unknown: 'Erreur inconnue',
      sorry_try_again:
        "Désolé, une erreur inattendue s'est produite. Veuillez réessayer.",
      required: 'Requis',
      min: '{{field}} doit être au moins {{min}}',
      max: '{{field}} doit être au plus {{max}}',
      type_not_accepted: "Ce type de fichier n'est pas accepté.",
      only_one_file: 'Un seul fichier peut être fourni à la fois.',
    },
    validation: {
      form_invalid: 'Le formulaire est invalide',
      form_invalid_long: 'Le formulaire est invalide, veuillez vérifier les erreurs.',
      value_invalid_generic: 'La valeur est invalide',
      value_must_be_array: 'La {{label}} doit être un tableau',
      value_required: '{{label}} est requis',
      value_count_required: '{{label}} doit avoir au moins {{count}} sélectionné',
      value_invalid: '{{label}} est invalide',
      value_incomplete: '{{label}} est incomplet',
      value_empty: '{{label}} ne peut pas être vide',
      value_too_long: '{{label}} est trop long',
      date_invalid: '{{label}} n’est pas une date valide',
      date_invalid_past: '{{label}} ne peut pas être dans le passé',
      date_invalid_future: '{{label}} ne peut pas être dans le futur',
      field_required: 'Ce champ est obligatoire',
      incomplete_form: 'Veuillez remplir tous les champs requis',
      email_invalid: "L'adresse e-mail n'est pas valide",
    },
    notifier: {
      label: 'Notificateur',
      disabled_create: 'Le notificateur est désactivé en mode création',
      disabled_import: 'Le notificateur est désactivé en mode importation',
      disabled_mode: 'Le notificateur est désactivé dans ce mode',
      draft_asset_disabled:
        'Les ressources en statut brouillon ne peuvent pas être planifiées',
      no_posts_found: 'Aucune publication trouvée',
      no_channels_found: 'Aucun canal trouvé',
      create_post: 'Créer une publication',
      notifier_post: 'Publication du notificateur',
      editing_post: 'Modification de la publication',
      viewing_post: 'Affichage de la publication',
      save_draft: 'Enregistrer le brouillon',
      schedule_post: 'Planifier la publication',
      scheduled_date_and_time: 'Date et heure prévues',
      channels: 'Canaux',
      channel_disabled: 'canal désactivé',
      message_published: 'Message publié',
      status_uneditable: '{{status}} les publications ne peuvent pas être modifiées',
      status_undeletable: '{{status}} les publications ne peuvent pas être supprimées',
      target_info: 'Sélectionnez une ressource ou fournissez une URL.',
      validation: {
        valid_target_required: 'Une ressource ou une URL valide est requise',
        publish_channels_required: 'Au moins un canal est requis pour publier',
        date_invalid_start_time:
          'La date doit être postérieure ou égale à la date de début des ressources',
        date_in_past_warning:
          'Avec la date définie dans le passé, la publication sera faite dès que possible.',
      },
      status: {
        draft: 'brouillon',
        canceled: 'annulé',
        failed: 'échoué',
        pending: 'en attente',
        sent: 'envoyé',
        staged: 'mis en scène',
        undelivered: 'non livré',
        partially_sent: 'partiellement envoyé',
        partially_sent_info: "Distribué sur certaines plateformes, échoué sur d'autres",
        unknown: 'inconnu',
      },
      logs: {
        action: 'Voir les journaux',
        title: 'Journaux de livraison',
        log_date: 'Date du journal',
        send_status: "Statut d'envoi",
        loading_more: 'Chargement...',
        no_results: 'Aucun journal de livraison trouvé pour cet envoi.',
        column: {
          time: 'Heure',
          status: 'Statut',
          driver: 'Pilote',
          message: 'Message',
        },
        target_status: {
          success: 'Réussi',
          failed: 'Échoué',
          warning: 'Avertissement',
          info: 'Info',
          unknown: 'Inconnu',
        },
        error: {
          failed_to_load: 'Échec du chargement des journaux de livraison.',
          missing_params: "Informations d'envoi manquantes.",
        },
      },
      search: {
        search_messages: 'Rechercher des messages...',
        asset_app: 'Application',
        domain: 'Domaine',
        target: 'Cible',
        message: 'Message',
        title: 'Titre',
        social_title: 'Titre social',
        social_summary: 'Résumé social',
        send_date: 'Date d’envoi',
        send_status: 'Statut',
        type: 'Type',
        channels: 'Canaux',
      },
      channel: {
        title: 'Canal',
        create_channel: 'Créer un canal',
        edit_channel: 'Modifier le canal',
        delete_channel: 'Supprimer le canal',
        channel_name: 'Nom du canal',
        general: 'Général',
        automatic_notification_rules: 'Règles de notification automatique',
        delivery_targets: 'Cibles de livraison',
        select_delivery_targets: 'Sélectionner les cibles de livraison',
        add_targets: 'Ajouter des cibles',
        manage_targets: 'Gérer les cibles',
        no_targets_selected: 'Aucune cible de livraison sélectionnée',
        enabled: 'Activé',
        disabled: 'Désactivé',
        all_systems_operational: 'Tous les systèmes opérationnels',
        auto_notification: 'Notification automatique',
        last_active: 'Dernière activité',
        automatic_notify: 'Notification automatique',
        last_used_days_ago: 'Dernière utilisation il y a {{days}} jours',
        last_used_months_ago: 'Dernière utilisation il y a {{months}} mois',
        never_used: 'Jamais utilisé',
        search_channels: 'Rechercher des canaux...',
        no_channels: 'Aucun canal trouvé',
        filter_message_id: 'Message',
        targets: {
          mobile_app: 'Application mobile',
          facebook: 'Facebook',
          webhook: 'Webhook',
          push_notification: 'Notification push',
        },
        rules: {
          title: 'Règles de notification automatique',
          create_rule: 'Créer une règle',
          edit_rule: 'Modifier la règle',
          delete_rule: 'Supprimer la règle',
          rule_type: 'Type de règle',
          asset_type: 'Type de ressource',
          asset_types_label: 'Types de ressources',
          flags: 'Indicateurs',
          keyword_tags: 'Mots-clés',
          section_tags: 'Tags de section',
          select_criteria: 'Sélectionner les critères',
          step_choose_type: 'Choisir le type de règle',
          step_select_criteria: 'Sélectionner les critères',
          step_save: 'Enregistrer la règle',
          no_rules: 'Aucune règle de notification automatique configurée',
          inclusion_rule: "Règle d'inclusion",
          rule_name: 'Nom de la règle (Facultatif)',
          rule_name_helper:
            'Donnez un nom descriptif à votre règle pour faciliter la gestion',
          selected_values: 'Valeurs sélectionnées',
          enter_keyword: 'Entrez un mot-clé',
          no_flags: 'Aucun indicateur disponible',
          no_sections: 'Aucune section disponible',
          review_rule: 'Vérifiez votre règle',
          select_type_desc:
            'Sélectionnez un type de règle pour déterminer comment les notifications sont déclenchées',
          suggestions: 'Suggestions',
        },
        confirm_delete: 'Êtes-vous sûr de vouloir supprimer ce canal ?',
        channel_created: 'Canal créé avec succès',
        channel_updated: 'Canal mis à jour avec succès',
        channel_deleted: 'Canal supprimé avec succès',
      },
      channel_grid: {
        name: 'Nom',
        delivery_targets: 'Cibles de livraison',
        auto_notification_rules: 'Règles de notification automatique',
      },
      settings: {
        title: 'Paramètres du notificateur',
        social_accounts: {
          title: 'Comptes sociaux',
          description: 'Gérer les comptes de réseaux sociaux pour le notificateur.',
          disconnect: 'Déconnecter',
          disconnect_confirm: 'Êtes-vous sûr de vouloir déconnecter ce compte ?',
          no_accounts: 'Aucun compte social trouvé.',
          platform: 'Plateforme',
          account_name: 'Nom du compte',
          actions: 'Actions',
          account_disconnected: 'Compte social déconnecté avec succès.',
          error_disconnect: 'Échec de la déconnexion du compte social.',
          error_loading: 'Échec du chargement des comptes sociaux.',
          account_count: '{{count}} connecté',
          account_count_plural: '{{count}} connectés',
          unknown_provider: 'Inconnu',
        },
        automatic_notifications: {
          title: 'Paramètres de notifications automatiques',
          description:
            'Activer ou désactiver les notifications automatiques pour les canaux du notificateur avec un décalage horaire.',
          enable_label: 'Activer les notifications automatiques',
          enable_description:
            "Lorsqu'elles sont activées, les notifications sont automatiquement envoyées pour les contenus éligibles.",
          disable_description:
            "Lorsqu'elles sont désactivées, les notifications doivent être déclenchées manuellement.",
          time_offset: 'Décalage horaire',
          time_offset_help: 'Définit la période de recherche des contenus éligibles.',
          time_offset_unit: {
            minutes: 'Minutes',
            hours: 'Heures',
          },
          time_offset_preview:
            'Les notifications rechercheront les contenus éligibles sur les {{value}} dernières {{unit}}.',
          save_success:
            'Paramètres de notifications automatiques enregistrés avec succès.',
          save_error:
            "Échec de l'enregistrement des paramètres de notifications automatiques.",
        },
      },
    },
    journeys: {
      // Journey (Access Criteria)
      journey: 'Parcours',
      update_journey: 'Mettre à jour le parcours',
      create_journey: 'Créer le parcours',
      delete_journey: 'Supprimer définitivement le parcours',
      // Offer Group
      offer_group: 'Groupe d’offres',
      create_offer_group: 'Créer un groupe d’offres',
      update_offer_group: 'Mettre à jour le groupe d’offres',
      edit_offer_group: 'Modifier le groupe d’offres',
      delete_offer_group: 'Supprimer définitivement le groupe d’offres',
      offer_group_name_info: "Un nom court pour identifier ce groupe d'offres",
      // Method Group
      method_group: 'Groupe de méthodes',
      method_group_id: 'ID du groupe de méthodes',
      new_method_group: 'Nouveau groupe de méthodes',
      create_method_group: 'Créer un groupe de méthodes',
      update_method_group: 'Mettre à jour le groupe de méthodes',
      edit_method_group: 'Modifier le groupe de méthodes',
      delete_method_group: 'Supprimer définitivement le groupe de méthodes',
      method_group_name_info: 'Un nom court pour identifier ce groupe de méthodes',
      // Connections Sidepanel - Method Target
      connections: 'Connexions',
      method_create_first:
        'Les informations seront affichées après la création du groupe de méthodes.',
      method_group_used: 'Ce groupe de méthodes est connecté à des parcours.',
      method_group_not_used: "Ce groupe de méthodes n'est connecté à aucun parcours.",
      // Connections Sidepanel - Rate Target
      rate_used: 'Ce groupe de tarifs est connecté à des parcours.',
      rate_not_used: "Ce groupe de tarifs n'est connecté à aucun parcours.",
      rate_create_first:
        'Les informations seront affichées après la création du groupe de tarifs.',

      // Method Group Labels
      method: 'Méthode',
      methods: 'Méthodes',
      wall_behavior: 'Comportement du mur',
      display_content: 'Afficher le contenu',
      hard_paywall_block: 'Blocage strict du contenu payant',
      hard_paywall_block_info:
        "L'utilisateur doit s'abonner ou effectuer l'action pour voir le contenu",
      nag_mode: 'Mode de relance',
      nag_mode_info:
        "L'utilisateur peut ignorer en cliquant sur le X, puis accéder au contenu",
      select_methods: 'Sélectionner les méthodes',
      customjavascript: 'JavaScript personnalisé',
      mailinglist: 'Inscription à la newsletter par e-mail',
      subscription: 'Abonnement',
      user_registration: "Inscription de l'utilisateur",
      free_access: 'Accès gratuit',
      meter: 'Compteur',
      // Access Criteria Labels
      criteria_name_desc: 'Nommez ce critère',
      appman_title: "Profil de l'application",
      archivetime_title: "Heure d'archivage",
      asseteditortoggle_title: "Basculer l'éditeur d'actifs",
      assetflag_title: 'Drapeau',
      customjs_title: 'JavaScript personnalisé',
      dmp_title: 'Audience DMP',
      gdpr_title: 'Pays RGPD',
      hostname_title: "Nom d'hôte",
      incognito_title: 'Navigateurs privés/incognito',
      ip_title: 'Adresse IP',
      keyword_title: 'Mots-clés',
      metatag_title: 'Balise méta',
      metercheck_title: 'Vérification du compteur',
      queryparams_title: 'Paramètres de requête',
      referrer_title: 'Référent',
      starttime_title: 'Heure de début',
      assettype_title: 'Type de ressource',
      subscriberstatus_title: "Statut de l'abonné",
      url_title: 'URL',
      urlpattern_title: "Modèle d'URL",
      user_title: "Connexion de l'utilisateur",
      useragent_title: 'Agent utilisateur',
      // Offer Group Preview
      offer_group_preview: 'Aperçu du groupe d’offres',
      offer_group_preview_empty:
        'Veuillez sélectionner un groupe d’offres pour générer un aperçu.',
      offer_group_preview_disabled:
        'L’aperçu est désactivé lors de la création de nouveaux groupes d’offres.',
      offer_group_preview_error:
        "Désolé, une erreur s'est produite lors de la génération de l'aperçu. Veuillez vérifier que le formulaire est valide et réessayer.",
      offer_group_refresh_preview:
        'Actualiser l’aperçu en utilisant les données actuelles du formulaire.',
      offer_group_please_validate:
        'Veuillez valider le formulaire avant de rafraîchir l’aperçu.',
    },
    components: {
      copy_button: {
        tooltip: {
          default: 'Copier dans le presse-papiers',
          success: 'Copié !',
          error: 'Échec de la copie',
        },
      },
    },
    navigation: {
      common: {
        divider: 'Séparateur',
        ariaOpen: '{{label}} ouvert',
        ariaClose: '{{label}} fermé',
      },
      beta_requires_program:
        'Cette fonctionnalité est actuellement en version bêta. Contactez le support si vous avez des questions.',
      settings: {
        label: 'Paramètres',
        general: 'Paramètres Généraux',
        appearance: "Paramètres d'Apparence",
        advanced: 'Paramètres Avancés',
        advanced_description:
          "Les paramètres avancés vous permettent d'accéder à des fonctionnalités expérimentales que nous testons actuellement. Ces fonctionnalités sont déployées isolément afin de recueillir des retours et d'affiner leur fonctionnement avant un déploiement plus large.",
      },
      root: {
        home: 'Accueil',
        boards: 'Tableaux',
        dashboards_management: 'Tableaux de Bord',
      },
      assets: {
        title: 'Gestion de Contenu',
        label: 'Ressources',
        all: 'Toutes les Ressources',
        articles: 'Articles',
        images: 'Images',
        videos: 'Vidéos',
        collections: 'Collections',
        templates: 'Modèles',
        dashboard: 'Tableau de Bord',
        video_dashboard: 'Lectures vidéo',
        advanced_filters: 'Filtres avancés',
        quick_filters: 'Filtres Rapides',
        standard_filters: 'Filtres standard',
        more_filters: 'Plus de filtres',
      },
      feeds: {
        label: 'Flux',
        all: 'Tous les Flux',
        channels: 'Chaînes',
      },
      user: {
        title: 'Communauté',
        contacts: 'Contacts',
        all_contacts: 'Tous les Contacts',
        admin_management: 'Gestion Admin',
        services: 'Services',
        all_services: 'Tous les Services',
        reports: 'Rapports',
        reports_dashboard: 'Activité des abonnements',
        journeys: 'Parcours',
        all_journeys: 'Tous les Parcours',
        transactions: 'Transactions',
        transactions_search: 'Toutes les transactions',
        email_reach: 'Portée Email',
        email_reach_search: 'Tous les Comptes',
        email_reach_contacts: 'Tous les Contacts',
        email_reach_lists: 'Listes de Contacts',
        email_reach_messages: 'Messages',
        multisite_search: 'Recherche multi-sites',
      },
      notifier: {
        title: 'Notificateur',
        messages: 'Messages',
        channels: 'Canaux',
        connections: 'Connexions',
        settings: 'Paramètres',
        social_accounts: 'Comptes sociaux',
        automatic_notifications: 'Notifications automatiques',
      },
      design: {
        title: 'Design',
        maps: 'Cartes',
      },
      reports: {
        domain_filter: {
          label: 'Domaines',
          placeholder: 'Sélectionnez des domaines',
          disabled_message: "L'offre Audience+ est requise pour modifier les domaines.",
          clear: 'Effacer les domaines',
        },
      },
    },
    service: bloxFrenchServiceMessages,
    services: bloxFrenchServiceMessages,
    video_field_input: {
      uploading_percentage: 'Téléchargement... {{percentage}}%',
      uploading_poster: "Téléchargement de l'affiche...",
      upload_success: 'Fichier téléchargé avec succès.',
      upload_unsuccessful: 'Échec du téléchargement du fichier.',
      transfer_success: 'Fichier transféré avec succès !',
      transfer_error: 'Erreur lors du transfert du fichier.',
      error: {
        wait_upload: 'Veuillez patienter, téléchargement du fichier en cours...',
        file_required: 'Veuillez joindre un fichier.',

        no_video: "Aucune vidéo trouvée pour capturer une capture d'écran",
        no_file_playback: 'Fichier non disponible pour la lecture',
        canvas_context: "Échec de l'obtention du contexte du canvas",
        screenshot_capture: "Échec de la capture d'écran",
        screenshot_upload: "Échec du téléchargement de la capture d'écran",
        poster_save: "Échec de l'enregistrement en tant qu'affiche",
        media_playback: {
          generic: "Une erreur inconnue s'est produite pendant la lecture du média.",
          aborted: 'La lecture du média a été interrompue.',
          network_error: 'Une erreur réseau a empêché le chargement correct du média.',
          decode_error:
            "La lecture du média a été interrompue en raison d'une erreur survenue lors du décodage de la ressource média.",
          format_converting:
            'Conversion de la vidéo au format web. Aperçu disponible prochainement.',
        },
      },
      screenshot: {
        preview: "Aperçu de la capture d'écran",
        captured: "Capture d'écran réussie",
        use_as_preview: 'Utiliser comme aperçu',
        use_as_poster: 'Utiliser comme affiche',
        discard: 'Supprimer',
        saved: "Capture d'écran enregistrée avec succès",
      },
      remote_url: {
        title: 'Ajouter une vidéo depuis une URL',
        description:
          "Entrez l'URL d'un fichier vidéo ou un code d'intégration d'un service pris en charge.",
      },
      play_to_capture: "Lancez la vidéo pour prendre une capture d'écran",
      not_supported: "La capture d'écran n'est pas prise en charge pour cette vidéo",
      trim_video: {
        label: 'Couper la vidéo',
        help: 'Couper la vidéo à une durée spécifique',
        description: 'Spécifiez les points de début et de fin pour couper la vidéo.',
        errors: {
          invalid_range:
            "Plage invalide : l'heure de début doit être antérieure à l'heure de fin.",
          out_of_bounds:
            'Hors limites : les temps doivent être compris dans la durée de la vidéo.',
          processing:
            'Erreur lors du traitement du nouveau clip vidéo. Veuillez réessayer.',
          unsupported_format: 'Format non pris en charge pour le découpage vidéo.',
          unknown: 'Une erreur inconnue est survenue lors du découpage de la vidéo.',
        },
        actions: {
          preview: {
            label: 'Aperçu de la coupe',
            tooltip: 'Aperçu de la vidéo coupée',
          },
          cancel: {
            label: 'Annuler la coupe',
            tooltip: 'Annule l’opération de coupe',
          },
          trim_new: {
            label: 'Couper & Nouveau',
            tooltip:
              'Crée une nouvelle vidéo avec la section coupée et duplique les métadonnées',
            success: 'Nouvelle vidéo coupée créée avec succès',
          },
          play: {
            label: 'Lire',
            tooltip: 'Lire la vidéo',
          },
          pause: {
            label: 'Pause',
            tooltip: 'Mettre la vidéo en pause',
          },
          reverse: {
            label: 'Reculer de 5 secondes',
            tooltip: 'Reculer la lecture de 5 secondes',
          },
          forward: {
            label: 'Avancer de 5 secondes',
            tooltip: 'Avancer la lecture de 5 secondes',
          },
        },
        details: {
          in: 'Début',
          out: 'Fin',
          duration: 'Durée',
          original_duration: 'Durée originale',
        },
      },
    },
    download_menu: {
      label: 'Téléchargements',
      title: 'Exportations',

      button: {
        tooltip: {
          all_ready: 'Exportations prêtes',
          of: 'sur',
          exports_ready: 'exportations prêtes',
          preparing: 'Préparation des exportations',
        },
      },

      empty: {
        message: 'Aucune exportation active disponible.',
      },

      export: {
        label: 'Exportation',
        status: {
          ready: 'Prêt à télécharger',
          processing: 'Traitement en cours…',
        },
      },

      actions: {
        download: 'Télécharger',
        delete: 'Supprimer',
        clear: 'Effacer',
        close: 'Fermer',
      },

      notifications: {
        download_started: 'Téléchargement commencé',
        download_failed: 'Échec du téléchargement',
        export_ready_suffix: 'exportation prête',
        export_cleared: 'Exportation effacée',
        export_processing: "L'exportation est encore en cours de traitement",
        export_not_found: 'Exportation introuvable ou expirée',
      },

      footer: {
        availability: 'Vos exportations seront disponibles pendant 24 heures.',
      },

      file: {
        prefix: 'blox',
        suffix: 'exportation',
      },
    },
    export_button: {
      label: 'Exporter',
      menu: {
        loading: "Chargement des options d'exportation...",
      },
      notifications: {
        export_started: 'Exportation démarrée',
        export_failed: "Échec du démarrage de l'exportation",
        export_unavailable: "Fonction d'exportation non disponible",
        load_options_failed: "Échec du chargement des options d'exportation",
      },
    },
    notification_return: {
      processing: 'Traitement de la notification, veuillez patienter...',
      loading: 'Chargement des détails de la notification...',
      preparing_download: 'Préparation de votre téléchargement...',
      downloading: 'Téléchargement en cours...',
      modal: {
        title: 'Téléchargement prêt',
        description:
          'Vérifiez les détails ci-dessus et cliquez sur Télécharger pour enregistrer le fichier sur votre appareil.',
      },
      success: {
        download_started: 'Votre téléchargement a commencé',
      },
      error: {
        fetch_failed:
          'Impossible de charger les détails de la notification. Veuillez réessayer.',
        unknown_action: "Cette action de notification n'est pas prise en charge.",
        missing_export_id:
          "La notification ne contient pas l'identifiant d'exportation requis.",
        download_failed:
          "Échec du téléchargement du fichier d'exportation. Veuillez réessayer.",
      },
    },
    notifications_panel: {
      title: 'Notifications',
      settings_title: 'Paramètres des notifications',
      mark_all_read: 'Tout marquer comme lu',
      filters: {
        all: 'Tous',
        unread: 'Non lus ({{count}})',
        read: 'Lus',
      },
      sections: {
        today: "Aujourd'hui",
        earlier: 'Plus tôt',
      },
      empty: 'Aucune notification',
      error: 'Échec du chargement des notifications',
      settings_placeholder: 'Contenu des paramètres à venir...',
    },
    welcome: {
      title: 'Bienvenue à ',
    },
  },
  wizard: {
    stepper: {
      currentStepToggle:
        'Étape actuelle : {{label}}. Cliquez pour {{action}} toutes les étapes',
      collapse: 'réduire',
      expand: 'développer',
      stepCounter: 'Étape {{current}} sur {{total}}',
      listLabel: 'Toutes les étapes',
      itemLabel: '{{label}}, étape {{current}} sur {{total}}',
      statusSuffix: ', {{status}}',
      status: {
        active: 'étape en cours',
        completed: 'terminée',
        disabled: 'désactivée',
        inactive: 'inactive',
      },
      iconLabel: 'Étape {{status}}',
      clickToGo: 'Cliquer pour accéder à cette étape',
      navigationLabel: 'Progression des étapes',
      regionLabel: 'Indicateur de progression des étapes',
    },
    confirmClose: {
      title: 'Confirmer la fermeture',
      content:
        'Vous avez des modifications non enregistrées. Voulez-vous vraiment fermer cet assistant ?',
      subtext:
        'La fermeture de l’assistant supprimera toutes les modifications non enregistrées.',
      confirm: 'Fermer l’assistant',
      cancel: 'Annuler',
    },
  },
};
